import * as React from "react";
import React__default, { useState, useRef, useCallback, Component, forwardRef, useMemo, useEffect, createContext, useLayoutEffect, useContext, useImperativeHandle, memo, Fragment, Suspense } from "react";
import classNames from "classnames";
import { useFloating, offset, autoPlacement, flip, shift, arrow, useHover, useFocus, useInteractions, FloatingArrow, FloatingPortal } from "@floating-ui/react";
import omit from "/home/runner/_work/Frontend/Frontend/node_modules/lodash-es/omit.js";
import { Slot, Slottable } from "@radix-ui/react-slot";
import ReactDOM, { createPortal } from "react-dom";
import { Manager, Reference, Popper } from "react-popper";
import Scrollbars from "react-custom-scrollbars-2";
import { useVirtual } from "react-virtual";
import { DotSpinner } from "@uiball/loaders";
import { cva } from "class-variance-authority";
import { ComboboxInput, Combobox as Combobox$2, ComboboxOption, ComboboxOptions, ComboboxButton } from "@headlessui/react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { Command as Command$1 } from "cmdk";
import * as SliderPrimitive from "@radix-ui/react-slider";
import * as HoverOverPrimitive from "@radix-ui/react-hover-card";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { useController } from "react-hook-form";
import { AnimatePresence, motion } from "framer-motion";
import { DateTime } from "luxon";
import isEqual from "/home/runner/_work/Frontend/Frontend/node_modules/lodash-es/isEqual.js";
import { useReactTable, getSortedRowModel, getExpandedRowModel, getCoreRowModel, flexRender } from "@tanstack/react-table";
import debounce from "/home/runner/_work/Frontend/Frontend/node_modules/lodash-es/debounce.js";
import throttle from "/home/runner/_work/Frontend/Frontend/node_modules/lodash-es/throttle.js";
const button$2 = "_button_1i7ex_9";
const disabled$6 = "_disabled_1i7ex_12";
const isActive$1 = "_isActive_1i7ex_23";
const selected$1 = "_selected_1i7ex_85";
const combined = "_combined_1i7ex_245";
const isLoading = "_isLoading_1i7ex_336";
const loadingMarkup = "_loadingMarkup_1i7ex_339";
const styles$z = {
  button: button$2,
  disabled: disabled$6,
  "variant-default": "_variant-default_1i7ex_15",
  "priority-xlow": "_priority-xlow_1i7ex_15",
  isActive: isActive$1,
  "priority-low": "_priority-low_1i7ex_30",
  "priority-medium": "_priority-medium_1i7ex_43",
  "priority-high": "_priority-high_1i7ex_57",
  "priority-xhigh": "_priority-xhigh_1i7ex_71",
  selected: selected$1,
  "variant-danger": "_variant-danger_1i7ex_97",
  "variant-success": "_variant-success_1i7ex_142",
  "variant-floating": "_variant-floating_1i7ex_183",
  combined,
  "size-xsmall": "_size-xsmall_1i7ex_299",
  "size-small": "_size-small_1i7ex_309",
  "size-medium": "_size-medium_1i7ex_318",
  "size-large": "_size-large_1i7ex_327",
  isLoading,
  loadingMarkup
};
const container$8 = "_container_k35sf_5";
const styles$y = {
  container: container$8
};
const autoPlacementValues = ["auto", "auto-start", "auto-end"];
const Tooltip$1 = ({
  tooltip,
  children,
  position = "auto",
  delay = 0,
  fixed: fixed2,
  className,
  childrenClassName,
  style,
  enabled = true,
  isOpen: isOpenFromProps,
  openOnFocus = false,
  usePortal = false,
  portalRoot,
  element,
  onClick
}) => {
  const [isOpenInState, setIsOpen] = useState(false);
  const isOpen = (isOpenFromProps ?? isOpenInState) && !!tooltip;
  const arrowRef = useRef(null);
  const isAutoPlacement = autoPlacementValues.includes(position);
  const alignment = getAutoAlignmentFromPlacement(position);
  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    strategy: fixed2 ? "fixed" : void 0,
    placement: isAutoPlacement ? "bottom" : position,
    // bottom is the default
    middleware: [
      offset(10),
      ...isAutoPlacement ? [
        autoPlacement({
          alignment
        })
      ] : [flip()],
      shift(),
      arrow({
        element: arrowRef
      })
    ]
  });
  const hover = useHover(context, {
    move: false,
    enabled: isOpenFromProps === void 0,
    delay: delay ? { open: delay } : void 0
  });
  const focus2 = useFocus(context, {
    enabled: openOnFocus && !isOpenFromProps
  });
  const { getReferenceProps, getFloatingProps } = useInteractions([hover, focus2]);
  const Tooltip2 = tooltip;
  const Element3 = element || "div";
  const tooltipContent = /* @__PURE__ */ React__default.createElement(
    "div",
    {
      ref: refs.setFloating,
      className: classNames(styles$y.container, className),
      ...getFloatingProps(),
      style: floatingStyles
    },
    /* @__PURE__ */ React__default.createElement(FloatingArrow, { ref: arrowRef, context }),
    typeof Tooltip2 === "function" ? /* @__PURE__ */ React__default.createElement(Tooltip2, null) : Tooltip2
  );
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    Element3,
    {
      ref: refs.setReference,
      className: childrenClassName,
      style,
      ...getReferenceProps(),
      onClick
    },
    children
  ), isOpen && enabled ? usePortal ? /* @__PURE__ */ React__default.createElement(FloatingPortal, { root: portalRoot }, tooltipContent) : tooltipContent : null);
};
function getAutoAlignmentFromPlacement(placement) {
  if (!autoPlacementValues.includes(placement)) return void 0;
  return placement.endsWith("start") ? "start" : placement.endsWith("end") ? "end" : void 0;
}
const LoadingIcon = (props) => /* @__PURE__ */ React__default.createElement(
  "svg",
  {
    width: "38",
    height: "38",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    ...props
  },
  /* @__PURE__ */ React__default.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React__default.createElement("g", { transform: "translate(1 1)", strokeWidth: "2" }, /* @__PURE__ */ React__default.createElement("circle", { strokeOpacity: ".5", cx: "18", cy: "18", r: "18" }), /* @__PURE__ */ React__default.createElement("path", { d: "M36 18c0-9.94-8.06-18-18-18" }, /* @__PURE__ */ React__default.createElement(
    "animateTransform",
    {
      attributeName: "transform",
      type: "rotate",
      from: "0 18 18",
      to: "360 18 18",
      dur: "1s",
      repeatCount: "indefinite"
    }
  ))))
);
const buttonPriorities = ["xlow", "low", "medium", "high", "xhigh"];
const Button$1 = React__default.forwardRef(
  (props, ref) => {
    const {
      children,
      className,
      isLoading: isLoading2,
      disabled: disabled2 = isLoading2,
      type = "button",
      isActive: isActive2,
      onClick,
      destructive,
      style,
      tooltip,
      selected: selected2,
      caret,
      asChild,
      ...rest
    } = props;
    const handleClick = (e) => {
      if (disabled2) {
        e.preventDefault();
        return;
      }
      onClick == null ? void 0 : onClick(e);
    };
    const { className: classes } = useButtonClassNames(props);
    const buttonClass = classNames(classes, className);
    const caretMarkup = caret ? /* @__PURE__ */ React__default.createElement(Caret, { direction: isActive2 ? "up" : "down" }) : null;
    const loadingMarkup2 = isLoading2 ? /* @__PURE__ */ React__default.createElement("div", { className: styles$z.loadingMarkup }, /* @__PURE__ */ React__default.createElement(LoadingIcon, null)) : null;
    const buttonProps = {
      disabled: disabled2,
      onClick: handleClick,
      style,
      type
    };
    const wrappedChildren = typeof children === "string" ? /* @__PURE__ */ React__default.createElement("span", { className: styles$z.text }, children) : children;
    const Component2 = asChild ? Slot : "button";
    const button2 = /* @__PURE__ */ React__default.createElement(Component2, { ...omit(rest, "priority"), ref, className: buttonClass, ...buttonProps }, /* @__PURE__ */ React__default.createElement(Slottable, null, wrappedChildren), caretMarkup, loadingMarkup2);
    if (tooltip) {
      return /* @__PURE__ */ React__default.createElement(Tooltip$1, { position: "bottom", usePortal: true, tooltip }, button2);
    }
    return button2;
  }
);
Button$1.displayName = "Button";
function validateProps(props) {
  if (process.env.NODE_ENV === "production") {
    return;
  }
  const priority = props.priority ?? "medium";
  if (props.selected && priority !== "low" && priority !== "medium") {
    throw new Error(
      `Button: \`selected\` prop is only supported on low & medium priority buttons. Priority: ${priority}`
    );
  }
  if (props.destructive && (priority === "xlow" || priority === "xhigh")) {
    throw new Error(
      `Button: \`destructive\` prop is not supported on xlow or xhigh priority buttons. Priority: ${props.priority}`
    );
  }
  if (props.selected && props.destructive) {
    throw new Error("Button: `selected` prop is not supported on destructive buttons.");
  }
}
const Caret = ({
  direction,
  ...props
}) => /* @__PURE__ */ React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React__default.createElement(
  "path",
  {
    d: direction === "up" ? "M6.1018 16.9814C5.02785 16.9814 4.45387 15.7165 5.16108 14.9083L10.6829 8.59762C11.3801 7.80079 12.6197 7.80079 13.3169 8.59762L18.8388 14.9083C19.5459 15.7165 18.972 16.9814 17.898 16.9814H6.1018Z" : "M6.1018 8C5.02785 8 4.45387 9.2649 5.16108 10.0731L10.6829 16.3838C11.3801 17.1806 12.6197 17.1806 13.3169 16.3838L18.8388 10.0731C19.5459 9.2649 18.972 8 17.898 8H6.1018Z",
    fill: "currentColor"
  }
));
function useButtonClassNames(props) {
  validateProps(props);
  const {
    destructive,
    isActive: isActive2,
    selected: selected2,
    isLoading: isLoading2,
    disabled: disabled2 = isLoading2,
    variant = "default",
    priority = "medium",
    size = "medium"
  } = props;
  const activeClassName = styles$z.isActive;
  const buttonVariant = destructive ? "danger" : variant;
  const className = classNames(
    styles$z.button,
    styles$z[`variant-${buttonVariant}`],
    styles$z[`priority-${buttonPriorities.find((p) => p === priority) ?? "medium"}`],
    styles$z[`size-${size}`],
    {
      [activeClassName]: isActive2,
      [styles$z.selected]: selected2,
      [styles$z.disabled]: disabled2,
      [styles$z.isLoading]: isLoading2
    }
  );
  return { className, activeClassName };
}
const LinkButton = (props) => {
  const { className } = useButtonClassNames(props);
  const { disabled: disabled2, onClick, linkTo, newWindow, destructive, children, ...rest } = props;
  const handleClick = (e) => {
    if (disabled2) {
      e.preventDefault();
      return;
    }
    onClick == null ? void 0 : onClick(e);
  };
  const wrappedChildren = typeof children === "string" ? /* @__PURE__ */ React__default.createElement("span", null, children) : children;
  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    /* @__PURE__ */ React__default.createElement(
      "a",
      {
        ...rest,
        href: linkTo,
        "data-act-as-button": true,
        className: classNames(className, props.className),
        onClick: handleClick,
        target: newWindow ? "_blank" : void 0,
        rel: newWindow ? "noopener" : void 0
      },
      wrappedChildren
    )
  );
};
LinkButton.displayName = "LinkButton";
const buttonRow = "_buttonRow_1cgcc_5";
const left = "_left_1cgcc_11";
const right = "_right_1cgcc_18";
const styles$x = {
  buttonRow,
  left,
  right
};
const ButtonRow = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", { ...props, className: classNames(styles$x.buttonRow, props.className) }, props.children);
};
ButtonRow.Left = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", { ...props, className: classNames(styles$x.left, props.className) }, props.children);
};
ButtonRow.Right = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", { ...props, className: classNames(styles$x.right, props.className) }, props.children);
};
const buttonGroup = "_buttonGroup_1b109_5";
const button$1 = "_button_1b109_5";
const disabled$5 = "_disabled_1b109_36";
const active$5 = "_active_1b109_36";
const stretch = "_stretch_1b109_98";
const styles$w = {
  buttonGroup,
  button: button$1,
  disabled: disabled$5,
  active: active$5,
  "size-xsmall": "_size-xsmall_1b109_68",
  "size-small": "_size-small_1b109_78",
  "size-medium": "_size-medium_1b109_88",
  stretch
};
const ButtonGroup = (props) => {
  const { size = "small", options, activeValue, stretch: stretch2, onChange, ...rest } = props;
  const groupClassName = classNames(
    styles$w.buttonGroup,
    styles$w[`size-${size}`],
    {
      [styles$w.stretch]: stretch2
    },
    props.className
  );
  return /* @__PURE__ */ React__default.createElement("div", { ...rest, className: groupClassName }, options.map(
    ({ value, label: label2, tooltip, icon: icon2, disabled: disabled2, ...rest2 }) => maybeWrapTooltip(
      tooltip,
      value,
      /* @__PURE__ */ React__default.createElement(
        "button",
        {
          type: "button",
          className: classNames(styles$w.button, {
            [styles$w.active]: value === activeValue,
            [styles$w.disabled]: disabled2
          }),
          key: String(value),
          onClick: (e) => !disabled2 && onChange(value, e),
          "data-testid": rest2["data-testid"] || `button-group-${value}`
        },
        icon2,
        /* @__PURE__ */ React__default.createElement("span", null, label2)
      )
    )
  ));
};
ButtonGroup.displayName = "ButtonGroup";
function maybeWrapTooltip(tooltip, key, element) {
  if (tooltip) {
    return /* @__PURE__ */ React__default.createElement(Tooltip$1, { key: String(key), tooltip }, element);
  }
  return element;
}
const CombinedButton = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", { ...props, className: classNames(styles$z.combined, props.className) }, props.children);
};
CombinedButton.displayName = "CombinedButton";
const wrapper = "_wrapper_z0pw8_5";
const label$3 = "_label_z0pw8_33";
const track = "_track_z0pw8_38";
const trackInner = "_trackInner_z0pw8_44";
const thumb = "_thumb_z0pw8_48";
const checked$1 = "_checked_z0pw8_59";
const disabled$4 = "_disabled_z0pw8_69";
const focus = "_focus_z0pw8_70";
const screenreaderOnly = "_screenreaderOnly_z0pw8_146";
const styles$v = {
  wrapper,
  "switch": "_switch_z0pw8_12",
  label: label$3,
  track,
  trackInner,
  thumb,
  checked: checked$1,
  disabled: disabled$4,
  focus,
  "size-xsmall": "_size-xsmall_z0pw8_89",
  "size-small": "_size-small_z0pw8_108",
  "size-medium": "_size-medium_z0pw8_127",
  screenreaderOnly
};
const Switch = ({
  checked: checked2,
  onChangeChecked,
  label: label2,
  size = "medium",
  disabled: disabled2,
  className = "",
  ...rest
}) => {
  const inputRef = useRef(null);
  const [hasFocus, setHasFocus] = useState(false);
  const handleFocus = useCallback(() => setHasFocus(true), []);
  const handleBlur = useCallback(() => setHasFocus(false), []);
  const handleClick = useCallback(() => {
    if (disabled2) {
      return;
    }
    const checkbox2 = inputRef.current;
    onChangeChecked(!checked2);
    if (checkbox2) {
      checkbox2.focus();
    }
  }, [checked2, disabled2, onChangeChecked]);
  const classes = classNames({ [className]: !label2 }, styles$v.switch, styles$v[`size-${size}`], {
    [styles$v.checked]: checked2,
    [styles$v.focus]: hasFocus,
    [styles$v.disabled]: disabled2
  });
  const switchArea = /* @__PURE__ */ React__default.createElement("div", { className: classes, onClick: handleClick }, /* @__PURE__ */ React__default.createElement("div", { className: styles$v.track }, /* @__PURE__ */ React__default.createElement("div", { className: styles$v.trackInner }, /* @__PURE__ */ React__default.createElement("div", { className: styles$v.thumb }))), /* @__PURE__ */ React__default.createElement(
    "input",
    {
      ...rest,
      ref: inputRef,
      className: styles$v.screenreaderOnly,
      onFocus: handleFocus,
      onBlur: handleBlur,
      type: "checkbox",
      disabled: disabled2
    }
  ));
  return label2 ? /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames(className, styles$v.wrapper, styles$v[`size-${size}`], {
        [styles$v.checked]: checked2,
        [styles$v.focus]: hasFocus,
        [styles$v.disabled]: disabled2
      })
    },
    switchArea,
    /* @__PURE__ */ React__default.createElement("div", { className: styles$v.label, onClick: handleClick }, label2)
  ) : switchArea;
};
Switch.displayName = "Switch";
const checkbox = "_checkbox_1me3u_5";
const inner$1 = "_inner_1me3u_29";
const checked = "_checked_1me3u_42";
const indeterminate = "_indeterminate_1me3u_42";
const disabled$3 = "_disabled_1me3u_47";
const label$2 = "_label_1me3u_61";
const styles$u = {
  checkbox,
  inner: inner$1,
  checked,
  indeterminate,
  disabled: disabled$3,
  label: label$2
};
const CheckedSymbol = () => /* @__PURE__ */ React__default.createElement(
  "svg",
  {
    width: "10",
    height: "8",
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { width: 10, height: 8 }
  },
  /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M9 1.33333L3.5 6.33333L1 4.0606",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
const IndeterminateSymbol = () => /* @__PURE__ */ React__default.createElement(
  "svg",
  {
    width: "10",
    height: "2",
    viewBox: "0 0 10 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { width: 10, height: 2 }
  },
  /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M8.5 1L1.5 1",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
const Checkbox$1 = ({
  checked: checked2,
  children,
  className,
  disabled: disabled2,
  indeterminate: indeterminate2 = false,
  label: label2,
  style,
  onChange,
  onChangeChecked,
  ...props
}) => {
  const handleOnChange = useCallback(
    (event) => {
      onChange == null ? void 0 : onChange(event);
      onChangeChecked == null ? void 0 : onChangeChecked(event.target.checked, event);
    },
    [onChange, onChangeChecked]
  );
  const checkbox2 = /* @__PURE__ */ React__default.createElement(
    "span",
    {
      className: classNames(!label2 && className, styles$u.checkbox, {
        [styles$u.checked]: checked2,
        [styles$u.disabled]: disabled2,
        [styles$u.indeterminate]: !checked2 && indeterminate2
      }),
      role: "checkbox",
      "aria-checked": checked2,
      style
    },
    /* @__PURE__ */ React__default.createElement(
      "input",
      {
        ref: (input2) => {
          if (input2) {
            input2.indeterminate = !checked2 && indeterminate2;
          }
        },
        type: "checkbox",
        checked: checked2,
        disabled: disabled2,
        onChange: handleOnChange,
        "data-testid": "checkbox",
        ...props
      }
    ),
    /* @__PURE__ */ React__default.createElement("span", { className: styles$u.inner }, checked2 && /* @__PURE__ */ React__default.createElement(CheckedSymbol, null), !checked2 && indeterminate2 && /* @__PURE__ */ React__default.createElement(IndeterminateSymbol, null), /* @__PURE__ */ React__default.createElement("div", { className: styles$u.stateLayer }))
  );
  const labelContent = children ?? label2;
  return labelContent ? /* @__PURE__ */ React__default.createElement(
    "label",
    {
      htmlFor: props.id,
      className: classNames(className, styles$u.label, {
        [styles$u.disabled]: disabled2,
        [styles$u.checked]: checked2,
        [styles$u.indeterminate]: indeterminate2
      })
    },
    checkbox2,
    labelContent
  ) : checkbox2;
};
Checkbox$1.displayName = "Checkbox";
const targetWrapper = "_targetWrapper_15x3x_1";
const popper = "_popper_15x3x_9";
const preventTextOverflow = "_preventTextOverflow_15x3x_22";
const isInitialized = "_isInitialized_15x3x_25";
const styles$t = {
  targetWrapper,
  popper,
  preventTextOverflow,
  isInitialized
};
const OPEN_CLASS_NAME = "PopoverTarget_openClass";
const PopoverTarget = React__default.forwardRef((props, ref) => {
  const {
    target,
    isCurrentlyOpen,
    targetCaret,
    ignoreTargetOnClick,
    onClick,
    onFocus = null,
    targetWrapperElement,
    targetWrapper: targetWrapper2
  } = props;
  if (!target) {
    return null;
  }
  const targetProps = {
    ...target.props,
    onFocus,
    onClick: (...args) => {
      var _a, _b;
      if (args.event && typeof args.event === typeof MouseEvent) {
        args.event.stopPropagation();
      }
      if (!ignoreTargetOnClick) {
        (_b = (_a = target.props).onClick) == null ? void 0 : _b.call(_a, ...args);
      }
      onClick(...args);
    },
    className: classNames(target.props.className, { [OPEN_CLASS_NAME]: isCurrentlyOpen })
  };
  const targetName = typeof target.type === "string" ? target.type : target.type.displayName ?? target.type.name;
  if ((targetName ?? "").endsWith("Button")) {
    targetProps.isActive = isCurrentlyOpen;
    if (targetProps.caret !== false) {
      targetProps.caret = targetCaret;
    }
  }
  if (targetWrapper2) {
    return React__default.createElement(
      targetWrapperElement,
      { className: styles$t.targetWrapper, ref },
      React__default.cloneElement(target, targetProps)
    );
  }
  targetProps.ref = ref;
  return React__default.cloneElement(target, targetProps);
});
PopoverTarget.displayName = "PopoverTarget";
const isOpenCheck = (props, state) => {
  const isOpenStateControllerViaProp = props.isOpen !== void 0;
  return !!(isOpenStateControllerViaProp ? props.isOpen : state.isOpen);
};
const getAnimationPosition = (placement = "auto") => {
  const distance = "10px";
  const direction = {
    auto: `0px,0px,0px`,
    top: `0px,${distance},0px`,
    right: `-${distance},0px,0px`,
    bottom: `0px,-${distance},0px`,
    left: `${distance},0px,0px`
  };
  const finalPlacement = placement.replace("-start", "").replace("-end", "");
  return direction[finalPlacement];
};
let timer = null;
const isDOM = typeof document !== "undefined";
const _FocalPoint = class _FocalPoint extends React__default.Component {
  constructor() {
    super(...arguments);
    this.anchor = isDOM ? document.activeElement : null;
    this.rootRef = React__default.createRef();
    this.focus = () => {
      var _a;
      if (this.contains(document.activeElement) === false) {
        (_a = this.rootRef.current) == null ? void 0 : _a.focus();
      }
    };
    this._onBlur = (event) => {
      const current = this.anchor;
      if (current && event.target instanceof Node && current.contains(event.target) === false) {
        event.preventDefault();
        this.trapFocus();
      }
    };
  }
  contains(element) {
    var _a;
    return ((_a = this.rootRef.current) == null ? void 0 : _a.contains(element)) === true;
  }
  trapFocus() {
    window.clearTimeout(timer);
    timer = window.setTimeout(this.focus, 10);
  }
  returnFocus() {
    if (this.anchor instanceof HTMLElement && typeof this.anchor.focus === "function") {
      this.anchor.focus();
    }
  }
  componentDidMount() {
    this.trapFocus();
    document.addEventListener("focus", this._onBlur, true);
  }
  componentWillUnmount() {
    document.removeEventListener("focus", this._onBlur, true);
    clearTimeout(timer);
    this.returnFocus();
    this.anchor = null;
  }
  render() {
    const { children, element, className } = this.props;
    return React__default.createElement(
      element ?? "div",
      {
        ref: this.rootRef,
        tabIndex: 0,
        className
      },
      children
    );
  }
};
_FocalPoint.defaultProps = {
  element: "div"
};
let FocalPoint = _FocalPoint;
const FocusTrap = (props) => {
  const {
    active: active2 = true,
    onExit,
    className,
    baseClassName = "focus-trap",
    children,
    element
  } = props;
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      onExit == null ? void 0 : onExit(event);
    }
  };
  if (!active2) return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children);
  return /* @__PURE__ */ React__default.createElement("div", { className: classNames(`${baseClassName}-wrapper`, className), onKeyDown: handleKeyDown }, /* @__PURE__ */ React__default.createElement(FocalPoint, { className: baseClassName, element }, children));
};
const _ClickOutsideTrap = class _ClickOutsideTrap extends React__default.Component {
  constructor() {
    super(...arguments);
    this.ownRef = React__default.createRef();
    this.handleClickOutsideTrap = (event) => {
      var _a;
      if (this.props.enabled) {
        const target = event.target instanceof HTMLElement ? event.target : null;
        if (!target) {
          return;
        }
        const ignoredParent = target.closest(".ignore-react-onclickoutside");
        if (ignoredParent) {
          return;
        }
        const ref = this.props.forwardedRef ?? this.ownRef;
        const isOutside = !((_a = ref.current) == null ? void 0 : _a.contains(target));
        if (isOutside) {
          this.props.onClickOutside(event);
        }
      }
    };
  }
  componentDidMount() {
    if (this.props.enabled) {
      document.addEventListener("mousedown", this.handleClickOutsideTrap, true);
    }
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.enabled && this.props.enabled) {
      document.addEventListener("mousedown", this.handleClickOutsideTrap, true);
    }
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutsideTrap, true);
  }
  render() {
    const { children, onClickOutside, enabled, forwardedRef, ...props } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", { ...props, ref: forwardedRef ?? this.ownRef }, children);
  }
};
_ClickOutsideTrap.defaultProps = {
  enabled: true
};
let ClickOutsideTrap = _ClickOutsideTrap;
const _Trap = class _Trap extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    this.clickOutsideRef = React__default.createRef();
    this.handleClickOutside = (event) => {
      var _a, _b, _c, _d;
      if (!this.props.shouldExitOnClickOutside) {
        return;
      }
      if (!this.clickOutsideRef.current) {
        (_b = (_a = this.props).onExit) == null ? void 0 : _b.call(_a, event);
        return;
      }
      const bounds = this.clickOutsideRef.current.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
        (_d = (_c = this.props).onExit) == null ? void 0 : _d.call(_c, event);
      }
    };
    this.handleExit = (event) => {
      var _a, _b;
      if (!this.props.shouldExitOnEsc || event.key !== "Escape") {
        return;
      }
      if (this.props.stopEscPropagation) {
        event.stopPropagation();
      }
      (_b = (_a = this.props).onExit) == null ? void 0 : _b.call(_a, event);
    };
  }
  render() {
    const {
      children,
      onExit,
      enabled,
      shouldExitOnEsc,
      shouldExitOnClickOutside,
      stopEscPropagation,
      ...rest
    } = this.props;
    if (!enabled) {
      return /* @__PURE__ */ React__default.createElement("div", { ...rest }, children);
    }
    return /* @__PURE__ */ React__default.createElement(
      ClickOutsideTrap,
      {
        onClickOutside: this.handleClickOutside,
        forwardedRef: this.clickOutsideRef,
        ...rest
      },
      /* @__PURE__ */ React__default.createElement(FocusTrap, { active: this.props.shouldExitOnEsc, onExit: this.handleExit }, children)
    );
  }
};
_Trap.defaultProps = {
  enabled: true,
  stopEscPropagation: true,
  shouldExitOnClickOutside: true,
  shouldExitOnEsc: true
};
let Trap = _Trap;
const flipBehavior = ["right", "left", "bottom", "top"];
const _Popover = class _Popover extends Component {
  constructor(props) {
    super(props);
    this.shouldScheduleUpdate = false;
    this.targetRef = React__default.createRef();
    this.close = () => {
      if (!isOpenCheck(this.props, this.state)) return;
      this.handleTogglePopover(new Event("click"));
    };
    this.handleTogglePopover = (event) => {
      const isOpenStateControllerViaProp = this.props.isOpen !== void 0;
      const isCurrentlyOpen = isOpenCheck(this.props, this.state);
      const { current } = this.targetRef;
      if (event.target instanceof Element && current && current.contains(event.target) === false) {
        event.preventDefault();
      }
      if (this.props.stopPropagation) {
        event.stopPropagation();
      }
      if (!isOpenStateControllerViaProp) {
        this.setState({ isOpen: !isCurrentlyOpen });
      }
      if (isCurrentlyOpen) {
        this.props.onClose(event);
      } else {
        this.props.onOpen(event);
      }
    };
    this.state = {
      isOpen: !!props.isInitiallyOpen
    };
  }
  renderTarget(ref) {
    return /* @__PURE__ */ React__default.createElement(
      PopoverTarget,
      {
        ref,
        isCurrentlyOpen: isOpenCheck(this.props, this.state),
        targetCaret: this.props.targetCaret,
        targetWrapper: this.props.targetWrapper,
        targetWrapperElement: this.props.targetWrapperElement,
        onFocus: this.props.openOnTargetFocus ? this.handleTogglePopover : null,
        onClick: this.handleTogglePopover,
        ignoreTargetOnClick: this.props.ignoreTargetOnClick,
        target: this.props.target
      }
    );
  }
  render() {
    const isOpen = isOpenCheck(this.props, this.state);
    const {
      enableKeyTrap,
      closeOnOutsideClick,
      closeOnClick,
      className,
      children: childNodeOrFunction,
      variant,
      width,
      maxWidth,
      maxHeight,
      height,
      padding,
      preventTextOverflow: preventTextOverflow2,
      customScrollbars,
      zIndex,
      usePortal
    } = this.props;
    if (!isOpen) {
      return this.renderTarget();
    }
    return /* @__PURE__ */ React__default.createElement(Manager, null, /* @__PURE__ */ React__default.createElement(Reference, null, ({ ref }) => {
      return this.renderTarget(ref);
    }), !!isOpen && /* @__PURE__ */ React__default.createElement(
      Popper,
      {
        strategy: this.props.fixed ? "fixed" : "absolute",
        placement: this.props.position,
        modifiers: [
          // We disable the built-in gpuAcceleration so that
          // Popper.js will return us easy to interpolate values
          // (top, left instead of transform: translate3d)
          { name: "computeStyles", options: { gpuAcceleration: false } },
          { name: "preventOverflow" },
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: flipBehavior } }
        ]
      },
      ({ ref, style, placement }) => {
        const isInitialized2 = !!placement;
        const realPlacement = placement || this.props.position;
        const popperContentClass = classNames(
          styles$t.popper,
          styles$t[`variant-${variant}`],
          {
            [styles$t.isInitialized]: isInitialized2,
            [styles$t.preventTextOverflow]: preventTextOverflow2
          },
          className
        );
        const animations = isInitialized2 ? { transform: "translate3d(0,0,0) scale(1)" } : { transform: `translate3d(${getAnimationPosition(realPlacement)}) scale(0.95)` };
        const children = typeof childNodeOrFunction === "function" ? childNodeOrFunction(realPlacement) : childNodeOrFunction;
        const isTrapEnabled = enableKeyTrap || closeOnOutsideClick;
        const childDom = /* @__PURE__ */ React__default.createElement(
          Trap,
          {
            enabled: isTrapEnabled,
            shouldExitOnEsc: enableKeyTrap,
            shouldExitOnClickOutside: closeOnOutsideClick,
            onExit: this.handleTogglePopover,
            style: { padding }
          },
          children
        );
        const content2 = /* @__PURE__ */ React__default.createElement(
          "div",
          {
            style: {
              width,
              maxWidth,
              maxHeight,
              height,
              ...style,
              ...animations,
              zIndex,
              willChange: `transform, box-shadow`
            },
            className: popperContentClass,
            ref,
            "data-placement": realPlacement,
            onClick: closeOnClick ? this.handleTogglePopover : void 0,
            "data-testid": this.props.testId
          },
          customScrollbars ? /* @__PURE__ */ React__default.createElement(
            Scrollbars,
            {
              autoHeight: true,
              hideTracksWhenNotNeeded: true,
              autoHeightMin: 0,
              autoHeightMax: maxHeight || height || "calc(100vh - 40px)"
            },
            childDom
          ) : childDom
        );
        return usePortal ? ReactDOM.createPortal(content2, document.body) : content2;
      }
    ));
  }
};
_Popover.defaultProps = {
  fixed: false,
  target: null,
  position: "auto",
  onOpen: () => null,
  onClose: () => null,
  isOpen: void 0,
  enableKeyTrap: true,
  closeOnOutsideClick: true,
  closeOnClick: false,
  openOnTargetFocus: false,
  stopPropagation: false,
  targetCaret: true,
  targetWrapper: true,
  // We default to div for legacy reasons
  targetWrapperElement: "div",
  variant: "default",
  // Modifier options that might be
  flipEnabled: true,
  isInitiallyOpen: false,
  padding: 0,
  width: void 0,
  maxWidth: void 0,
  preventTextOverflow: false,
  maxHeight: void 0,
  height: void 0,
  // Todo: This should probably be default, but make sure we
  // fix double-overflows like AccountSwitcherDropdown
  customScrollbars: false,
  preventOverflow: true,
  zIndex: void 0,
  // Should probably be false by default, but don't have time to check all the use cases atm
  ignoreTargetOnClick: true,
  usePortal: false
};
let Popover = _Popover;
const SvgAlertSquare$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 8v4m0 4h.01M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
    }
  )
);
SvgAlertSquare$1.displayName = "AlertSquare";
const SvgAlertTriangle$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 9v4m0 4h.01M10.615 3.892 2.39 18.098c-.456.788-.684 1.182-.65 1.506a1 1 0 0 0 .406.705c.263.191.718.191 1.629.191h16.45c.91 0 1.365 0 1.628-.191a1 1 0 0 0 .407-.705c.034-.324-.195-.718-.65-1.506L13.383 3.892c-.454-.785-.681-1.178-.978-1.31a1 1 0 0 0-.813 0c-.296.132-.523.525-.978 1.31Z"
    }
  )
);
SvgAlertTriangle$1.displayName = "AlertTriangle";
const SvgArrowNarrowDown$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 4v16m0 0 6-6m-6 6-6-6"
    }
  )
);
SvgArrowNarrowDown$1.displayName = "ArrowNarrowDown";
const SvgArrowNarrowLeft = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M20 12H4m0 0 6 6m-6-6 6-6"
    }
  )
);
SvgArrowNarrowLeft.displayName = "ArrowNarrowLeft";
const SvgArrowNarrowUp$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 20V4m0 0-6 6m6-6 6 6"
    }
  )
);
SvgArrowNarrowUp$1.displayName = "ArrowNarrowUp";
const SvgBankNote01$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M6 11v4m12-6v4m-1-9c2.449 0 3.773.375 4.432.665a.708.708 0 0 1 .258.18c.076.072.215.284.25.383.06.165.06.255.06.435V16.41c0 .909 0 1.363-.136 1.597a.872.872 0 0 1-.532.44c-.255.089-.77-.01-1.8-.208-.72-.138-1.576-.24-2.532-.24-3 0-6 2-10 2-2.449 0-3.773-.375-4.432-.665-.088-.04-.132-.059-.258-.18a1.463 1.463 0 0 1-.25-.383C2 18.607 2 18.517 2 18.337V7.59c0-.909 0-1.363.136-1.597a.871.871 0 0 1 .532-.44c.255-.089.77.01 1.8.208C5.188 5.898 6.043 6 7 6c3 0 6-2 10-2Zm-2.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
    }
  )
);
SvgBankNote01$1.displayName = "BankNote01";
const SvgBarChartSquare01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M8 13v4m8-6v6M12 7v10m-4.2 4h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
    }
  )
);
SvgBarChartSquare01.displayName = "BarChartSquare01";
const SvgBold01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M6 12h8a4 4 0 0 0 0-8H6v8Zm0 0h9a4 4 0 0 1 0 8H6v-8Z"
    }
  )
);
SvgBold01.displayName = "Bold01";
const SvgCalendar$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M21 10H3m13-8v4M8 2v4m-.2 16h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22Z"
    }
  )
);
SvgCalendar$1.displayName = "Calendar";
const SvgCheckCircle$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "m7.5 12 3 3 6-6m5.5 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
    }
  )
);
SvgCheckCircle$1.displayName = "CheckCircle";
const SvgCheckDone02$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M16 8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 16 4.08 16 5.2 16H8m4-1 2 2 4.5-4.5M11.2 22h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.48 22 19.92 22 18.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 8 19.92 8 18.8 8h-7.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C8 9.52 8 10.08 8 11.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C9.52 22 10.08 22 11.2 22Z"
    }
  )
);
SvgCheckDone02$1.displayName = "CheckDone02";
const SvgCheckVerified02$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "m9 12 2 2 4.5-4.5m2.401-4.501c.206.498.601.893 1.1 1.1l1.744.723a2.033 2.033 0 0 1 1.1 2.656l-.722 1.744a2.03 2.03 0 0 0 0 1.556l.722 1.744a2.033 2.033 0 0 1-1.1 2.656L19 17.901A2.033 2.033 0 0 0 17.9 19l-.723 1.745a2.032 2.032 0 0 1-2.656 1.1l-1.744-.722a2.032 2.032 0 0 0-1.555 0l-1.745.723a2.033 2.033 0 0 1-2.654-1.1L6.1 19.001A2.033 2.033 0 0 0 5 17.9l-1.744-.723a2.033 2.033 0 0 1-1.1-2.654l.721-1.744a2.033 2.033 0 0 0 0-1.556l-.722-1.746a2.033 2.033 0 0 1 1.1-2.657L5 6.098c.498-.206.893-.6 1.1-1.098l.723-1.745a2.033 2.033 0 0 1 2.656-1.1l1.744.722a2.033 2.033 0 0 0 1.555-.001l1.746-.72a2.032 2.032 0 0 1 2.655 1.1l.723 1.746v-.003Z"
    }
  )
);
SvgCheckVerified02$1.displayName = "CheckVerified02";
const SvgChevronRight$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "m9 18 6-6-6-6" })
);
SvgChevronRight$1.displayName = "ChevronRight";
const SvgClockPlus = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M21.92 13.265c.053-.414.08-.837.08-1.265 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10c.435 0 .864-.028 1.285-.082M12 6v6l3.738 1.87M19 22v-6m-3 3h6"
    }
  )
);
SvgClockPlus.displayName = "ClockPlus";
const SvgClockRefresh$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M20.453 12.893A8.5 8.5 0 0 1 4.638 16.25l-.25-.433m-.842-4.71A8.5 8.5 0 0 1 19.361 7.75l.25.433M3.493 18.066l.732-2.732 2.732.732m10.085-8.132 2.732.732.732-2.732M12 7.5V12l2.5 1.5"
    }
  )
);
SvgClockRefresh$1.displayName = "ClockRefresh";
const SvgClock$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 6v6l4 2m6-2c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
    }
  )
);
SvgClock$1.displayName = "Clock";
const SvgCurrencyDollarCircle$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M8.5 14.667A2.333 2.333 0 0 0 10.833 17H13a2.5 2.5 0 0 0 0-5h-2a2.5 2.5 0 0 1 0-5h2.167A2.333 2.333 0 0 1 15.5 9.333M12 5.5V7m0 10v1.5M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
    }
  )
);
SvgCurrencyDollarCircle$1.displayName = "CurrencyDollarCircle";
const SvgDownload01$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M21 15v1.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V15m14-5-5 5m0 0-5-5m5 5V3"
    }
  )
);
SvgDownload01$1.displayName = "Download01";
const SvgExpand01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "m14 10 7-7m0 0h-6m6 0v6m-11 5-7 7m0 0h6m-6 0v-6"
    }
  )
);
SvgExpand01.displayName = "Expand01";
const SvgExpand06 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "m16 8 5-5m0 0h-5m5 0v5M8 8 3 3m0 0v5m0-5h5m0 13-5 5m0 0h5m-5 0v-5m13 0 5 5m0 0v-5m0 5h-5"
    }
  )
);
SvgExpand06.displayName = "Expand06";
const SvgEyeOff = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M10.743 5.092C11.149 5.032 11.569 5 12 5c5.105 0 8.455 4.505 9.58 6.287.137.215.205.323.243.49.029.125.029.322 0 .447-.038.166-.107.274-.244.492-.3.474-.757 1.141-1.363 1.865M6.724 6.715c-2.162 1.467-3.63 3.504-4.303 4.57-.137.217-.205.325-.243.492a1.173 1.173 0 0 0 0 .446c.038.167.106.274.242.49C3.546 14.495 6.895 19 12 19c2.059 0 3.832-.732 5.289-1.723M3 3l18 18M9.88 9.879a3 3 0 1 0 4.243 4.243"
    }
  )
);
SvgEyeOff.displayName = "EyeOff";
const SvgEye$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M2.42 12.713c-.136-.215-.204-.323-.242-.49a1.173 1.173 0 0 1 0-.446c.038-.167.106-.274.242-.49C3.546 9.505 6.895 5 12 5s8.455 4.505 9.58 6.287c.137.215.205.323.243.49.029.125.029.322 0 .446-.038.167-.106.274-.242.49C20.455 14.495 17.105 19 12 19c-5.106 0-8.455-4.505-9.58-6.287Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    }
  )
);
SvgEye$1.displayName = "Eye";
const SvgFile02$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M14 11H8m2 4H8m8-8H8m12-.2v10.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 2 7.12 2 8.8 2h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 4.28 20 5.12 20 6.8Z"
    }
  )
);
SvgFile02$1.displayName = "File02";
const SvgFile05 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M14 17H8m8-4H8m12-3.012V17.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 2 7.12 2 8.8 2h3.212c.733 0 1.1 0 1.446.083.306.073.598.195.867.36.303.185.562.444 1.08.963l3.19 3.188c.518.519.777.778.963 1.081a3 3 0 0 1 .36.867c.082.346.082.712.082 1.446Z"
    }
  )
);
SvgFile05.displayName = "File05";
const SvgFilterFunnel01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M2 4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 3 3.04 3 3.6 3h16.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C22 3.76 22 4.04 22 4.6v.67c0 .268 0 .403-.033.528-.029.11-.077.215-.141.31-.073.106-.175.194-.378.37l-6.396 5.543c-.203.176-.305.265-.377.371-.065.095-.113.2-.142.31-.033.125-.033.26-.033.529v5.227c0 .196 0 .294-.031.378a.5.5 0 0 1-.133.196c-.066.06-.157.096-.339.17l-3.4 1.36c-.367.146-.551.22-.699.189a.5.5 0 0 1-.315-.213c-.083-.126-.083-.324-.083-.72v-6.587c0-.27 0-.404-.033-.529a1.001 1.001 0 0 0-.141-.31c-.073-.106-.175-.194-.378-.37L2.552 6.478c-.203-.177-.305-.265-.378-.371a1 1 0 0 1-.141-.31C2 5.673 2 5.538 2 5.269V4.6Z"
    }
  )
);
SvgFilterFunnel01.displayName = "FilterFunnel01";
const SvgGrid01$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M8.4 3H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.76 3 4.04 3 4.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 10 4.04 10 4.6 10h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 9.24 10 8.96 10 8.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C9.24 3 8.96 3 8.4 3ZM19.4 3h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 3.76 14 4.04 14 4.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 10 15.04 10 15.6 10h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 9.24 21 8.96 21 8.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 3 19.96 3 19.4 3ZM19.4 14h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 14.76 14 15.04 14 15.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 21 15.04 21 15.6 21h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-3.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 14 19.96 14 19.4 14ZM8.4 14H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 14.76 3 15.04 3 15.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 20.24 10 19.96 10 19.4v-3.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C9.24 14 8.96 14 8.4 14Z"
    }
  )
);
SvgGrid01$1.displayName = "Grid01";
const SvgGrid02$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2V8m5 13H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8V16m18-8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3H16m5 13v1.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 21 18.92 21 17.8 21H16m-4-4V7m-5 5h10"
    }
  )
);
SvgGrid02$1.displayName = "Grid02";
const SvgInbox01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M2.5 12h3.382c.685 0 1.312.387 1.618 1 .306.613.933 1 1.618 1h5.764c.685 0 1.312-.387 1.618-1 .306-.613.933-1 1.618-1H21.5M8.967 4h6.066c1.077 0 1.616 0 2.091.164a3 3 0 0 1 1.121.693c.36.352.6.833 1.082 1.796l2.166 4.333c.19.378.284.567.35.765.06.177.102.357.128.541.029.207.029.418.029.841V15.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 20 18.88 20 17.2 20H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 17.72 2 16.88 2 15.2v-2.067c0-.422 0-.634.029-.84.026-.184.068-.365.128-.541.066-.199.16-.388.35-.766l2.166-4.333c.482-.963.723-1.444 1.082-1.796a3 3 0 0 1 1.12-.693C7.352 4 7.89 4 8.968 4Z"
    }
  )
);
SvgInbox01.displayName = "Inbox01";
const SvgInbox02 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M2 12h3.882c.685 0 1.312.387 1.618 1 .306.613.933 1 1.618 1h5.764c.685 0 1.312-.387 1.618-1 .306-.613.933-1 1.618-1H22M2 12V8.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 4 5.12 4 6.8 4h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 6.28 22 7.12 22 8.8V12M2 12v3.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 20 5.12 20 6.8 20h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.72 22 16.88 22 15.2V12"
    }
  )
);
SvgInbox02.displayName = "Inbox02";
const SvgLayoutGrid02 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M3 9h18M3 15h18M12 3v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
    }
  )
);
SvgLayoutGrid02.displayName = "LayoutGrid02";
const SvgLock01$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M17 10V8A5 5 0 0 0 7 8v2m5 4.5v2M8.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.72 20 17.88 20 16.2v-1.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 10 16.88 10 15.2 10H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 12.28 4 13.12 4 14.8v1.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 21 7.12 21 8.8 21Z"
    }
  )
);
SvgLock01$1.displayName = "Lock01";
const SvgMail01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "m2 7 8.165 5.715c.661.463.992.695 1.351.784a2 2 0 0 0 .968 0c.36-.09.69-.32 1.351-.784L22 7M6.8 20h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.72 22 16.88 22 15.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 4 18.88 4 17.2 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.28 2 7.12 2 8.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 20 5.12 20 6.8 20Z"
    }
  )
);
SvgMail01.displayName = "Mail01";
const SvgMessageTextSquare01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M7 8.5h5M7 12h8m-5.316 6H16.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v12.535c0 .533 0 .8.11.937a.5.5 0 0 0 .39.188c.176 0 .384-.167.8-.5l2.385-1.908c.488-.39.731-.585 1.002-.724.241-.122.497-.212.762-.267C8.748 18 9.06 18 9.684 18Z"
    }
  )
);
SvgMessageTextSquare01.displayName = "MessageTextSquare01";
const SvgPauseSquare$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M9.5 15V9m5 6V9M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
    }
  )
);
SvgPauseSquare$1.displayName = "PauseSquare";
const SvgPieChart03$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 2a10 10 0 0 1 10 10M12 2v10m0-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10M12 2c5.523 0 10 4.477 10 10m0 0H12m10 0a10 10 0 0 1-4.122 8.09L12 12"
    }
  )
);
SvgPieChart03$1.displayName = "PieChart03";
const SvgRefreshCcw04 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M17 18.875A8.5 8.5 0 0 0 12 3.5h-.5m.5 17A8.5 8.5 0 0 1 7 5.125M11 22.4l2-2-2-2m2-12.8-2-2 2-2"
    }
  )
);
SvgRefreshCcw04.displayName = "RefreshCcw04";
const SvgSearchMd$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "m21 21-4.35-4.35M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
    }
  )
);
SvgSearchMd$1.displayName = "SearchMd";
const SvgSettings01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M18.727 14.727a1.5 1.5 0 0 0 .3 1.655l.055.054a1.816 1.816 0 0 1 0 2.573 1.818 1.818 0 0 1-2.573 0l-.055-.055a1.5 1.5 0 0 0-1.654-.3 1.5 1.5 0 0 0-.91 1.373v.155a1.818 1.818 0 1 1-3.636 0V20.1a1.5 1.5 0 0 0-.981-1.373 1.5 1.5 0 0 0-1.655.3l-.054.055a1.818 1.818 0 0 1-3.106-1.287 1.818 1.818 0 0 1 .533-1.286l.054-.055a1.5 1.5 0 0 0 .3-1.654 1.5 1.5 0 0 0-1.372-.91h-.155a1.818 1.818 0 1 1 0-3.636H3.9a1.5 1.5 0 0 0 1.373-.981 1.5 1.5 0 0 0-.3-1.655l-.055-.054A1.818 1.818 0 1 1 7.491 4.99l.054.054a1.5 1.5 0 0 0 1.655.3h.073a1.5 1.5 0 0 0 .909-1.372v-.155a1.818 1.818 0 0 1 3.636 0V3.9a1.499 1.499 0 0 0 .91 1.373 1.5 1.5 0 0 0 1.654-.3l.054-.055a1.817 1.817 0 0 1 2.573 0 1.819 1.819 0 0 1 0 2.573l-.055.054a1.5 1.5 0 0 0-.3 1.655v.073a1.5 1.5 0 0 0 1.373.909h.155a1.818 1.818 0 0 1 0 3.636H20.1a1.499 1.499 0 0 0-1.373.91Z"
    }
  )
);
SvgSettings01.displayName = "Settings01";
const SvgSettings02$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "m9.29 19.371.584 1.315a2.213 2.213 0 0 0 4.044 0l.585-1.315a2.426 2.426 0 0 1 2.47-1.423l1.43.152a2.212 2.212 0 0 0 2.022-3.502l-.847-1.164a2.428 2.428 0 0 1-.46-1.434c0-.513.163-1.014.465-1.429l.847-1.163a2.212 2.212 0 0 0-2.023-3.502l-1.43.152a2.433 2.433 0 0 1-1.47-.312 2.425 2.425 0 0 1-1-1.117l-.588-1.315a2.212 2.212 0 0 0-4.045 0L9.29 4.63c-.207.468-.558.86-1 1.117-.445.256-.96.365-1.47.312l-1.435-.152a2.212 2.212 0 0 0-2.022 3.502l.847 1.163a2.43 2.43 0 0 1 0 2.858l-.847 1.163a2.21 2.21 0 0 0 .786 3.273c.381.195.81.274 1.236.23l1.43-.153a2.434 2.434 0 0 1 2.475 1.43Z"
    }
  )
);
SvgSettings02$1.displayName = "Settings02";
const SvgTag01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M8 8h.01M2 5.2v4.475c0 .489 0 .733.055.963.05.204.13.4.24.579.123.201.296.374.642.72l7.669 7.669c1.188 1.188 1.782 1.782 2.467 2.004a3 3 0 0 0 1.854 0c.685-.222 1.28-.816 2.467-2.004l2.212-2.212c1.188-1.188 1.782-1.782 2.004-2.467a3 3 0 0 0 0-1.854c-.222-.685-.816-1.28-2.004-2.467l-7.669-7.669c-.346-.346-.519-.519-.72-.642a2.001 2.001 0 0 0-.579-.24C10.409 2 10.165 2 9.676 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2ZM8.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    }
  )
);
SvgTag01.displayName = "Tag01";
const SvgTrash01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M16 6v-.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C8 3.52 8 4.08 8 5.2V6m2 5.5v5m4-5v5M3 6h18m-2 0v11.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C16.72 22 15.88 22 14.2 22H9.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C5 19.72 5 18.88 5 17.2V6"
    }
  )
);
SvgTrash01.displayName = "Trash01";
const SvgUsers02$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M16 3.468a4.5 4.5 0 0 1 0 8.064m2 5.234c1.512.684 2.872 1.799 4 3.234M2 20c1.946-2.477 4.59-4 7.5-4s5.553 1.523 7.5 4M14 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
    }
  )
);
SvgUsers02$1.displayName = "Users02";
const SvgXClose$1 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M18 6 6 18M6 6l12 12"
    }
  )
);
SvgXClose$1.displayName = "XClose";
const lineIcons = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AlertSquare: SvgAlertSquare$1,
  AlertTriangle: SvgAlertTriangle$1,
  ArrowNarrowDown: SvgArrowNarrowDown$1,
  ArrowNarrowLeft: SvgArrowNarrowLeft,
  ArrowNarrowUp: SvgArrowNarrowUp$1,
  BankNote01: SvgBankNote01$1,
  BarChartSquare01: SvgBarChartSquare01,
  Bold01: SvgBold01,
  Calendar: SvgCalendar$1,
  CheckCircle: SvgCheckCircle$1,
  CheckDone02: SvgCheckDone02$1,
  CheckVerified02: SvgCheckVerified02$1,
  Clock: SvgClock$1,
  ClockPlus: SvgClockPlus,
  ClockRefresh: SvgClockRefresh$1,
  CurrencyDollarCircle: SvgCurrencyDollarCircle$1,
  Download01: SvgDownload01$1,
  Eye: SvgEye$1,
  EyeOff: SvgEyeOff,
  File02: SvgFile02$1,
  File05: SvgFile05,
  FilterFunnel01: SvgFilterFunnel01,
  Grid01: SvgGrid01$1,
  Grid02: SvgGrid02$1,
  Inbox01: SvgInbox01,
  Inbox02: SvgInbox02,
  LayoutGrid02: SvgLayoutGrid02,
  Lock01: SvgLock01$1,
  Mail01: SvgMail01,
  MessageTextSquare01: SvgMessageTextSquare01,
  PauseSquare: SvgPauseSquare$1,
  PieChart03: SvgPieChart03$1,
  RefreshCcw04: SvgRefreshCcw04,
  SearchMd: SvgSearchMd$1,
  Settings01: SvgSettings01,
  Settings02: SvgSettings02$1,
  Tag01: SvgTag01,
  Trash01: SvgTrash01,
  Users02: SvgUsers02$1
}, Symbol.toStringTag, { value: "Module" }));
const SvgAlertSquare = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17.838 2H6.162c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A17.9 17.9 0 0 0 17.838 2ZM13 8a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V8Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z",
      clipRule: "evenodd"
    }
  )
);
SvgAlertSquare.displayName = "AlertSquare";
const SvgAlertTriangle = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.813 1.668a2 2 0 0 0-1.626 0c-.4.178-.659.49-.84.746-.177.25-.367.579-.576.94l-8.267 14.28c-.21.362-.4.692-.53.971-.132.285-.274.666-.229 1.102a2 2 0 0 0 .813 1.41c.355.258.757.326 1.069.355.306.028.687.028 1.106.028h16.534c.419 0 .8 0 1.106-.028.312-.029.714-.097 1.069-.354a2 2 0 0 0 .813-1.41c.045-.437-.097-.818-.229-1.103-.13-.28-.32-.609-.53-.971L14.23 3.354c-.21-.361-.4-.69-.577-.94-.18-.255-.44-.568-.84-.746ZM13 9a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V9Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z",
      clipRule: "evenodd"
    }
  )
);
SvgAlertTriangle.displayName = "AlertTriangle";
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M12.707 5.707a1 1 0 0 0-1.414-1.414l-7 7a1 1 0 0 0 0 1.414l7 7a1 1 0 0 0 1.414-1.414L7.414 13H19a1 1 0 1 0 0-2H7.414l5.293-5.293Z"
    }
  )
);
SvgArrowLeft.displayName = "ArrowLeft";
const SvgArrowNarrowDown = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M13 4a1 1 0 1 0-2 0v13.586l-4.293-4.293a1 1 0 0 0-1.414 1.414l6 6a1 1 0 0 0 1.414 0l6-6a1 1 0 0 0-1.414-1.414L13 17.586V4Z"
    }
  )
);
SvgArrowNarrowDown.displayName = "ArrowNarrowDown";
const SvgArrowNarrowUp = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M12.707 3.293a1 1 0 0 0-1.414 0l-6 6a1 1 0 0 0 1.414 1.414L11 6.414V20a1 1 0 1 0 2 0V6.414l4.293 4.293a1 1 0 0 0 1.414-1.414l-6-6Z"
    }
  )
);
SvgArrowNarrowUp.displayName = "ArrowNarrowUp";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M12.707 4.293a1 1 0 1 0-1.414 1.414L16.586 11H5a1 1 0 1 0 0 2h11.586l-5.293 5.293a1 1 0 0 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414l-7-7Z"
    }
  )
);
SvgArrowRight.displayName = "ArrowRight";
const SvgBankNote01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17 3c-2.163 0-4.038.542-5.67 1.044l-.304.094C9.486 4.614 8.235 5 7 5a12.44 12.44 0 0 1-2.343-.222l-.032-.006c-.488-.094-.898-.173-1.217-.215-.279-.037-.693-.08-1.072.053-.198.07-.413.169-.616.337-.203.167-.341.36-.447.541-.195.334-.236.712-.254.983C1 6.761 1 7.13 1 7.555v10.796c0 .197 0 .43.119.76.06.164.156.322.213.409.056.086.161.239.287.36.082.077.175.159.286.232.109.072.208.115.251.134l.008.004c.82.361 2.29.75 4.836.75 2.163 0 4.038-.543 5.67-1.044l.304-.094C14.514 19.386 15.765 19 17 19c.886 0 1.677.094 2.343.222l.032.006c.488.094.898.173 1.216.215.28.037.694.08 1.073-.053.198-.07.413-.169.616-.337.203-.167.341-.36.447-.541.195-.334.236-.712.254-.983.019-.29.019-.659.019-1.084V5.649c0-.197 0-.43-.119-.76a2.108 2.108 0 0 0-.213-.409 2.1 2.1 0 0 0-.287-.36 2.01 2.01 0 0 0-.286-.232c-.109-.072-.208-.115-.251-.134l-.008-.003C21.016 3.389 19.546 3 17 3Zm2 6a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V9ZM8.5 12a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM6 10a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z",
      clipRule: "evenodd"
    }
  )
);
SvgBankNote01.displayName = "BankNote01";
const SvgCalendarPlus02 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M20 15a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16 1a1 1 0 0 1 1 1v1.002c.476.003.891.013 1.252.042.562.046 1.079.145 1.564.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 7.29 22 7.954 22 8.758v4.488c0 .14-.114.254-.255.254a.268.268 0 0 1-.223-.125A3 3 0 1 0 16 21c0 .138.01.273.027.406.105.772.157 1.159.109 1.28-.058.145-.084.176-.22.252-.114.064-.387.064-.934.065-2.408.003-4.816-.003-7.223-.003-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 18.71 2 18.046 2 17.242V8.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392.361-.03.777-.04 1.252-.042V2a1 1 0 0 1 2 0v1h6V2a1 1 0 0 1 1-1ZM7 5.002V6a1 1 0 0 0 2 0V5h6v1a1 1 0 1 0 2 0v-.998c.445.003.795.012 1.089.036.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819C20 7.361 20 7.943 20 8.8V9H4v-.2c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18.294-.024.643-.033 1.089-.036Z",
      clipRule: "evenodd"
    }
  )
);
SvgCalendarPlus02.displayName = "CalendarPlus02";
const SvgCalendar = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16 1a1 1 0 0 1 1 1v1.002c.476.003.891.013 1.252.042.562.046 1.079.145 1.564.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 7.29 22 7.954 22 8.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 18.71 2 18.046 2 17.242V8.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392.361-.03.777-.04 1.252-.042V2a1 1 0 0 1 2 0v1h6V2a1 1 0 0 1 1-1ZM7 5.002V6a1 1 0 0 0 2 0V5h6v1a1 1 0 1 0 2 0v-.998c.445.003.795.012 1.089.036.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819C20 7.361 20 7.943 20 8.8V9H4v-.2c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18.294-.024.643-.033 1.089-.036Z",
      clipRule: "evenodd"
    }
  )
);
SvgCalendar.displayName = "Calendar";
const SvgCheckCircle = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm5.207 8.707a1 1 0 0 0-1.414-1.414L10.5 13.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l6-6Z",
      clipRule: "evenodd"
    }
  )
);
SvgCheckCircle.displayName = "CheckCircle";
const SvgCheckDone02 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18.838 7h-7.677c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C7 10.18 7 10.635 7 11.161v7.678c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031h7.678c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.357v-7.677c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A17.9 17.9 0 0 0 18.838 7Zm.37 6.207a1 1 0 0 0-1.415-1.414L14 15.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M5.161 1h7.678c.527 0 .981 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.028.336.03.736.031 1.195h-5.88c-.49 0-1.02 0-1.478.037-.519.043-1.205.148-1.912.508A5 5 0 0 0 5.545 7.73c-.36.707-.465 1.393-.508 1.912C5 10.101 5 10.631 5 11.12V17c-.459 0-.86-.003-1.195-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 13.82 1 13.365 1 12.839V5.16c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 1 4.635 1 5.161 1Z"
    }
  )
);
SvgCheckDone02.displayName = "CheckDone02";
const SvgCheckVerified02 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.031 12c0-.134-.026-.268-.078-.393L1.23 9.86a3.036 3.036 0 0 1 .658-3.306c.281-.282.616-.505.984-.658l1.744-.722c.252-.105.454-.305.559-.557l.722-1.745a3.033 3.033 0 0 1 3.963-1.641l1.743.722c.253.104.537.104.79 0l.002-.002 1.744-.72a3.034 3.034 0 0 1 3.962 1.642l.705 1.703a1.032 1.032 0 0 0 .576.6l1.745.722a3.033 3.033 0 0 1 1.641 3.962l-.722 1.745a1.035 1.035 0 0 0 0 .79l.722 1.745a3.034 3.034 0 0 1-1.641 3.962l-1.745.723a1.033 1.033 0 0 0-.576.6l-.705 1.702a3.032 3.032 0 0 1-3.962 1.641l-1.744-.72h-.002a1.033 1.033 0 0 0-.79 0l-1.743.721a3.032 3.032 0 0 1-3.963-1.641l-.722-1.745a1.034 1.034 0 0 0-.56-.557l-1.743-.722A3.033 3.033 0 0 1 1.23 14.14l.722-1.747c.052-.126.078-.26.078-.393Zm14.176-1.793a1 1 0 0 0-1.414-1.414L11 12.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z",
      clipRule: "evenodd"
    }
  )
);
SvgCheckVerified02.displayName = "CheckVerified02";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20.707 5.293a1 1 0 0 1 0 1.414l-11 11a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L9 15.586 19.293 5.293a1 1 0 0 1 1.414 0Z",
      clipRule: "evenodd"
    }
  )
);
SvgCheck.displayName = "Check";
const SvgChevronLeft = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15.707 5.293a1 1 0 0 1 0 1.414L10.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0Z",
      clipRule: "evenodd"
    }
  )
);
SvgChevronLeft.displayName = "ChevronLeft";
const SvgChevronRight = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L13.586 12 8.293 6.707a1 1 0 0 1 0-1.414Z",
      clipRule: "evenodd"
    }
  )
);
SvgChevronRight.displayName = "ChevronRight";
const SvgClockRefresh = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m19.54 5.675-.108.406C16.553 2.457 11.379 1.389 7.25 3.773a9.488 9.488 0 0 0-4.698 7.229 1 1 0 0 0 1.989.211A7.502 7.502 0 0 1 17.645 7.06l-.344-.092a1 1 0 1 0-.517 1.932l2.732.732a1 1 0 0 0 1.225-.707l.732-2.732a1 1 0 1 0-1.932-.518ZM20.56 11.898a1 1 0 0 1 .888 1.1 9.488 9.488 0 0 1-4.698 7.23c-4.129 2.383-9.303 1.315-12.182-2.309l-.109.406a1 1 0 0 1-1.932-.518l.733-2.732a1 1 0 0 1 1.224-.707l2.732.732a1 1 0 1 1-.517 1.932l-.345-.093a7.503 7.503 0 0 0 13.105-4.152 1 1 0 0 1 1.1-.889Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M13 7.5a1 1 0 0 0-2 0V12a1 1 0 0 0 .486.857l2.5 1.5a1 1 0 1 0 1.028-1.715L13 11.434V7.5Z"
    }
  )
);
SvgClockRefresh.displayName = "ClockRefresh";
const SvgClockSnooze = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18 19a1 1 0 1 1 0-2h4a1 1 0 0 1 .707 1.707L20.414 21H22a1 1 0 1 1 0 2h-4a1 1 0 0 1-.707-1.707L19.586 19H18Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11c.805 0 1.59-.087 2.345-.25.228-.05.342-.075.423-.131a.44.44 0 0 0 .168-.197c.042-.09.05-.253.068-.58a3 3 0 0 1 .76-1.842A3 3 0 0 1 18 15h4c.163 0 .244 0 .287-.007a.457.457 0 0 0 .375-.298c.017-.04.029-.092.053-.196C22.9 13.696 23 12.86 23 12c0-6.075-4.925-11-11-11Zm0 4a1 1 0 0 1 1 1v5.382l3.447 1.724a1 1 0 1 1-.894 1.788l-4-2A1 1 0 0 1 11 12V6a1 1 0 0 1 1-1Z",
      clipRule: "evenodd"
    }
  )
);
SvgClockSnooze.displayName = "ClockSnooze";
const SvgClockStopwatch = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10 1a1 1 0 0 0 0 2h1v1.052c-4.777.5-8.5 4.539-8.5 9.448a9.5 9.5 0 0 0 19 0c0-4.909-3.723-8.948-8.5-9.448V3h1a1 1 0 1 0 0-2h-4Zm3 8.5a1 1 0 1 0-2 0v4a1 1 0 0 0 .486.857l2.5 1.5a1 1 0 0 0 1.028-1.714L13 12.933V9.5Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M18.122 3.385a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 0-1.414ZM5.878 3.385a1 1 0 0 1 0 1.414l-1.5 1.5a1 1 0 1 1-1.414-1.414l1.5-1.5a1 1 0 0 1 1.414 0Z"
    }
  )
);
SvgClockStopwatch.displayName = "ClockStopwatch";
const SvgClock = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm12-6a1 1 0 1 0-2 0v6a1 1 0 0 0 .553.894l4 2a1 1 0 1 0 .894-1.788L13 11.382V6Z",
      clipRule: "evenodd"
    }
  )
);
SvgClock.displayName = "Clock";
const SvgContrast01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M13 3.055c.19.02.377.048.563.08a1 1 0 1 0 .344-1.97A11.063 11.063 0 0 0 12 1C5.925 1 1 5.925 1 12s4.925 11 11 11c.649 0 1.286-.056 1.905-.165a1 1 0 0 0-.344-1.97 9.036 9.036 0 0 1-.561.08V3.055Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M16.92 3.235a1 1 0 0 1 1.392-.245 11.058 11.058 0 0 1 2.7 2.701 1 1 0 0 1-1.637 1.149 9.056 9.056 0 0 0-2.212-2.212 1 1 0 0 1-.244-1.393ZM21.678 9.28a1 1 0 0 1 1.157.813 11.063 11.063 0 0 1 0 3.814 1 1 0 1 1-1.97-.345 9.063 9.063 0 0 0 0-3.124 1 1 0 0 1 .813-1.157ZM20.764 16.922a1 1 0 0 1 .244 1.393 11.054 11.054 0 0 1-2.697 2.695 1 1 0 1 1-1.148-1.637 9.055 9.055 0 0 0 2.208-2.207 1 1 0 0 1 1.393-.244Z"
    }
  )
);
SvgContrast01.displayName = "Contrast01";
const SvgCopy01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.162 8h6.676c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.357v6.676c0 .528 0 .982-.03 1.357-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.357.031h-6.677c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167A17.9 17.9 0 0 1 8 18.838v-6.677c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C11.18 8 11.635 8 12.162 8Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M11.838 1H5.162c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 4.18 1 4.635 1 5.161v6.678c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H6v-3.88c0-.49 0-1.02.037-1.478.043-.519.148-1.205.508-1.912A5 5 0 0 1 8.73 6.545c.707-.36 1.393-.465 1.912-.508C11.101 6 11.631 6 12.12 6H16v-.839c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C12.82 1 12.365 1 11.838 1Z"
    }
  )
);
SvgCopy01.displayName = "Copy01";
const SvgCurrencyDollarCircle = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm1 4.5a1 1 0 1 0-2 0V6a3.5 3.5 0 1 0 0 7h2a1.5 1.5 0 0 1 0 3h-2.167A1.333 1.333 0 0 1 9.5 14.667a1 1 0 1 0-2 0A3.333 3.333 0 0 0 10.833 18H11v.5a1 1 0 1 0 2 0V18a3.5 3.5 0 1 0 0-7h-2a1.5 1.5 0 0 1 0-3h2.167c.736 0 1.333.597 1.333 1.333a1 1 0 1 0 2 0A3.333 3.333 0 0 0 13.167 6H13v-.5Z",
      clipRule: "evenodd"
    }
  )
);
SvgCurrencyDollarCircle.displayName = "CurrencyDollarCircle";
const SvgDataflow04 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18.032 1H5.968c-.439 0-.817 0-1.13.021a3.07 3.07 0 0 0-.986.207 3 3 0 0 0-1.624 1.624 3.07 3.07 0 0 0-.207.986C2 4.15 2 4.529 2 4.968v.064c0 .439 0 .817.021 1.13.023.33.072.66.207.986a3 3 0 0 0 1.624 1.624c.326.135.656.184.986.207C5.15 9 5.529 9 5.968 9H11v3H8.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564a19.07 19.07 0 0 0-.043 1.423 3.001 3.001 0 1 0 2 0c.002-.529.01-.93.037-1.26.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18C7.361 14 7.943 14 8.8 14H11v3.17a3.001 3.001 0 1 0 2 0V14h2.2c.857 0 1.439 0 1.889.038.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819.027.33.035.731.037 1.26A3.001 3.001 0 0 0 20 23a3 3 0 0 0 1-5.83 19.079 19.079 0 0 0-.044-1.422c-.046-.562-.145-1.079-.392-1.564a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 12 16.046 12 15.242 12H13V9h5.032c.439 0 .817 0 1.13-.021.33-.023.66-.072.986-.207a3 3 0 0 0 1.624-1.624c.135-.326.184-.656.207-.986C22 5.85 22 5.471 22 5.032v-.064c0-.439 0-.817-.021-1.13a3.072 3.072 0 0 0-.207-.986 3 3 0 0 0-1.624-1.624 3.07 3.07 0 0 0-.986-.207C18.85 1 18.471 1 18.032 1Z",
      clipRule: "evenodd"
    }
  )
);
SvgDataflow04.displayName = "Dataflow04";
const SvgDotsHorizontal = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM17 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM3 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
      clipRule: "evenodd"
    }
  )
);
SvgDotsHorizontal.displayName = "DotsHorizontal";
const SvgDotsVertical = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM10 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM10 19a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
      clipRule: "evenodd"
    }
  )
);
SvgDotsVertical.displayName = "DotsVertical";
const SvgDownload01Alt = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M7.226 14.469c-.173-.173-.26-.26-.36-.322a1 1 0 0 0-.29-.12C6.463 14 6.34 14 6.096 14h-.762c-.305 0-.567 0-.802.037a3 3 0 0 0-2.494 2.494 5.274 5.274 0 0 0-.037.802v.15c0 .476 0 .83.05 1.143a4 4 0 0 0 3.324 3.325c.313.05.667.05 1.143.05h10.966c.476 0 .83 0 1.143-.05a4 4 0 0 0 3.325-3.325c.05-.313.05-.666.049-1.143v-.15c0-.305 0-.567-.037-.802a3 3 0 0 0-2.494-2.494 5.278 5.278 0 0 0-.802-.037h-.762c-.244 0-.367 0-.482.028a1 1 0 0 0-.289.12c-.1.061-.187.148-.36.32l-2.653 2.653a3 3 0 0 1-4.242 0L7.226 14.47Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M13 3a1 1 0 1 0-2 0v9.586L7.707 9.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L13 12.586V3Z"
    }
  )
);
SvgDownload01Alt.displayName = "Download01Alt";
const SvgDownload01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M13 3a1 1 0 1 0-2 0v9.586L7.707 9.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L13 12.586V3Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M3 14a1 1 0 0 1 1 1v1.2c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 20 6.943 20 7.8 20h8.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V15a1 1 0 1 1 2 0v1.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V15a1 1 0 0 1 1-1Z"
    }
  )
);
SvgDownload01.displayName = "Download01";
const SvgEye = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 4C9.138 4 6.805 5.265 5.077 6.707c-1.727 1.441-2.91 3.107-3.503 4.046l-.024.038c-.117.185-.27.425-.347.762a2.159 2.159 0 0 0 0 .894c.077.337.23.577.347.762l.024.038c.593.939 1.776 2.605 3.503 4.046C6.805 18.735 9.138 20 12 20s5.195-1.265 6.923-2.707c1.727-1.441 2.91-3.107 3.503-4.046l.024-.038c.117-.185.27-.425.347-.762a2.16 2.16 0 0 0 0-.894c-.077-.337-.23-.577-.347-.762l-.024-.038c-.593-.939-1.776-2.605-3.503-4.046C17.195 5.265 14.862 4 12 4Zm0 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
      clipRule: "evenodd"
    }
  )
);
SvgEye.displayName = "Eye";
const SvgFile02 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15.241 1H8.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23h6.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V6.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 1 16.046 1 15.242 1ZM8 6a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H8Zm-1 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z",
      clipRule: "evenodd"
    }
  )
);
SvgFile02.displayName = "File02";
const SvgFlipBackward = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M7.707 5.707a1 1 0 0 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L5.414 10H16.5a3.5 3.5 0 1 1 0 7H12a1 1 0 1 0 0 2h4.5a5.5 5.5 0 1 0 0-11H5.414l2.293-2.293Z"
    }
  )
);
SvgFlipBackward.displayName = "FlipBackward";
const SvgGrid01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4.568 2h3.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v3.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201C8.93 11 8.684 11 8.432 11H4.568c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.022 2.022 0 0 1-.201-.77C2 8.93 2 8.684 2 8.432V4.568c0-.252 0-.498.017-.706.019-.229.063-.499.201-.77a2 2 0 0 1 .874-.874c.271-.138.541-.182.77-.201C4.07 2 4.316 2 4.568 2ZM4.568 13h3.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v3.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201C8.93 22 8.684 22 8.432 22H4.568c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.022 2.022 0 0 1-.201-.77C2 19.93 2 19.684 2 19.432v-3.864c0-.252 0-.498.017-.706.019-.229.063-.499.201-.77a2 2 0 0 1 .874-.874 2.02 2.02 0 0 1 .77-.201C4.07 13 4.316 13 4.568 13ZM15.568 2h3.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v3.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201c-.208.017-.454.017-.706.017h-3.864c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.02 2.02 0 0 1-.201-.77C13 8.93 13 8.684 13 8.432V4.568c0-.252 0-.498.017-.706a2.02 2.02 0 0 1 .201-.77 2 2 0 0 1 .874-.874c.271-.138.541-.182.77-.201C15.07 2 15.316 2 15.568 2ZM15.568 13h3.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v3.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201c-.208.017-.454.017-.706.017h-3.864c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.02 2.02 0 0 1-.201-.77C13 19.93 13 19.684 13 19.432v-3.864c0-.252 0-.498.017-.706a2.02 2.02 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2.02 2.02 0 0 1 .77-.201c.208-.017.454-.017.706-.017Z",
      clipRule: "evenodd"
    }
  )
);
SvgGrid01.displayName = "Grid01";
const SvgGrid02 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M19.032 4.024C18.75 4 18.377 4 17.8 4H16a1 1 0 1 1 0-2h1.838c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V8a1 1 0 1 1-2 0V6.2c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085ZM8 2H6.161c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V8a1 1 0 1 0 2 0V6.2c0-.577 0-.949.024-1.232.022-.272.06-.373.085-.422a1 1 0 0 1 .437-.437c.05-.025.15-.063.422-.085C5.25 4 5.623 4 6.2 4H8a1 1 0 1 0 0-2ZM4 16a1 1 0 1 0-2 0v1.838c0 .528 0 .982.03 1.357.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H8a1 1 0 1 0 0-2H6.2c-.577 0-.949 0-1.232-.024-.272-.022-.373-.06-.422-.085a1 1 0 0 1-.437-.437c-.025-.05-.063-.15-.085-.422C4 18.75 4 18.377 4 17.8V16ZM22 16a1 1 0 1 0-2 0v1.8c0 .577 0 .949-.024 1.232-.022.272-.06.372-.085.422a1 1 0 0 1-.437.437c-.05.025-.15.063-.422.085C18.75 20 18.377 20 17.8 20H16a1 1 0 1 0 0 2h1.838c.528 0 .982 0 1.357-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.357V16ZM12 6a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2h-4v4a1 1 0 1 1-2 0v-4H7a1 1 0 1 1 0-2h4V7a1 1 0 0 1 1-1Z"
    }
  )
);
SvgGrid02.displayName = "Grid02";
const SvgHand = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 3c-.405 0-.7.317-.7.667v7.222a1 1 0 1 1-2 0V4.778a.684.684 0 0 0-.7-.667c-.405 0-.7.317-.7.667v9.444a1 1 0 1 1-2 0v-2.778a.684.684 0 0 0-.7-.666c-.405 0-.7.317-.7.666v2.223C4.5 17.698 7.84 21 12 21s7.5-3.302 7.5-7.333V8.11a.684.684 0 0 0-.7-.667c-.405 0-.7.317-.7.667v2.778a1 1 0 1 1-2 0V4.778a.684.684 0 0 0-.7-.667c-.405 0-.7.317-.7.667v6.11a1 1 0 1 1-2 0V3.668A.684.684 0 0 0 12 3Zm2.336-.673A2.712 2.712 0 0 0 12 1c-.988 0-1.865.529-2.336 1.327A2.72 2.72 0 0 0 8.6 2.11c-1.472 0-2.7 1.175-2.7 2.667v4.09a2.728 2.728 0 0 0-.7-.09c-1.472 0-2.7 1.175-2.7 2.666v2.223C2.5 18.84 6.772 23 12 23s9.5-4.16 9.5-9.333V8.11c0-1.491-1.228-2.667-2.7-2.667-.241 0-.476.032-.7.091v-.757c0-1.492-1.228-2.667-2.7-2.667a2.72 2.72 0 0 0-1.064.216Z",
      clipRule: "evenodd"
    }
  )
);
SvgHand.displayName = "Hand";
const SvgHelpCircle = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm-1.093 7.271a2 2 0 0 1 3.013 1.727V10c0 .47-.365.958-1.055 1.418a6.05 6.05 0 0 1-1.262.634 1 1 0 0 0 .633 1.897l.169-.061a8.05 8.05 0 0 0 1.57-.806c.81-.54 1.944-1.55 1.945-3.081a4 4 0 0 0-7.773-1.333 1 1 0 0 0 1.886.664 2 2 0 0 1 .874-1.06ZM12 16a1 1 0 1 0 0 2h.01a1 1 0 0 0 0-2H12Z",
      clipRule: "evenodd"
    }
  )
);
SvgHelpCircle.displayName = "HelpCircle";
const SvgLinkExternal01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M14 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V5.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L18.586 4H15a1 1 0 0 1-1-1Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M7.759 4H10a1 1 0 1 1 0 2H7.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 8.361 4 8.943 4 9.8v6.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 20 6.943 20 7.8 20h6.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V14a1 1 0 1 1 2 0v2.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V9.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 4 6.954 4 7.758 4Z"
    }
  )
);
SvgLinkExternal01.displayName = "LinkExternal01";
const SvgLock01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6 8a6 6 0 1 1 12 0v1.15c.283.062.554.152.816.286a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v1.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 17.71 3 17.046 3 16.242v-1.483c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.262-.134.533-.224.816-.286V8Zm10 0v1.002H8V8a4 4 0 1 1 8 0Zm-3 6.5a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Z",
      clipRule: "evenodd"
    }
  )
);
SvgLock01.displayName = "Lock01";
const SvgLockUnlocked01 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6 8a6 6 0 0 1 11.5-2.4 1 1 0 0 1-1.832.8A4.001 4.001 0 0 0 8 8v1.002C8.238 9 8.49 9 8.759 9h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v1.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 17.71 3 17.046 3 16.242v-1.483c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.262-.134.533-.224.816-.286V8Zm7 6.5a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Z",
      clipRule: "evenodd"
    }
  )
);
SvgLockUnlocked01.displayName = "LockUnlocked01";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z",
      clipRule: "evenodd"
    }
  )
);
SvgMinus.displayName = "Minus";
const SvgPauseSquare = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17.838 2H6.162c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A17.9 17.9 0 0 0 17.838 2ZM10.5 9a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0V9Zm5 0a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0V9Z",
      clipRule: "evenodd"
    }
  )
);
SvgPauseSquare.displayName = "PauseSquare";
const SvgPieChart03 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M11 2.796c0-.593 0-.889-.145-1.128a1.092 1.092 0 0 0-.563-.437c-.268-.082-.517-.018-1.016.109C4.518 2.552 1 6.865 1 12c0 6.075 4.925 11 11 11 1.435 0 2.806-.275 4.062-.774.479-.19.718-.286.886-.51.135-.178.217-.46.199-.684-.023-.279-.197-.518-.545-.997l-5.404-7.438A.996.996 0 0 1 11 12V2.796Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M21.204 13c.593 0 .889 0 1.128.145.19.117.372.349.437.563.082.268.018.517-.109 1.016a10.967 10.967 0 0 1-2.19 4.295c-.33.398-.495.596-.76.688a1.09 1.09 0 0 1-.712-.023c-.258-.108-.432-.348-.78-.828l-3.332-4.586c-.298-.41-.447-.615-.442-.786a.5.5 0 0 1 .193-.38c.136-.104.39-.104.896-.104h5.671ZM13 2.796c0-.593 0-.889.145-1.128.117-.191.349-.372.563-.437.268-.082.517-.018 1.016.109 3.886.99 6.946 4.05 7.936 7.936.127.499.19.748.109 1.016a1.093 1.093 0 0 1-.437.563c-.24.145-.535.145-1.128.145H13.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C13 10.62 13 10.48 13 10.2V2.796Z"
    }
  )
);
SvgPieChart03.displayName = "PieChart03";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M13 5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V5Z"
    }
  )
);
SvgPlus.displayName = "Plus";
const SvgReceiptCheck = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.759 2h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C21 6.29 21 6.954 21 7.758V21a1 1 0 0 1-1.588.809l-2.133-1.552-1.904 1.524a1 1 0 0 1-1.213.028L12 20.236 9.838 21.81a1 1 0 0 1-1.213-.028l-1.904-1.523-2.133 1.55A1 1 0 0 1 3 21V7.759c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C7.29 2 7.954 2 8.758 2Zm7.448 6.707a1 1 0 0 0-1.414-1.414L11 11.086 9.707 9.793a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z",
      clipRule: "evenodd"
    }
  )
);
SvgReceiptCheck.displayName = "ReceiptCheck";
const SvgSearchMd = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11 2a9 9 0 1 0 5.618 16.032l3.675 3.675a1 1 0 0 0 1.414-1.414l-3.675-3.675A9 9 0 0 0 11 2Zm-7 9a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z",
      clipRule: "evenodd"
    }
  )
);
SvgSearchMd.displayName = "SearchMd";
const SvgSettings02 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m9.742 21.554-.652-1.446a2.682 2.682 0 0 0-1.122-1.228 2.75 2.75 0 0 0-1.64-.344l-1.597.168a2.504 2.504 0 0 1-1.381-.252 2.457 2.457 0 0 1-1.019-.952 2.404 2.404 0 0 1 .142-2.649l.945-1.28a2.645 2.645 0 0 0 0-3.143l-.945-1.28A2.41 2.41 0 0 1 2.33 6.5a2.455 2.455 0 0 1 1.019-.952 2.502 2.502 0 0 1 1.38-.252l1.602.168a2.75 2.75 0 0 0 1.641-.344A2.682 2.682 0 0 0 9.09 3.892l.652-1.446c.194-.43.51-.796.911-1.053a2.497 2.497 0 0 1 2.694 0c.4.257.717.622.91 1.053l.658 1.446c.231.515.622.945 1.117 1.228a2.75 2.75 0 0 0 1.64.344l1.598-.168c.475-.05.954.038 1.38.252.426.213.78.544 1.019.952a2.403 2.403 0 0 1-.142 2.649l-.945 1.28A2.645 2.645 0 0 0 20.063 12a2.645 2.645 0 0 0 .514 1.578l.945 1.28a2.41 2.41 0 0 1 .142 2.648 2.454 2.454 0 0 1-1.019.953 2.502 2.502 0 0 1-1.38.251l-1.597-.167a2.75 2.75 0 0 0-1.641.343c-.494.281-.885.71-1.117 1.222l-.652 1.446c-.194.43-.51.796-.911 1.053a2.497 2.497 0 0 1-2.694 0 2.444 2.444 0 0 1-.91-1.053ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
      clipRule: "evenodd"
    }
  )
);
SvgSettings02.displayName = "Settings02";
const SvgShare04 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M14 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V5.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L18.586 4H15a1 1 0 0 1-1-1Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M7.759 4H10a1 1 0 1 1 0 2H7.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 8.361 4 8.943 4 9.8v6.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 20 6.943 20 7.8 20h6.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V14a1 1 0 1 1 2 0v2.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V9.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 4 6.954 4 7.758 4Z"
    }
  )
);
SvgShare04.displayName = "Share04";
const SvgUsers02 = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15.104 3.023a1 1 0 0 1 1.341-.45 5.5 5.5 0 0 1 0 9.855 1 1 0 0 1-.89-1.791 3.5 3.5 0 0 0 0-6.274 1 1 0 0 1-.45-1.34ZM17.089 16.354a1 1 0 0 1 1.323-.499c1.678.76 3.162 1.984 4.374 3.527a1 1 0 1 1-1.572 1.236c-1.043-1.327-2.281-2.332-3.626-2.94a1 1 0 0 1-.5-1.324Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM1.214 19.382C3.305 16.72 6.217 15 9.5 15c3.283 0 6.195 1.72 8.286 4.382A1 1 0 0 1 17 21H2a1 1 0 0 1-.786-1.618Z",
      clipRule: "evenodd"
    }
  )
);
SvgUsers02.displayName = "Users02";
const SvgXCircle = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm3.707 7.293a1 1 0 0 1 0 1.414L13.414 12l2.293 2.293a1 1 0 0 1-1.414 1.414L12 13.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L10.586 12 8.293 9.707a1 1 0 0 1 1.414-1.414L12 10.586l2.293-2.293a1 1 0 0 1 1.414 0Z",
      clipRule: "evenodd"
    }
  )
);
SvgXCircle.displayName = "XCircle";
const SvgXClose = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M18.707 6.707a1 1 0 0 0-1.414-1.414L12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293Z"
    }
  )
);
SvgXClose.displayName = "XClose";
const SvgX = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M17.707 7.707a1 1 0 0 0-1.414-1.414L12 10.586 7.707 6.293a1 1 0 0 0-1.414 1.414L10.586 12l-4.293 4.293a1 1 0 1 0 1.414 1.414L12 13.414l4.293 4.293a1 1 0 0 0 1.414-1.414L13.414 12l4.293-4.293Z"
    }
  )
);
SvgX.displayName = "X";
const solidIcons = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AlertSquare: SvgAlertSquare,
  ArrowNarrowDown: SvgArrowNarrowDown,
  ArrowNarrowUp: SvgArrowNarrowUp,
  ArrowRight: SvgArrowRight,
  BankNote01: SvgBankNote01,
  Calendar: SvgCalendar,
  CalendarPlus02: SvgCalendarPlus02,
  Check: SvgCheck,
  CheckCircle: SvgCheckCircle,
  CheckDone02: SvgCheckDone02,
  CheckVerified02: SvgCheckVerified02,
  ChevronLeft: SvgChevronLeft,
  ChevronRight: SvgChevronRight,
  Clock: SvgClock,
  ClockRefresh: SvgClockRefresh,
  ClockSnooze: SvgClockSnooze,
  ClockStopwatch: SvgClockStopwatch,
  Contrast01: SvgContrast01,
  Copy01: SvgCopy01,
  CurrencyDollarCircle: SvgCurrencyDollarCircle,
  Dataflow04: SvgDataflow04,
  DotsHorizontal: SvgDotsHorizontal,
  Download01: SvgDownload01,
  Download01Alt: SvgDownload01Alt,
  Eye: SvgEye,
  File02: SvgFile02,
  FlipBackward: SvgFlipBackward,
  Grid01: SvgGrid01,
  Grid02: SvgGrid02,
  HelpCircle: SvgHelpCircle,
  LinkExternal01: SvgLinkExternal01,
  Lock01: SvgLock01,
  LockUnlocked01: SvgLockUnlocked01,
  PauseSquare: SvgPauseSquare,
  PieChart03: SvgPieChart03,
  Plus: SvgPlus,
  ReceiptCheck: SvgReceiptCheck,
  SearchMd: SvgSearchMd,
  Settings02: SvgSettings02,
  Share04: SvgShare04,
  Users02: SvgUsers02,
  XCircle: SvgXCircle,
  XClose: SvgXClose
}, Symbol.toStringTag, { value: "Module" }));
const DEFAULT_STROKE_WIDTH = 1.5;
const Icons = {
  line: lineIcons,
  solid: solidIcons
};
function Icon$2({
  name,
  type = "line",
  ...props
}) {
  const iconName = Icons[type][name];
  if (!iconName) {
    if (process.env.NODE_ENV === "development") {
      throw new Error(`Icon not found: ${type}/${name}`);
    } else {
      console.error(`Icon not found: ${type}/${name}`);
    }
    return null;
  }
  return React__default.createElement(Icons[type][name], {
    strokeWidth: DEFAULT_STROKE_WIDTH,
    ...props
  });
}
const iconNames = Array.from(
  /* @__PURE__ */ new Set([...Object.keys(Icons.solid), ...Object.keys(Icons.line)])
);
const MappedIcons = iconNames.reduce(
  (iconMap, iconName) => {
    iconMap[iconName] = (props) => /* @__PURE__ */ React__default.createElement(Icon$2, { ...props, name: iconName });
    return iconMap;
  },
  {}
);
const Icon$3 = Object.assign(Icon$2, MappedIcons);
const Brain = (props) => {
  return /* @__PURE__ */ React__default.createElement(
    "svg",
    {
      "data-testid": "brain_icon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 19 22",
      fill: "currentColor",
      ...props
    },
    /* @__PURE__ */ React__default.createElement("path", { d: "M14.242 13.657l.022.02c.732.658 2.1.924 3.438.772.012.1.02.2.02.3 0 1.33-1.06 2.4-2.376 2.4-.256 0-.51-.04-.73-.11-.22 1.11-1.17 1.96-2.34 1.96-1.314 0-2.374-1.04-2.374-2.37h-.037V3.7c.037-.74.84-1.7 1.864-1.7.8 0 1.49.628 1.75 1.367.25-.147.55-.22.87-.22 1.02 0 1.86.85 1.86 1.883 0 .15-.02.3-.05.443l-.04.07c-.11.19-.23.377-.37.55-.278.348-.56.584-.82.664-.084.024-.17.04-.264.046-.3.02-.643-.06-.99-.205-.11-.047-.216-.097-.308-.147-.055-.02-.09-.05-.105-.05l-.54.89c.03.02.09.057.16.098.12.066.255.13.4.19.48.2.967.31 1.445.28.17-.01.33-.04.49-.09.495-.15.93-.51 1.32-1.01.17-.215.32-.444.45-.673L17 6.07c.628.303 1.067.954 1.067 1.7 0 .517-.22.997-.55 1.33.84.37 1.462 1.22 1.462 2.217 0 1.023-.64 1.878-1.46 2.21-1.09.113-2.18-.103-2.677-.547-.217-.2-.39-.41-.525-.64-.344-.574-.416-1.187-.334-1.723.01-.065.02-.107.022-.12l-.89-.25c-.01.05-.03.124-.043.225-.11.73-.015 1.552.446 2.336-.705.164-1.266.53-1.69 1.037-.207.244-.366.51-.48.77-.075.162-.12.293-.14.38l.89.233.014-.045c.02-.054.04-.11.07-.178.087-.19.2-.38.348-.555.39-.466.93-.757 1.677-.797zm-9.177-5.74c-.233.007-.475-.017-.725-.073-.744-.167-1.328-.52-1.762-1.003-.22-.24-.39-.51-.51-.77l-.018-.04c-.667.29-1.14.96-1.14 1.74 0 .52.22 1 .55 1.33C.622 9.47 0 10.32 0 11.32c0 1.07.694 1.96 1.57 2.253-.182.37-.29.776-.29 1.183 0 1.33 1.058 2.406 2.374 2.406.218 0 .437-.028.633-.08 1.368-.577 1.937-1.75 1.326-3.155-.207-.472-.505-.786-.876-.98-.378-.196-.783-.25-1.118-.22l-.04.004-.14-.95c.02 0 .05-.01.1-.01.49-.04 1.07.03 1.62.32.56.29 1.01.77 1.31 1.45.83 1.91.02 3.6-1.74 4.39.43.64 1.16 1.07 1.99 1.07 1.31 0 2.37-1.03 2.37-2.36h.036V3.7C9.1 2.96 8.294 2 7.27 2c-.803 0-1.497.628-1.753 1.367-.255-.147-.548-.22-.877-.22-1.023 0-1.863.85-1.863 1.883 0 .143.017.285.047.424l.01-.003c.008.03.033.11.08.21.085.19.2.37.355.54.3.34.72.59 1.27.72.66.15 1.23-.03 1.72-.45.13-.11.25-.23.34-.35.05-.07.09-.12.1-.14l.79.51c-.035.057-.09.14-.175.24-.133.167-.29.33-.47.48-.138.12-.28.22-.43.31.3.19.57.41.803.65.28.3.5.61.667.94.06.11.107.21.15.316l.035.087c-.023-.046-.038-.07-.088-.123l-.66.676c-.077-.08-.227-.44-.265-.51-.128-.25-.295-.49-.51-.72-.38-.4-.874-.71-1.5-.892l.003-.01z" })
  );
};
const BrainOutline = (props) => {
  return /* @__PURE__ */ React__default.createElement(
    "svg",
    {
      width: "16",
      height: "15",
      viewBox: "0 0 16 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      stroke: "currentColor"
    },
    /* @__PURE__ */ React__default.createElement(
      "path",
      {
        d: "M8.06044 11.7852C8.06044 8.84995 8.06044 5.7 8.06044 2.98493M8.06044 11.7852C8.1384 14.3704 4.15709 13.6221 4.81819 12.1813M8.06044 11.7852C8.16229 14.2482 11.5297 13.7712 11.804 12.3847C12.7638 12.5239 14.8542 10.8538 13.4038 9.81528M8.06044 2.98493C8.06044 2.71728 7.78314 1.92505 7.0579 1.60387C6.33266 1.2827 5.51143 1.76446 5.18081 2.25693C4.03964 2.03211 2.88637 3.28041 3.17932 4.2054M8.06044 2.98493C8.08809 1.35485 10.1054 1.03377 10.9507 2.25693C12.2093 2.05351 13.2267 3.3747 12.8172 4.39811M6.00001 4.83333C5.5914 5.1626 5.04031 5.4161 4.66668 5.4M4.66668 5.4C5.30015 5.82913 5.28972 5.82783 5.66668 6.5M4.66668 5.4C3.79591 5.17852 3.51026 4.88364 3.17932 4.2054M3.17932 4.2054C2.61287 4.30176 1.61007 4.89486 2.13054 6.49646C1.24533 7.12811 0.850718 8.76611 2.26919 9.75105C1.8959 11.9886 3.68767 12.556 4.81819 12.1813M4.40225 8.64834C6.40732 9.38705 5.86767 11.5251 4.81819 12.1813M12.8172 4.39811C12.4925 5.20962 11.4649 5.62016 10.6735 5.25457M12.8172 4.39811C13.9878 4.99821 14.1981 5.46657 13.9264 6.48575C15.3662 7.65269 14.4383 9.46199 13.4038 9.81528M13.4038 9.81528C12.8556 10.0665 11.9487 9.95469 11.3027 9.22821M10.7481 7.69552C10.7757 8.38183 10.9934 8.88038 11.3027 9.22821M11.3027 9.22821C10.8832 9.32398 10.0335 9.56905 9.66025 10.3506",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  );
};
const MemoryApp = React__default.forwardRef((props, ref) => /* @__PURE__ */ React__default.createElement(
  "svg",
  {
    "data-testid": "memory_app_icon",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props
  },
  /* @__PURE__ */ React__default.createElement("g", { clipPath: "url(#clip0_1162_7817)" }, /* @__PURE__ */ React__default.createElement("g", { clipPath: "url(#clip1_1162_7817)" }, /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M1 7.22222C1 4.28904 1 2.82245 1.91122 1.91122C2.82245 1 4.28904 1 7.22222 1H8.77778C11.711 1 13.1776 1 14.0888 1.91122C15 2.82245 15 4.28904 15 7.22222V8.77778C15 11.711 15 13.1776 14.0888 14.0888C13.1776 15 11.711 15 8.77778 15H7.22222C4.28904 15 2.82245 15 1.91122 14.0888C1 13.1776 1 11.711 1 8.77778V7.22222Z",
      fill: "#FE435E"
    }
  )), /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M10.7583 9.78605C11.0855 9.98116 11.5495 10.0736 12.0335 10.0632C12.2174 10.0592 12.3614 10.2164 12.3316 10.3899C12.2239 11.0187 11.568 11.4876 10.9046 11.3577C10.8286 11.3429 10.7536 11.3868 10.7322 11.4581C10.3649 12.6809 8.35346 12.4865 8.35877 11.1191L8.34949 4.82598C8.34928 4.69318 8.37755 4.56118 8.43626 4.44084C8.7491 3.79987 9.7574 3.68701 10.1304 4.44124C10.1639 4.50884 10.2456 4.54204 10.3187 4.51542C10.9208 4.29598 11.6 4.80574 11.58 5.4189C11.5765 5.52687 11.542 5.63195 11.4834 5.72428C11.1544 6.24292 10.8328 6.39466 10.2894 6.17293C9.95574 6.0501 9.74968 6.49416 10.0696 6.6477C10.7834 6.95697 11.3679 6.77691 11.8178 6.15757C11.9409 5.98818 12.1546 5.97931 12.2902 6.13973C12.5535 6.45129 12.5948 6.94391 12.355 7.2774C12.306 7.3454 12.3288 7.43872 12.4028 7.48099C12.5817 7.58308 12.718 7.72765 12.8119 7.89425C13.309 8.77609 12.462 9.79672 11.4443 9.55894C10.798 9.40799 10.3901 8.93561 10.4326 8.27301C10.4394 8.16702 10.3689 8.07061 10.2621 8.0416C10.1182 8.00242 9.97212 8.09963 9.96242 8.2423C9.94532 8.49424 9.98275 8.75436 10.094 9.01398C10.1427 9.12753 10.0849 9.25994 9.96628 9.30649C9.59868 9.45076 9.30398 9.72892 9.13421 10.0597C9.00782 10.3308 9.40503 10.5226 9.55697 10.2611C9.75803 9.85375 10.3094 9.51158 10.7582 9.78615L10.7583 9.78605ZM5.10039 6.68199C4.81247 6.56186 4.57877 6.37562 4.40994 6.13823C4.29054 5.97044 4.08041 5.95708 3.94099 6.11012C3.65765 6.42108 3.60249 6.93264 3.84963 7.27641C3.89896 7.3451 3.87936 7.43932 3.80479 7.48229C3.01257 7.93931 3.05616 9.18087 3.88478 9.55913C3.95527 9.59134 3.9875 9.6709 3.95861 9.74029C3.59654 10.6085 4.41755 11.6119 5.40343 11.3426C6.56993 10.9939 6.36679 9.27708 5.23929 9.19423C5.12323 9.18566 5.02896 9.10111 5.01227 8.99104C4.98975 8.84259 5.11603 8.71099 5.27256 8.72156C6.75263 8.82195 7.16423 10.864 5.9459 11.6109C5.77061 11.7183 5.76393 11.9627 5.9337 12.0781C6.66138 12.5726 7.89722 12.1111 7.86125 11.125L7.86333 4.81731C7.86333 4.70076 7.84175 4.58471 7.79586 4.47673C7.5095 3.80306 6.46168 3.67455 6.08491 4.44094C6.05165 4.50864 5.96979 4.54194 5.89668 4.51532C5.23397 4.27434 4.47105 4.91192 4.65959 5.60583L4.6647 5.60434C4.92551 6.36156 5.96082 6.61081 6.51122 6.01889C6.58828 5.93604 6.7179 5.92098 6.81488 5.9817C6.94002 6.05648 6.96307 6.22188 6.86306 6.32577C6.81937 6.37123 6.77234 6.4153 6.72343 6.45667C6.61539 6.5479 6.61633 6.70931 6.72656 6.79824C6.9346 6.96604 7.11459 7.16813 7.22294 7.39804C7.2633 7.48388 7.24525 7.58448 7.17705 7.65237C7.06297 7.76573 6.86682 7.73842 6.79017 7.59913C6.72729 7.48488 6.65825 7.37521 6.5522 7.27481C6.28253 6.9782 5.9652 6.8479 5.54703 6.79695C5.39342 6.77821 5.24253 6.74112 5.1006 6.68189L5.10039 6.68199Z",
      fill: "white"
    }
  )),
  /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("clipPath", { id: "clip0_1162_7817" }, /* @__PURE__ */ React__default.createElement("rect", { width: 14, height: 14, fill: "white", transform: "translate(1 1)" })), /* @__PURE__ */ React__default.createElement("clipPath", { id: "clip1_1162_7817" }, /* @__PURE__ */ React__default.createElement("rect", { width: 14, height: 14, fill: "white", transform: "translate(1 1)" })))
));
const Sparkling = React__default.forwardRef((props, ref) => /* @__PURE__ */ React__default.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...props,
    ref
  },
  /* @__PURE__ */ React__default.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M14.896 20.972c-.171 0-.265-.093-.28-.28-.18-1.472-.374-2.701-.584-3.69-.203-.994-.471-1.802-.806-2.422-.327-.62-.755-1.107-1.284-1.46-.53-.354-1.195-.628-1.997-.822-.802-.195-1.783-.368-2.943-.52-.21-.029-.315-.119-.315-.27 0-.144.105-.234.315-.27 1.16-.145 2.141-.31 2.943-.498.802-.195 1.463-.458 1.985-.79.53-.339.957-.793 1.284-1.363.327-.577.592-1.316.794-2.217.203-.909.386-2.03.55-3.364.015-.195.108-.292.28-.292.163 0 .26.097.292.292.179 1.334.37 2.455.572 3.364.21.901.475 1.64.794 2.217.319.57.74 1.024 1.26 1.363.523.332 1.18.595 1.974.79.802.187 1.787.353 2.955.497.21.037.315.127.315.27 0 .152-.105.242-.315.271-1.168.152-2.149.325-2.943.52-.794.194-1.452.468-1.973.822-.514.353-.935.84-1.262 1.46-.319.62-.58 1.428-.782 2.423-.195.988-.374 2.217-.537 3.688-.024.188-.12.281-.292.281ZM4.526 10.826c-.147 0-.23-.086-.245-.26a20.762 20.762 0 0 0-.268-2.044c-.101-.519-.253-.915-.456-1.19a1.693 1.693 0 0 0-.852-.594c-.366-.123-.845-.217-1.436-.282C1.089 6.442 1 6.374 1 6.251c0-.137.09-.216.269-.238.599-.065 1.078-.155 1.436-.27.366-.123.65-.31.852-.563.203-.26.355-.62.456-1.082.1-.468.19-1.088.268-1.86.024-.159.105-.238.246-.238.132 0 .21.076.233.227.078.772.167 1.396.269 1.871.1.47.253.83.455 1.082.202.252.487.44.853.563.365.115.844.205 1.436.27.179.022.268.1.268.238 0 .05-.02.097-.058.14-.039.037-.105.058-.198.065-.608.065-1.094.16-1.46.282-.358.122-.639.32-.84.595-.203.274-.355.667-.456 1.179a20.75 20.75 0 0 0-.269 2.055c-.015.173-.093.26-.233.26ZM7.949 22c-.148 0-.226-.087-.234-.26-.077-.858-.17-1.543-.28-2.055-.101-.512-.253-.905-.455-1.179a1.693 1.693 0 0 0-.853-.595c-.366-.122-.844-.216-1.436-.28-.179-.015-.269-.084-.269-.206 0-.145.09-.224.269-.238.6-.065 1.082-.155 1.448-.27.366-.123.646-.31.84-.563.203-.26.355-.62.456-1.082.11-.469.203-1.089.28-1.86.016-.16.094-.238.234-.238.132 0 .21.075.234.227.077.771.167 1.395.268 1.871.11.469.26.83.456 1.082.202.252.486.44.852.562.366.116.849.206 1.448.27.093.008.16.033.199.076a.234.234 0 0 1 .058.163c0 .122-.086.19-.257.205-.6.065-1.082.159-1.448.281-.366.116-.65.314-.852.595-.203.274-.355.667-.456 1.18a20.75 20.75 0 0 0-.268 2.054c-.016.174-.094.26-.234.26Z"
    }
  )
));
const SparklingOff = React__default.forwardRef(
  (props, ref) => /* @__PURE__ */ React__default.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      ...props,
      ref
    },
    /* @__PURE__ */ React__default.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.293 2.293a1 1 0 0 1 1.414 0l18 18a1 1 0 0 1-1.414 1.414l-4.59-4.59.022-.114a13.71 13.71 0 0 0 0-.001l-.022.114-2.41-2.41a4.997 4.997 0 0 0-.067-.127c-.327-.62-.755-1.107-1.285-1.46a4.79 4.79 0 0 0-.552-.316L9.437 10.85 2.293 3.707a1 1 0 0 1 0-1.414Zm9.096 10.51a7.073 7.073 0 0 0-1.444-.506c-.802-.194-1.783-.367-2.943-.519-.21-.029-.315-.119-.315-.27 0-.144.105-.234.315-.27a32.014 32.014 0 0 0 2.435-.387l1.952 1.953Zm0 0c.199.098.383.203.553.316.529.354.957.84 1.284 1.46l.066.127-1.903-1.902Zm6.082.545c.096-.082.195-.158.298-.229.521-.353 1.179-.627 1.973-.822.794-.194 1.775-.367 2.943-.519.21-.029.315-.119.315-.27 0-.144-.105-.234-.315-.27-1.168-.145-2.153-.31-2.955-.498-.794-.195-1.451-.458-1.973-.79a3.82 3.82 0 0 1-1.261-1.363c-.32-.577-.584-1.316-.794-2.217-.203-.909-.393-2.03-.572-3.364-.032-.195-.129-.292-.292-.292-.172 0-.265.097-.28.292-.164 1.334-.347 2.455-.55 3.364-.202.901-.467 1.64-.794 2.217a4.3 4.3 0 0 1-.194.31l4.451 4.45ZM7.714 21.74c.008.174.086.26.234.26.14 0 .218-.087.234-.26a20.75 20.75 0 0 1 .268-2.055c.101-.512.253-.905.456-1.179.202-.281.486-.48.852-.595.366-.122.849-.216 1.448-.28.171-.015.257-.084.257-.206a.234.234 0 0 0-.058-.163c-.04-.043-.106-.068-.2-.075-.598-.065-1.081-.155-1.447-.27-.366-.123-.65-.31-.852-.563-.195-.253-.347-.613-.456-1.082-.101-.476-.19-1.1-.268-1.871-.024-.152-.102-.227-.234-.227-.14 0-.218.079-.234.238-.077.771-.17 1.391-.28 1.86-.101.462-.253.822-.455 1.082-.195.252-.475.44-.841.562-.366.116-.849.206-1.448.27-.179.015-.269.094-.269.239 0 .122.09.19.269.205.592.065 1.07.159 1.436.281.366.123.65.321.853.595.202.274.354.667.455 1.18.11.511.203 1.196.28 2.054Zm6.902-1.048c-.18-1.471-.374-2.7-.584-3.689-.189-.928-.435-1.694-.74-2.296l2.411 2.41a46.75 46.75 0 0 0-.515 3.575c-.023.187-.12.28-.292.28-.171 0-.264-.093-.28-.28Z",
        clipRule: "evenodd"
      }
    )
  )
);
const BorderlessStar = (props) => /* @__PURE__ */ React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React__default.createElement("g", { fill: "none", fillRule: "nonzero" }, /* @__PURE__ */ React__default.createElement("rect", { width: "16", height: "16", fill: props.color || "red", rx: "8" }), /* @__PURE__ */ React__default.createElement(
  "path",
  {
    fill: "#FFF",
    d: "M8 10.585l-2.821 1.298.363-3.084-2.107-2.282 3.046-.608L8 3.2l1.52 2.709 3.045.608-2.107 2.282.363 3.084z"
  }
)));
const Info = ({
  backgroundColor,
  color,
  ...props
}) => {
  return /* @__PURE__ */ React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React__default.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React__default.createElement(
    "circle",
    {
      cx: "9",
      cy: "9",
      r: "9",
      fill: backgroundColor || "#32386F",
      fillOpacity: backgroundColor ? "1" : ".089"
    }
  ), /* @__PURE__ */ React__default.createElement(
    "path",
    {
      fill: color || "#000",
      fillOpacity: color ? "1" : ".416",
      fillRule: "nonzero",
      d: "M11.086 5.498a.96.96 0 0 1-.294.703.96.96 0 0 1-.704.294.96.96 0 0 1-.703-.294.96.96 0 0 1-.294-.703c0-.277.098-.513.294-.707a.965.965 0 0 1 .703-.291c.273 0 .508.097.704.291.196.194.294.43.294.707zm-1.074 6.305h.645c-.545 1.164-1.308 1.746-2.289 1.746-.397 0-.695-.083-.895-.25-.2-.165-.3-.413-.3-.741 0-.192.082-.529.248-1.01L8.19 9.34c.06-.17.09-.281.09-.332 0-.052-.012-.089-.036-.112-.023-.024-.06-.035-.112-.035-.217 0-.473.277-.767.83H6.75C7.3 8.504 8.076 7.91 9.078 7.91c.354 0 .629.086.825.259.196.172.294.41.294.713 0 .221-.087.573-.262 1.055l-.742 2.02c-.107.286-.16.466-.16.538a.14.14 0 0 0 .042.109c.027.025.067.038.118.038.11 0 .253-.096.425-.288a2.64 2.64 0 0 0 .394-.55z"
    }
  )));
};
const Integration = (props) => /* @__PURE__ */ React__default.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    ...props
  },
  /* @__PURE__ */ React__default.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M13.5385 13.5383L11.2308 15.8458M10.4615 10.4616L8.15385 12.7691M5.84616 10.4616L13.5385 18.1533M5.27501 18.7261L2.00001 22.0009M12.3846 16.9995L9.59612 19.7877C9.16334 20.2205 8.5764 20.4635 7.96439 20.4635C7.35237 20.4635 6.76543 20.2205 6.33266 19.7877L4.2115 17.6639C3.77964 17.2313 3.53709 16.645 3.53709 16.0338C3.53709 15.4225 3.77964 14.8362 4.2115 14.4036L6.99996 11.6154M10.4615 5.84667L18.1538 13.5383M18.725 5.27557L22 2.00085M17 12.3859L19.7885 9.59767C20.2212 9.16494 20.4643 8.57804 20.4643 7.96609C20.4643 7.35413 20.2212 6.76723 19.7885 6.3345L17.6644 4.21353C17.2318 3.78171 16.6454 3.53918 16.0341 3.53918C15.4228 3.53918 14.8365 3.78171 14.4038 4.21353L11.6154 7.00175",
      fill: props.fill,
      fillOpacity: "0.7",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ))
);
const CustomIcon = {
  Brain,
  BrainOutline,
  MemoryApp,
  Sparkling,
  SparklingOff,
  BorderlessStar,
  Info,
  Integration
};
const spacer = "_spacer_6prgg_8";
const separator = "_separator_6prgg_12";
const horizontal = "_horizontal_6prgg_15";
const vertical = "_vertical_6prgg_19";
const column = "_column_6prgg_25";
const row = "_row_6prgg_31";
const grid = "_grid_6prgg_37";
const styles$s = {
  spacer,
  separator,
  horizontal,
  vertical,
  column,
  row,
  grid
};
const transformSpecialCSSProperties = (props) => {
  const {
    style: restStyles,
    alignContent,
    alignItems,
    alignSelf,
    flex,
    flexBasis,
    flexDirection,
    flexFlow,
    flexGrow,
    flexShrink,
    flexWrap,
    gap,
    gridTemplateColumns,
    gridColumn,
    height,
    justifyContent,
    margin,
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    maxHeight,
    maxWidth,
    minHeight,
    minWidth,
    overflow,
    padding,
    width,
    ...restProps
  } = props;
  const convertBoolFlexValue = (value) => typeof value === "boolean" ? value ? 1 : 0 : value;
  const style = {
    ...restStyles,
    gap: sizeToVariableMap[gap] || gap || (restStyles == null ? void 0 : restStyles.gap),
    padding: sizeToVariableMap[padding] || padding || (restStyles == null ? void 0 : restStyles.padding),
    margin: sizeToVariableMap[margin] || margin || (restStyles == null ? void 0 : restStyles.margin),
    marginTop: sizeToVariableMap[marginTop] || marginTop || (restStyles == null ? void 0 : restStyles.marginTop),
    marginBottom: sizeToVariableMap[marginBottom] || marginBottom || (restStyles == null ? void 0 : restStyles.marginBottom),
    marginLeft: sizeToVariableMap[marginLeft] || marginLeft || (restStyles == null ? void 0 : restStyles.marginLeft),
    marginRight: sizeToVariableMap[marginRight] || marginRight || (restStyles == null ? void 0 : restStyles.marginRight),
    flex: flex ?? (restStyles == null ? void 0 : restStyles.flex),
    flexBasis: flexBasis ?? (restStyles == null ? void 0 : restStyles.flexBasis),
    flexDirection: flexDirection ?? (restStyles == null ? void 0 : restStyles.flexDirection),
    flexFlow: flexFlow ?? (restStyles == null ? void 0 : restStyles.flexFlow),
    flexGrow: convertBoolFlexValue(flexGrow) ?? (restStyles == null ? void 0 : restStyles.flexGrow),
    flexShrink: convertBoolFlexValue(flexShrink) ?? (restStyles == null ? void 0 : restStyles.flexShrink),
    flexWrap: flexWrap ?? (restStyles == null ? void 0 : restStyles.flexWrap),
    alignItems: alignItems ?? (restStyles == null ? void 0 : restStyles.alignItems),
    alignContent: alignContent ?? (restStyles == null ? void 0 : restStyles.alignContent),
    alignSelf: alignSelf ?? (restStyles == null ? void 0 : restStyles.alignSelf),
    justifyContent: justifyContent ?? (restStyles == null ? void 0 : restStyles.justifyContent),
    width: width ?? (restStyles == null ? void 0 : restStyles.width),
    height: height ?? (restStyles == null ? void 0 : restStyles.height),
    maxWidth: maxWidth ?? (restStyles == null ? void 0 : restStyles.maxWidth),
    maxHeight: maxHeight ?? (restStyles == null ? void 0 : restStyles.maxHeight),
    minWidth: minWidth ?? (restStyles == null ? void 0 : restStyles.minWidth),
    minHeight: minHeight ?? (restStyles == null ? void 0 : restStyles.minHeight),
    overflow: overflow ?? (restStyles == null ? void 0 : restStyles.overflow),
    gridTemplateColumns: gridTemplateColumns ?? (restStyles == null ? void 0 : restStyles.gridTemplateColumns),
    gridColumn: gridColumn ?? (restStyles == null ? void 0 : restStyles.gridColumn)
  };
  Object.keys(style).forEach((key) => {
    if (typeof style[key] === "undefined") {
      delete style[key];
    }
  });
  return {
    style,
    ...restProps
  };
};
const sizeToVariableMap = {
  small: "var(--reference_size_01)",
  medium: "var(--reference_size_03)",
  large: "var(--reference_size_04)",
  xlarge: "var(--reference_size_05)"
};
function Spacer() {
  return /* @__PURE__ */ React__default.createElement("div", { className: styles$s.spacer });
}
function Separator$1({ orientation = "horizontal", ...rest }) {
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      ...rest,
      className: classNames(styles$s.separator, styles$s[orientation], rest.className)
    }
  );
}
const Column = forwardRef((props, ref) => {
  const { className, as: Component2 = "div", ...finalProps } = transformSpecialCSSProperties(props);
  return /* @__PURE__ */ React__default.createElement(Component2, { ...finalProps, ref, className: classNames(styles$s.column, className) });
});
const Row = forwardRef((props, ref) => {
  const { className, as: Component2 = "div", ...finalProps } = transformSpecialCSSProperties(props);
  return /* @__PURE__ */ React__default.createElement(Component2, { ...finalProps, ref, className: classNames(styles$s.row, className) });
});
function Grid(props) {
  const { className, as: Component2 = "div", ...finalProps } = transformSpecialCSSProperties(props);
  return /* @__PURE__ */ React__default.createElement(Component2, { ...finalProps, className: classNames(styles$s.grid, className) });
}
const Box$1 = Object.assign(Row, {
  Spacer,
  Separator: Separator$1,
  Column,
  Row,
  Grid
});
Box$1.displayName = "Box";
Box$1.Column.displayName = "Box.Column";
Box$1.Row.displayName = "Box.Row";
const container$7 = "_container_191wo_5";
const stretchContent = "_stretchContent_191wo_27";
const borders = "_borders_191wo_32";
const coloring = "_coloring_191wo_38";
const text$1 = "_text_191wo_81";
const frameStyles = {
  container: container$7,
  stretchContent,
  borders,
  coloring,
  "color-eucalyptus": "_color-eucalyptus_191wo_42",
  "color-neutral": "_color-neutral_191wo_46",
  "shape-circle": "_shape-circle_191wo_50",
  "size-xsmall": "_size-xsmall_191wo_54",
  "size-small": "_size-small_191wo_62",
  "size-medium": "_size-medium_191wo_70",
  "size-large": "_size-large_191wo_75",
  text: text$1
};
function Container$5({
  shape = "square",
  size = "medium",
  coloring: coloring2 = false,
  stretchContent: stretchContent2 = true,
  children,
  className,
  borders: borders2
}) {
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames(
        frameStyles.container,
        frameStyles[`shape-${shape}`],
        frameStyles[`size-${size}`],
        {
          [frameStyles.borders]: borders2,
          [frameStyles.coloring]: coloring2,
          [frameStyles.stretchContent]: stretchContent2,
          [frameStyles[`color-${coloring2}`]]: coloring2 && typeof coloring2 === "string"
        },
        className
      )
    },
    children
  );
}
function Image$1(props) {
  const {
    shape,
    size,
    coloring: coloring2,
    stretchContent: stretchContent2,
    as: Component2 = "img",
    children,
    borders: borders2,
    ...rest
  } = props;
  return /* @__PURE__ */ React__default.createElement(
    Container$5,
    {
      shape,
      size,
      coloring: coloring2,
      borders: borders2,
      stretchContent: stretchContent2
    },
    children ? children : /* @__PURE__ */ React__default.createElement(Component2, { alt: "", ...rest })
  );
}
function Avatar(props) {
  if (props.src) return /* @__PURE__ */ React__default.createElement(Image$1, { shape: "circle", ...props });
  return /* @__PURE__ */ React__default.createElement(Text$2, { coloring: true, shape: "circle", ...props }, props.alt);
}
function Icon$1(props) {
  const { shape, size, coloring: coloring2, stretchContent: stretchContent2, name, borders: borders2, children, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(
    Container$5,
    {
      shape,
      size,
      coloring: coloring2,
      borders: borders2,
      stretchContent: stretchContent2
    },
    !!name && !children ? /* @__PURE__ */ React__default.createElement(Icon$3, { name, ...rest }) : children
  );
}
function Text$2(props) {
  const { shape, size, coloring: coloring2, borders: borders2, children } = props;
  return /* @__PURE__ */ React__default.createElement(
    Container$5,
    {
      shape,
      size,
      coloring: coloring2,
      borders: !coloring2 || borders2 === true,
      className: frameStyles.text
    },
    typeof children === "string" ? children.substring(0, 2) : children
  );
}
const Frame$1 = {
  /** Frame an image by passing an `<img.. />` as child, or setting `src` directly */
  Image: Image$1,
  /** Frame an Icon, either by passing `Icon` as child, or setting icon `name` directly */
  Icon: Icon$1,
  /** Use text in lue of an image/icon; automatically strips to 2 characters */
  Text: Text$2,
  /** Handy wrapper around `Image` /w `Text` fallback to the `alt` value */
  Avatar
};
const table = "_table_1nyol_15";
const thead = "_thead_1nyol_24";
const tfoot = "_tfoot_1nyol_25";
const sticky = "_sticky_1nyol_28";
const tr = "_tr_1nyol_50";
const isSelected = "_isSelected_1nyol_57";
const isClickable = "_isClickable_1nyol_63";
const highlight = "_highlight_1nyol_66";
const td = "_td_1nyol_72";
const pinnedLeft = "_pinnedLeft_1nyol_72";
const pinnedRight = "_pinnedRight_1nyol_72";
const zebraStripes = "_zebraStripes_1nyol_76";
const verticalBorders = "_verticalBorders_1nyol_90";
const th = "_th_1nyol_24";
const sortable = "_sortable_1nyol_115";
const sorted = "_sorted_1nyol_121";
const tbody = "_tbody_1nyol_145";
const numeric = "_numeric_1nyol_184";
const alignRight = "_alignRight_1nyol_192";
const tallContent = "_tallContent_1nyol_201";
const standalone = "_standalone_1nyol_211";
const resizer = "_resizer_1nyol_231";
const isResizing = "_isResizing_1nyol_249";
const aggregateRow = "_aggregateRow_1nyol_267";
const aggregateDropdownContent = "_aggregateDropdownContent_1nyol_274";
const styles$r = {
  table,
  thead,
  tfoot,
  sticky,
  tr,
  isSelected,
  isClickable,
  highlight,
  td,
  pinnedLeft,
  pinnedRight,
  zebraStripes,
  verticalBorders,
  th,
  sortable,
  sorted,
  tbody,
  numeric,
  alignRight,
  tallContent,
  standalone,
  resizer,
  isResizing,
  aggregateRow,
  aggregateDropdownContent
};
const Element$1 = React__default.forwardRef(
  function Element2({ as: AsComponent = "div", asChild = false, ...props }, ref) {
    const finalProps = transformSpecialCSSProperties(props);
    const Component2 = asChild ? Slot : AsComponent;
    return /* @__PURE__ */ React__default.createElement(Component2, { ...finalProps, ref });
  }
);
Element$1.displayName = "Element";
const TableContainer = (props) => {
  const { standalone: standalone2, zebraStripes: zebraStripes2, verticalBorders: verticalBorders2, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      as: "table",
      ...rest,
      className: classNames(props.className, styles$r.table, {
        [styles$r.standalone]: standalone2,
        [styles$r.zebraStripes]: zebraStripes2,
        [styles$r.verticalBorders]: verticalBorders2
      })
    }
  );
};
const Thead = (props) => {
  const { sticky: sticky2, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      as: "thead",
      ...rest,
      className: classNames(props.className, styles$r.thead, {
        [styles$r.sticky]: sticky2
      })
    }
  );
};
const Tfoot = ({ sticky: sticky2, ...rest }) => {
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      as: "tfoot",
      ...rest,
      className: classNames(rest.className, styles$r.tfoot, {
        [styles$r.sticky]: sticky2
      })
    }
  );
};
const Tr = (props) => {
  const { isClickable: isClickable2, isSelected: isSelected2, highlight: highlight2, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      as: "tr",
      ...rest,
      className: classNames(props.className, styles$r.tr, {
        [styles$r.isClickable]: isClickable2,
        [styles$r.isSelected]: isSelected2,
        [styles$r.highlight]: highlight2
      }),
      "data-selected": isSelected2
    }
  );
};
const Th = (props) => {
  const {
    tallContent: tallContent2,
    numeric: numeric2,
    alignRight: alignRight2,
    sortable: sortable2,
    sorted: sorted2,
    pinnedLeft: pinnedLeft2,
    pinnedRight: pinnedRight2,
    highlight: highlight2,
    ...rest
  } = props;
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      as: "th",
      ...rest,
      className: classNames(props.className, styles$r.th, {
        [styles$r.tallContent]: tallContent2,
        [styles$r.numeric]: numeric2,
        [styles$r.alignRight]: alignRight2,
        [styles$r.sortable]: sortable2,
        [styles$r.sorted]: sorted2,
        [styles$r.pinnedLeft]: pinnedLeft2,
        [styles$r.pinnedRight]: pinnedRight2,
        [styles$r.highlight]: highlight2
      })
    }
  );
};
const Td = (props) => {
  const { tallContent: tallContent2, numeric: numeric2, alignRight: alignRight2, pinnedLeft: pinnedLeft2, pinnedRight: pinnedRight2, highlight: highlight2, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      as: "td",
      ...rest,
      className: classNames(props.className, styles$r.td, {
        [styles$r.tallContent]: tallContent2,
        [styles$r.numeric]: numeric2,
        [styles$r.alignRight]: alignRight2,
        [styles$r.pinnedLeft]: pinnedLeft2,
        [styles$r.pinnedRight]: pinnedRight2,
        [styles$r.highlight]: highlight2
      })
    }
  );
};
const Tbody = (props) => {
  return /* @__PURE__ */ React__default.createElement(Element$1, { as: "tbody", ...props, className: classNames(props.className, styles$r.tbody) });
};
const Caption = (props) => {
  return /* @__PURE__ */ React__default.createElement(Element$1, { as: "caption", ...props, className: classNames(props.className, styles$r.caption) });
};
const Colgroup = (props) => {
  return /* @__PURE__ */ React__default.createElement(Element$1, { as: "colgroup", ...props, className: classNames(props.className, styles$r.colgroup) });
};
const ThResizer = ({ header: header2, columnResizeMode, deltaOffset, ...rest }) => {
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      ...rest,
      ...{
        onMouseDown: header2.getResizeHandler(),
        onTouchStart: header2.getResizeHandler(),
        className: classNames(styles$r.resizer, {
          [styles$r.isResizing]: header2.column.getIsResizing()
        }),
        style: {
          transform: columnResizeMode === "onEnd" && header2.column.getIsResizing() ? `translateX(${deltaOffset}px)` : ""
        }
      }
    }
  );
};
const ThSorter = ({ header: header2, children }) => {
  return /* @__PURE__ */ React__default.createElement("div", null, children, {
    asc: /* @__PURE__ */ React__default.createElement(Icon$3, { name: "ArrowNarrowUp", "data-chevron": true, width: 16, height: 16 }),
    desc: /* @__PURE__ */ React__default.createElement(Icon$3, { name: "ArrowNarrowDown", "data-chevron": true, width: 16, height: 16 })
  }[header2.column.getIsSorted()] ?? null);
};
const ThDefault = ({
  header: header2,
  columnResizeMode = "onChange",
  deltaOffset = null,
  children,
  leftOffset,
  rightOffset
}) => {
  const isPinned = header2.column.getIsPinned();
  return /* @__PURE__ */ React__default.createElement(
    Table.Th,
    {
      key: header2.id,
      sortable: header2.column.getCanSort(),
      sorted: !!header2.column.getIsSorted(),
      pinnedLeft: isPinned === "left",
      pinnedRight: isPinned === "right",
      onClick: header2.column.getToggleSortingHandler(),
      ...{
        colSpan: header2.colSpan,
        style: {
          width: header2.getSize(),
          left: leftOffset,
          right: rightOffset
        }
      }
    },
    header2.isPlaceholder ? null : /* @__PURE__ */ React__default.createElement(Table.ThSorter, { header: header2 }, children),
    header2.column.getCanResize() && /* @__PURE__ */ React__default.createElement(
      Table.ThResizer,
      {
        header: header2,
        columnResizeMode,
        deltaOffset
      }
    )
  );
};
const Table = Object.assign(TableContainer, {
  /** `<thead>` wrapper */
  Thead,
  /** `<tbody>` wrapper */
  Tbody,
  /** `<tfoot>` wrapper */
  Tfoot,
  /** `<caption>` wrapper */
  Caption,
  /** `<colgroup>` wrapper */
  Colgroup,
  /** `<tr>` wrapper */
  Tr,
  /** `<td>` wrapper */
  Td,
  /** `<th>` wrapper */
  Th,
  /** Resize Handle for Th */
  ThResizer,
  /** Wrap `Th` contents for sorting */
  ThSorter,
  /** Default Th cell */
  ThDefault
});
const dropdownMenuArrow = "_dropdownMenuArrow_1dh0u_5";
const rightSlot = "_rightSlot_1dh0u_9";
const messageBody = "_messageBody_1dh0u_74";
const messageIcon = "_messageIcon_1dh0u_112";
const styles$q = {
  dropdownMenuArrow,
  rightSlot,
  "variant-selected": "_variant-selected_1dh0u_24",
  "variant-info": "_variant-info_1dh0u_34",
  "variant-alert": "_variant-alert_1dh0u_42",
  "variant-danger": "_variant-danger_1dh0u_50",
  "variant-success": "_variant-success_1dh0u_58",
  messageBody,
  "variant-neutral": "_variant-neutral_1dh0u_96",
  messageIcon
};
const overlay = "_overlay_1gyfz_11";
const overlayShow = "_overlayShow_1gyfz_1";
const visible = "_visible_1gyfz_20";
const closeButton = "_closeButton_1gyfz_27";
const pointerArrow = "_pointerArrow_1gyfz_55";
const contentBase = "_contentBase_1gyfz_62";
const popoverContentBase = "_popoverContentBase_1gyfz_62";
const modalContentBase = "_modalContentBase_1gyfz_62";
const dialogContentBase = "_dialogContentBase_1gyfz_62";
const dropdownContentBase = "_dropdownContentBase_1gyfz_62";
const slideDownAndFade = "_slideDownAndFade_1gyfz_1";
const slideLeftAndFade = "_slideLeftAndFade_1gyfz_1";
const slideUpAndFade = "_slideUpAndFade_1gyfz_1";
const slideRightAndFade = "_slideRightAndFade_1gyfz_1";
const contentShowWithoutTransform = "_contentShowWithoutTransform_1gyfz_1";
const tooltipContentBase = "_tooltipContentBase_1gyfz_155";
const contentVariantDialog = "_contentVariantDialog_1gyfz_190";
const contentVariantModal = "_contentVariantModal_1gyfz_195";
const contentVariantMinimal = "_contentVariantMinimal_1gyfz_200";
const contentVariantModalFullscreen = "_contentVariantModalFullscreen_1gyfz_206";
const contentVariantModalOverlayView = "_contentVariantModalOverlayView_1gyfz_213";
const contentVariantModalSettings = "_contentVariantModalSettings_1gyfz_219";
const contentVariantModalWizard = "_contentVariantModalWizard_1gyfz_228";
const dialogTitle = "_dialogTitle_1gyfz_241";
const dialogDescription = "_dialogDescription_1gyfz_249";
const dialogFooter = "_dialogFooter_1gyfz_290";
const dropdownMenuItemBase = "_dropdownMenuItemBase_1gyfz_304";
const dropdownMenuItemCustom = "_dropdownMenuItemCustom_1gyfz_335";
const dropdownMenuItemIndicator = "_dropdownMenuItemIndicator_1gyfz_347";
const dropdownMenuSeparator = "_dropdownMenuSeparator_1gyfz_368";
const dropdownMenuLabel = "_dropdownMenuLabel_1gyfz_379";
const indent = "_indent_1gyfz_384";
const commonStyles = {
  overlay,
  overlayShow,
  visible,
  closeButton,
  pointerArrow,
  contentBase,
  popoverContentBase,
  modalContentBase,
  dialogContentBase,
  dropdownContentBase,
  slideDownAndFade,
  slideLeftAndFade,
  slideUpAndFade,
  slideRightAndFade,
  contentShowWithoutTransform,
  tooltipContentBase,
  contentVariantDialog,
  contentVariantModal,
  contentVariantMinimal,
  contentVariantModalFullscreen,
  contentVariantModalOverlayView,
  contentVariantModalSettings,
  contentVariantModalWizard,
  dialogTitle,
  dialogDescription,
  dialogFooter,
  dropdownMenuItemBase,
  "orientation-vertical": "_orientation-vertical_1gyfz_321",
  dropdownMenuItemCustom,
  dropdownMenuItemIndicator,
  dropdownMenuSeparator,
  dropdownMenuLabel,
  indent
};
const input$1 = "_input_1w0hn_9";
const styles$p = {
  input: input$1
};
const CmdItem = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement(Command$1.Item, { className: commonStyles.dropdownMenuItemBase, ...props, ref: forwardedRef }));
const CmdInput = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement(Command$1.Input, { className: styles$p.input, ...props, ref: forwardedRef }));
const CmdSeparator = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement(
  Command$1.Separator,
  {
    className: commonStyles.dropdownMenuSeparator,
    ...props,
    ref: forwardedRef
  }
));
const Command = Object.assign({
  ...Command$1,
  Item: CmdItem,
  Input: CmdInput,
  Separator: CmdSeparator
});
const Combobox$1 = forwardRef((props, forwardedRef) => {
  const { items = [], cmdInputProps, onSelect, itemComponent, ...cmdProps } = props;
  const itemComponents = useMemo(
    () => items.map((item2, index) => {
      if (item2.type === "separator") {
        return /* @__PURE__ */ React__default.createElement(Command.Separator, { key: `${item2.type}-${index}` });
      }
      if (item2.type === "group") {
        return /* @__PURE__ */ React__default.createElement(Command.Group, { key: item2.label, heading: item2.label }, item2.subOptions.map((subItem, subIndex) => {
          const key = "value" in subItem ? `${subItem.value}-${subIndex}` : `sub-${subIndex}`;
          return /* @__PURE__ */ React__default.createElement(
            ComboboxItem,
            {
              key,
              item: subItem,
              onSelect,
              itemComponent
            }
          );
        }));
      }
      return /* @__PURE__ */ React__default.createElement(
        ComboboxItem,
        {
          key: `${item2.value}-${index}`,
          item: item2,
          onSelect,
          itemComponent
        }
      );
    }),
    [items, onSelect, itemComponent]
  );
  return /* @__PURE__ */ React__default.createElement(Command, { ...cmdProps, ref: forwardedRef }, /* @__PURE__ */ React__default.createElement(Command.Input, { placeholder: "Search for something...", autoFocus: true, ...cmdInputProps }), /* @__PURE__ */ React__default.createElement(Command.List, null, /* @__PURE__ */ React__default.createElement(Command.Empty, null, "No results found."), itemComponents));
});
const ComboboxItem = ({ item: item2, onSelect, itemComponent }) => {
  const handleSelect = useCallback(() => {
    if (onSelect && "value" in item2) {
      onSelect({ value: item2.value, item: item2 });
    }
  }, [item2, onSelect]);
  const ItemContent = itemComponent || GenericItemBody;
  return /* @__PURE__ */ React__default.createElement(Command.Item, { onSelect: handleSelect }, /* @__PURE__ */ React__default.createElement(ItemContent, { item: item2 }));
};
const DropdownMenu$1 = React__default.memo((props) => {
  const {
    trigger,
    closeOnSelect = false,
    onOpenChange,
    onAction,
    width,
    maxWidth,
    items,
    // MenuContentProps
    side,
    align,
    sticky: sticky2,
    collisionPadding,
    collisionBoundary,
    avoidCollisions,
    sideOffset,
    alignOffset,
    hideWhenDetached,
    contentClassName,
    style,
    disabled: disabled2 = false,
    returnFocusOnClose = true,
    ...rest
  } = props;
  const handleEscapeKeyDown = useCallback(() => {
    onOpenChange == null ? void 0 : onOpenChange(false);
  }, [onOpenChange]);
  const handlePreventDefault = useCallback((event) => {
    event.preventDefault();
  }, []);
  const computedStyle = useMemo(
    () => ({ ...style, width, maxWidth: maxWidth || width }),
    [maxWidth, style, width]
  );
  const contentProps = {
    side,
    align,
    sticky: sticky2,
    collisionPadding,
    collisionBoundary,
    avoidCollisions,
    sideOffset,
    alignOffset,
    hideWhenDetached,
    onCloseAutoFocus: !returnFocusOnClose ? handlePreventDefault : void 0,
    className: contentClassName,
    style: computedStyle
  };
  return /* @__PURE__ */ React__default.createElement(DropdownMenu.Root, { ...rest, onOpenChange }, /* @__PURE__ */ React__default.createElement(DropdownMenu.Trigger, { asChild: true, disabled: disabled2 }, trigger), /* @__PURE__ */ React__default.createElement(DropdownMenu.Portal, null, /* @__PURE__ */ React__default.createElement(DropdownMenu.Content, { ...contentProps, onEscapeKeyDown: handleEscapeKeyDown }, /* @__PURE__ */ React__default.createElement(RenderMenuItems, { closeOnSelect, onAction, items }))));
});
DropdownMenu$1.displayName = "DropdownMenu";
const DropdownMenuItemComponent = ({ item: item2, closeOnSelect, onAction, ...props }) => {
  const itemCloseOnSelect = "closeOnSelect" in item2 ? item2.closeOnSelect : closeOnSelect;
  const handleSelect = useCallback(
    (event) => {
      var _a;
      if (item2.disabled) {
        event.preventDefault();
        return;
      }
      if (!itemCloseOnSelect) event.preventDefault();
      (_a = item2.onSelect) == null ? void 0 : _a.call(item2, event, item2);
      onAction == null ? void 0 : onAction({ event, item: item2 });
    },
    [item2, onAction, itemCloseOnSelect]
  );
  if (item2.confirm && !item2.disabled) {
    return /* @__PURE__ */ React__default.createElement(
      PopoverConfirm,
      {
        ...item2.confirm,
        onConfirm: handleSelect,
        stopPropagation: true,
        usePortal: true,
        zIndex: 1e3,
        target: /* @__PURE__ */ React__default.createElement(
          DropdownMenu.Item,
          {
            ...props,
            variant: item2.variant,
            onSelect: (e) => e.preventDefault()
          },
          /* @__PURE__ */ React__default.createElement(GenericItemBody, { item: item2 })
        )
      }
    );
  }
  return /* @__PURE__ */ React__default.createElement(DropdownMenu.Item, { ...props, variant: item2.variant, onSelect: handleSelect }, /* @__PURE__ */ React__default.createElement(GenericItemBody, { item: item2 }));
};
DropdownMenuItemComponent.displayName = "DropdownMenuItemComponent";
const DropdownMenuSliderComponent = ({ item: item2, onAction, ...props }) => {
  const handleValueCommit = useCallback(
    (value) => {
      var _a, _b;
      (_b = (_a = item2.slider).onValueCommit) == null ? void 0 : _b.call(_a, value);
      onAction == null ? void 0 : onAction({ item: item2, value });
    },
    [item2, onAction]
  );
  return /* @__PURE__ */ React__default.createElement(
    Box$1.Column,
    {
      ...props,
      className: classNames(
        commonStyles.dropdownMenuItemBase,
        "variant" in item2 && item2.variant && styles$q[`variant-${item2.variant}`]
      )
    },
    /* @__PURE__ */ React__default.createElement(Box$1.Row, { width: "100%" }, /* @__PURE__ */ React__default.createElement(GenericItemBody, { item: { ...item2, description: void 0 } })),
    /* @__PURE__ */ React__default.createElement(Slider, { ...item2.slider, onValueCommit: handleValueCommit }),
    !!item2.description && /* @__PURE__ */ React__default.createElement(Text$1.Label, { ellipsis: 2, size: "xsmall", color: "lowContrast" }, item2.description)
  );
};
DropdownMenuSliderComponent.displayName = "DropdownMenuSliderComponent";
const DropdownMenuSwitchComponent = ({ item: item2, onAction, closeOnSelect, ...props }) => {
  const itemCloseOnSelect = "closeOnSelect" in item2 ? item2.closeOnSelect : closeOnSelect;
  const handleSelect = useCallback(
    (event) => {
      var _a;
      if (!itemCloseOnSelect) event.preventDefault();
      const checked2 = !item2.checked;
      (_a = item2.onCheckedChange) == null ? void 0 : _a.call(item2, checked2, item2);
      onAction == null ? void 0 : onAction({ item: item2, checked: checked2 });
    },
    [item2, onAction, itemCloseOnSelect]
  );
  return /* @__PURE__ */ React__default.createElement(DropdownMenu.Item, { ...props, variant: item2.variant, onSelect: handleSelect }, /* @__PURE__ */ React__default.createElement(DropdownMenu.Icon, { style: { paddingTop: 1 } }, /* @__PURE__ */ React__default.createElement(
    Switch,
    {
      size: "xsmall",
      name: item2.key,
      disabled: item2.disabled,
      checked: item2.checked,
      onChangeChecked: () => {
      },
      readOnly: true
    }
  )), /* @__PURE__ */ React__default.createElement(GenericItemBody, { item: item2 }));
};
DropdownMenuSwitchComponent.displayName = "DropdownMenuSwitchComponent";
const DropdownMenuLabelComponent = ({ item: item2 }) => /* @__PURE__ */ React__default.createElement(
  DropdownMenu.Label,
  {
    className: classNames(commonStyles.dropdownMenuLabel, {
      [commonStyles.indent]: item2.indent ?? true
    })
  },
  item2.label
);
DropdownMenuLabelComponent.displayName = "DropdownMenuLabelComponent";
const DropdownMenuSeparatorComponent = () => /* @__PURE__ */ React__default.createElement(DropdownMenu.Separator, null);
const DropdownMenuCheckboxItemComponent = ({
  item: item2,
  onAction,
  closeOnSelect,
  ...rest
}) => {
  const itemCloseOnSelect = "closeOnSelect" in item2 ? item2.closeOnSelect : closeOnSelect;
  const handleCheckedChange = useCallback(
    (checked2) => {
      var _a;
      (_a = item2.onCheckedChange) == null ? void 0 : _a.call(item2, checked2, item2);
      onAction == null ? void 0 : onAction({ checked: checked2, item: item2 });
    },
    [item2, onAction]
  );
  const handleSelect = useCallback(
    (event) => {
      if (!itemCloseOnSelect) event.preventDefault();
    },
    [itemCloseOnSelect]
  );
  return /* @__PURE__ */ React__default.createElement(
    DropdownMenu.CheckboxItem,
    {
      checked: item2.checked,
      ...rest,
      variant: item2.variant,
      onSelect: handleSelect,
      onCheckedChange: handleCheckedChange
    },
    /* @__PURE__ */ React__default.createElement(GenericItemBody, { item: item2 })
  );
};
DropdownMenuCheckboxItemComponent.displayName = "DropdownMenuCheckboxItemComponent";
const DropdownMenuRadioItemComponent = ({ item: item2, closeOnSelect, ...props }) => {
  const itemCloseOnSelect = "closeOnSelect" in item2 ? item2.closeOnSelect : closeOnSelect;
  const onSelect = useCallback(
    (event) => !itemCloseOnSelect && event.preventDefault(),
    [itemCloseOnSelect]
  );
  return /* @__PURE__ */ React__default.createElement(
    DropdownMenu.RadioItem,
    {
      onSelect,
      value: item2.value,
      variant: item2.variant,
      ...props
    },
    /* @__PURE__ */ React__default.createElement(GenericItemBody, { item: item2 })
  );
};
DropdownMenuRadioItemComponent.displayName = "DropdownMenuRadioItemComponent";
const DropdownMenuRadioGroupComponent = ({
  item: item2,
  onAction,
  closeOnSelect,
  disabled: disabled2 = false,
  ...props
}) => {
  const handleValueChange = useCallback(
    (value) => {
      var _a;
      const selectedItem = item2.subOptions.find((subItem) => subItem.value === value);
      (_a = item2.onValueChange) == null ? void 0 : _a.call(item2, value, selectedItem);
      onAction == null ? void 0 : onAction({ item: selectedItem });
    },
    [item2, onAction]
  );
  return /* @__PURE__ */ React__default.createElement(
    DropdownMenu.RadioGroup,
    {
      ...props,
      value: item2.currentValue,
      onValueChange: handleValueChange
    },
    /* @__PURE__ */ React__default.createElement(Box$1.Row, { alignContent: "center" }, /* @__PURE__ */ React__default.createElement(DropdownMenu.Label, null, item2.label)),
    item2.subOptions.map((subItem, index) => /* @__PURE__ */ React__default.createElement(
      DropdownMenuRadioItemComponent,
      {
        closeOnSelect,
        key: `${index}`,
        item: subItem,
        disabled: disabled2
      }
    ))
  );
};
DropdownMenuRadioGroupComponent.displayName = "DropdownMenuRadioGroupComponent";
const DropdownMenuGroupComponent = ({ item: item2, closeOnSelect, onAction, ...props }) => {
  return /* @__PURE__ */ React__default.createElement(DropdownMenu.Group, { ...props }, /* @__PURE__ */ React__default.createElement(DropdownMenu.Label, null, item2.label), item2.subOptions.map((subItem, index) => /* @__PURE__ */ React__default.createElement(
    RenderMenuItem,
    {
      key: index,
      closeOnSelect,
      onAction,
      item: subItem
    }
  )));
};
DropdownMenuGroupComponent.displayName = "DropdownMenuGroupComponent";
const DropdownMenuSubMenuComponent = ({
  item: item2,
  onAction,
  closeOnSelect,
  ...props
}) => /* @__PURE__ */ React__default.createElement(DropdownMenu.Sub, { ...props }, /* @__PURE__ */ React__default.createElement(
  DropdownMenu.SubTrigger,
  {
    disabled: item2.disabled,
    variant: item2.variant,
    onClick: item2.onClick
  },
  /* @__PURE__ */ React__default.createElement(GenericItemBody, { item: item2 })
), /* @__PURE__ */ React__default.createElement(DropdownMenu.Portal, null, /* @__PURE__ */ React__default.createElement(DropdownMenu.SubContent, { style: { width: item2.width, maxWidth: item2.width } }, item2.subOptions.map((subItem, index) => /* @__PURE__ */ React__default.createElement(
  RenderMenuItem,
  {
    key: index,
    closeOnSelect,
    onAction,
    item: subItem
  }
)))));
DropdownMenuSubMenuComponent.displayName = "DropdownMenuSubMenuComponent";
const DropdownMenuComboboxComponent = ({
  item: item2,
  onAction,
  closeOnSelect,
  ...props
}) => {
  return /* @__PURE__ */ React__default.createElement(DropdownMenu.Sub, { ...props }, /* @__PURE__ */ React__default.createElement(DropdownMenu.SubTrigger, { variant: item2.variant }, /* @__PURE__ */ React__default.createElement(GenericItemBody, { item: item2 }), /* @__PURE__ */ React__default.createElement(DropdownMenu.RightSlot, null)), /* @__PURE__ */ React__default.createElement(DropdownMenu.Portal, null, /* @__PURE__ */ React__default.createElement(DropdownMenu.SubContent, { asChild: true }, /* @__PURE__ */ React__default.createElement(Combobox$1, { items: item2.subOptions, onSelect: onAction }))));
};
DropdownMenuComboboxComponent.displayName = "DropdownMenuComboboxComponent";
const HorizontalItemBody = ({ item: item2 }) => {
  const isCheckbox = item2.type === "checkboxItem";
  const radioOrCheckbox = ["radioItem", "checkboxItem"].includes(item2.type);
  const rightIcon = "icon" in item2 && !!item2.icon && radioOrCheckbox;
  const leftIcon = "icon" in item2 && !!item2.icon && !radioOrCheckbox;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, radioOrCheckbox && /* @__PURE__ */ React__default.createElement(DropdownMenu.ItemIndicator, null, /* @__PURE__ */ React__default.createElement(SvgCheck, null)), leftIcon && /* @__PURE__ */ React__default.createElement(
    DropdownMenu.Icon,
    {
      icon: item2.icon,
      style: isCheckbox ? { position: "static" } : {}
    }
  ), "label" in item2 && item2.label, "shortcutCombo" in item2 && /* @__PURE__ */ React__default.createElement(DropdownMenu.ShortcutCombo, { combo: item2.shortcutCombo }), "sidenote" in item2 && !!item2.sidenote ? /* @__PURE__ */ React__default.createElement(DropdownMenu.RightSlot, null, item2.sidenote) : rightIcon ? /* @__PURE__ */ React__default.createElement(DropdownMenu.RightSlot, null, item2.icon) : item2.type === "subMenu" ? /* @__PURE__ */ React__default.createElement(DropdownMenu.RightSlot, null) : null);
};
HorizontalItemBody.displayName = "HorizontalItemBody";
const GenericItemBody = ({ item: item2 }) => {
  const hasDescription = "description" in item2 && !!item2.description;
  if (!hasDescription) return /* @__PURE__ */ React__default.createElement(HorizontalItemBody, { item: item2 });
  return /* @__PURE__ */ React__default.createElement(Box$1.Column, { gap: "medium", width: "100%" }, /* @__PURE__ */ React__default.createElement(Box$1.Row, { width: "100%" }, /* @__PURE__ */ React__default.createElement(HorizontalItemBody, { item: item2 })), /* @__PURE__ */ React__default.createElement(Text$1.Label, { ellipsis: 2, size: "xsmall", color: "lowContrast" }, item2.description));
};
GenericItemBody.displayName = "GenericItemBody";
const RenderMenuItem = ({ item: item2, onAction, ...rest }) => {
  const readonly = "readonly" in item2 && !!item2.readonly ? true : void 0;
  const disabled2 = readonly || "disabled" in item2 && !!item2.disabled ? true : void 0;
  const testid = item2["data-testid"] || item2.key || item2.label || void 0;
  const extra = {
    disabled: disabled2,
    "data-readonly": readonly,
    "data-testid": testid,
    "data-indent": "indent" in item2 && item2.indent
  };
  switch (item2.type) {
    case "group":
      return /* @__PURE__ */ React__default.createElement(DropdownMenuGroupComponent, { onAction, ...rest, ...extra, item: item2 });
    case "item":
      return /* @__PURE__ */ React__default.createElement(DropdownMenuItemComponent, { onAction, ...rest, ...extra, item: item2 });
    case "label":
      return /* @__PURE__ */ React__default.createElement(DropdownMenuLabelComponent, { ...rest, ...extra, item: item2 });
    case "separator":
      return /* @__PURE__ */ React__default.createElement(DropdownMenuSeparatorComponent, null);
    case "checkboxItem":
      return /* @__PURE__ */ React__default.createElement(DropdownMenuCheckboxItemComponent, { onAction, ...rest, ...extra, item: item2 });
    case "radioItem":
      return /* @__PURE__ */ React__default.createElement(DropdownMenuRadioItemComponent, { ...rest, item: item2, ...extra });
    case "radioGroup":
      return /* @__PURE__ */ React__default.createElement(DropdownMenuRadioGroupComponent, { onAction, ...rest, item: item2, ...extra });
    case "subMenu":
      return /* @__PURE__ */ React__default.createElement(DropdownMenuSubMenuComponent, { onAction, ...rest, item: item2, ...extra });
    case "slider": {
      const { closeOnSelect, ...restSlider } = rest;
      return /* @__PURE__ */ React__default.createElement(DropdownMenuSliderComponent, { onAction, ...restSlider, item: item2, ...extra });
    }
    case "switch":
      return /* @__PURE__ */ React__default.createElement(DropdownMenuSwitchComponent, { onAction, ...rest, ...extra, item: item2 });
    case "combobox":
      return /* @__PURE__ */ React__default.createElement(DropdownMenuComboboxComponent, { onAction, ...rest, ...extra, item: item2 });
    case "custom":
      return /* @__PURE__ */ React__default.createElement(DropdownMenu.CustomItem, { ...extra }, item2.content);
    case "message":
      return /* @__PURE__ */ React__default.createElement(DropdownMenu.Message, { ...extra, item: item2 });
    default:
      return /* @__PURE__ */ React__default.createElement("div", null, "RenderMenuItem doesnt support this item");
  }
};
const RenderMenuItems = ({ items, ...rest }) => {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, items.map((item2, index) => /* @__PURE__ */ React__default.createElement(RenderMenuItem, { key: `${index}-${item2.type}`, ...rest, item: item2 })));
};
RenderMenuItem.displayName = "RenderMenuItem";
const AggregateDropdown = ({
  alignRight: alignRight2,
  column: column2,
  mandatory,
  numeric: numeric2,
  rowSelection,
  rows,
  selectedFunction,
  onSelect,
  aggregateFunctions
}) => {
  const result = useMemo(() => {
    const aggregateFunction = aggregateFunctions[selectedFunction];
    return aggregateFunction(rows, column2, rowSelection);
  }, [selectedFunction, rows, column2, aggregateFunctions, rowSelection]);
  const handleSelect = (e) => {
    onSelect(e.target.value);
  };
  function uniqueCurrencies(rows2, column22, rowSelection2) {
    const selectRows = rowSelection2 ? Object.keys(rowSelection2).length : 0;
    const currencies = rows2.filter((row2) => selectRows === 0 || row2.getIsSelected()).map((row2) => {
      var _a;
      const cell = row2.getVisibleCells().find((cell2) => cell2.column.id === column22.id);
      return (_a = cell == null ? void 0 : cell.getValue()) == null ? void 0 : _a.currency;
    });
    const uniqueCurrencies2 = new Set(currencies);
    return uniqueCurrencies2;
  }
  const options = [
    ...numeric2 ? mandatory ? [
      { value: "sum", label: "Sum" },
      { value: "average", label: "Average" },
      { value: "median", label: "Median" }
    ] : [
      { value: "uniqueCount", label: "Unique" },
      { value: "sum", label: "Sum" },
      { value: "average", label: "Average" },
      { value: "median", label: "Median" }
    ] : mandatory ? [{ value: "uniqueCount", label: "Unique" }] : [
      { value: "uniqueCount", label: "Unique" },
      { value: "count", label: "Count (Number)" },
      { value: "countPercentage", label: "Count (Percentage)" }
    ]
  ];
  return /* @__PURE__ */ React__default.createElement(Box$1.Row, { gap: 8, justifyContent: alignRight2 ? "flex-end" : "flex-start" }, /* @__PURE__ */ React__default.createElement(
    DropdownMenu$1,
    {
      contentClassName: styles$r.aggregateDropdownContent,
      width: 305,
      trigger: /* @__PURE__ */ React__default.createElement(Button$1, { priority: "low", size: "xsmall", "data-testid": "aggregate_datatable_footer" }, result),
      items: [
        ...[
          {
            type: "radioGroup",
            label: "Summary",
            currentValue: String(selectedFunction),
            onValueChange: (value) => {
              handleSelect({
                target: { value }
              });
            },
            subOptions: options.map((option2) => ({
              type: "radioItem",
              value: option2.value,
              label: option2.label,
              sidenote: aggregateFunctions[option2.value] ? aggregateFunctions[option2.value](rows, column2, rowSelection) : ""
            }))
          },
          { type: "separator" },
          {
            type: "radioGroup",
            label: "",
            currentValue: String(selectedFunction),
            onValueChange: (value) => {
              handleSelect({
                target: { value }
              });
            },
            subOptions: [
              {
                type: "radioItem",
                value: "emptyLabel",
                label: "None"
              }
            ]
          }
        ],
        ...uniqueCurrencies(rows, column2, rowSelection).size > 1 ? [
          { type: "separator" },
          {
            type: "message",
            label: "Sum, Average and Median for multiple currencies cannot be displayed",
            variant: "alert"
          }
        ] : []
      ]
    }
  ));
};
const AggregateValue = ({
  column: column2,
  rows,
  selectedFunction,
  rowSelection,
  aggregateFunctions,
  alignRight: alignRight2
}) => {
  const result = React__default.useMemo(() => {
    const aggregateFunction = aggregateFunctions[selectedFunction];
    return aggregateFunction(rows, column2, rowSelection);
  }, [selectedFunction, rows, column2, aggregateFunctions, rowSelection]);
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      style: {
        textAlign: alignRight2 ? "right" : "left",
        padding: "4px 4px",
        fontSize: "0.9em"
      }
    },
    result
  );
};
const EMPTY_SORT = [];
const EMPTY_COLUMN_PINNING = {};
const DataTable = ({
  data,
  columns,
  columnResizeMode = "onChange",
  columnOrder,
  stickyHeader = true,
  stickyFooter = false,
  // Sorting
  sorting = EMPTY_SORT,
  // VERY important that data is stable or else re-rendering gets crazy
  onSortingChange,
  manualSorting,
  // Column pinning
  columnPinning = EMPTY_COLUMN_PINNING,
  onColumnPinningChange,
  // Row selection & click
  getRowId,
  rowSelection,
  enableRowSelection,
  onRowSelectionChange,
  onExpandedChange,
  enableRowExpansion,
  getSubRows,
  onRowClick,
  // Visibility
  columnVisibility,
  onColumnVisibilityChange,
  // Virtualization
  virtualContainerHeight,
  virtualization = false,
  virtualRowSize = 35,
  debug = true,
  fixedLayout,
  hideFooter,
  zebraStripes: zebraStripes2,
  verticalBorders: verticalBorders2,
  aggregateFooter = false,
  selectedAggregateFunctions,
  aggregateFunctions,
  handleAggregateSelection,
  expanded,
  // Highlighting
  highlightedColumns = [],
  highlightedRows = []
}) => {
  var _a, _b;
  const table2 = useReactTable({
    columnResizeMode,
    data,
    columns,
    state: {
      sorting,
      columnPinning,
      columnVisibility,
      columnOrder,
      rowSelection,
      expanded
    },
    getRowId,
    enableRowSelection,
    manualSorting,
    onRowSelectionChange,
    onSortingChange,
    onColumnVisibilityChange,
    onColumnPinningChange,
    getCoreRowModel: getCoreRowModel(),
    onExpandedChange,
    getSubRows: getSubRows || (() => []),
    getExpandedRowModel: getExpandedRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: debug,
    debugHeaders: debug,
    debugColumns: debug
  });
  const leftLeafColumns = table2.getLeftLeafColumns();
  const rightLeafColumns = table2.getRightLeafColumns();
  const { leftOffsets, rightOffsets } = useMemo(() => {
    let left2 = 0;
    const leftOffsets2 = {};
    for (const column2 of leftLeafColumns) {
      leftOffsets2[column2.id] = left2;
      left2 += column2.getSize();
    }
    let right2 = 0;
    const rightOffsets2 = {};
    for (const column2 of rightLeafColumns.slice().reverse()) {
      rightOffsets2[column2.id] = right2;
      right2 += column2.getSize();
    }
    return { leftOffsets: leftOffsets2, rightOffsets: rightOffsets2 };
  }, [leftLeafColumns, rightLeafColumns]);
  const handleRowClick = React__default.useCallback(
    (event) => {
      const rowId = event.currentTarget.dataset["rowId"];
      console.log("rowId", rowId);
      if (enableRowExpansion) {
        onExpandedChange == null ? void 0 : onExpandedChange(() => ({
          [rowId]: true
        }));
      }
      onRowClick == null ? void 0 : onRowClick(rowId, event);
    },
    [enableRowExpansion, onExpandedChange, onRowClick]
  );
  const tableContainerRef = React__default.useRef(null);
  const { rows } = table2.getRowModel();
  const rowVirtualizer = useVirtual({
    parentRef: tableContainerRef,
    size: rows.length,
    estimateSize: React__default.useCallback(() => virtualRowSize, [virtualRowSize]),
    overscan: 10
  });
  const { virtualItems: virtualRows, totalSize } = rowVirtualizer;
  const useVirtualization = virtualization && !!virtualContainerHeight;
  if (virtualization && !virtualContainerHeight) {
    console.warn(
      "⚠️ You MUST set `virtualContainerHeight` in px when using `virtualization`. Virtualization is NOT ENABLED with current props"
    );
  }
  const paddingTop = useVirtualization && virtualRows.length > 0 ? ((_a = virtualRows == null ? void 0 : virtualRows[0]) == null ? void 0 : _a.start) || 0 : 0;
  const paddingBottom = useVirtualization && virtualRows.length > 0 ? totalSize - (((_b = virtualRows == null ? void 0 : virtualRows[virtualRows.length - 1]) == null ? void 0 : _b.end) || 0) : 0;
  const rowsToRender = useVirtualization ? virtualRows : rows;
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      ref: tableContainerRef,
      style: useVirtualization ? { height: virtualContainerHeight, overflow: "auto" } : void 0
    },
    /* @__PURE__ */ React__default.createElement(
      Table,
      {
        style: {
          tableLayout: fixedLayout ? "fixed" : void 0,
          ...useVirtualization ? { height: `${totalSize}px`, width: "100%" } : void 0
        },
        zebraStripes: zebraStripes2,
        verticalBorders: verticalBorders2
      },
      /* @__PURE__ */ React__default.createElement(Table.Thead, { sticky: stickyHeader }, table2.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ React__default.createElement(Table.Tr, { key: headerGroup.id }, headerGroup.headers.map((header2) => {
        const isString = typeof header2.column.columnDef.header === "string";
        const isProjectColumn = header2.id === "num_of_projects";
        return isString || isProjectColumn ? /* @__PURE__ */ React__default.createElement(
          Table.ThDefault,
          {
            key: header2.id,
            header: header2,
            columnResizeMode,
            deltaOffset: table2.getState().columnSizingInfo.deltaOffset,
            leftOffset: leftOffsets[header2.column.id],
            rightOffset: rightOffsets[header2.column.id]
          },
          flexRender(header2.column.columnDef.header, header2.getContext())
        ) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, { key: header2.id }, flexRender(header2.column.columnDef.header, header2.getContext()));
      })))),
      /* @__PURE__ */ React__default.createElement(Table.Tbody, null, useVirtualization && paddingTop > 0 && /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", { style: { height: `${paddingTop}px` } })), rowsToRender.map((virtualRow) => {
        const row2 = rows[virtualRow.index];
        return /* @__PURE__ */ React__default.createElement(
          Table.Tr,
          {
            key: row2.id,
            "data-row-id": row2.id,
            isSelected: row2.getCanSelect() && row2.getIsSelected(),
            isClickable: !!onRowClick,
            onClick: handleRowClick,
            highlight: highlightedRows.includes(row2.id)
          },
          row2.getVisibleCells().map((cell) => {
            const isPinned = cell.column.getIsPinned();
            const meta = cell.column.columnDef.meta;
            const isHighlighted = highlightedColumns.includes(cell.column.id);
            return /* @__PURE__ */ React__default.createElement(
              Table.Td,
              {
                key: cell.id,
                pinnedLeft: isPinned === "left",
                pinnedRight: isPinned === "right",
                alignRight: !!(meta == null ? void 0 : meta.alignRight),
                numeric: !!(meta == null ? void 0 : meta.numeric),
                highlight: isHighlighted,
                ...{
                  style: {
                    width: cell.column.getSize(),
                    left: isPinned === "left" ? leftOffsets[cell.column.id] : void 0,
                    right: isPinned === "right" ? rightOffsets[cell.column.id] : void 0
                  }
                }
              },
              flexRender(cell.column.columnDef.cell, cell.getContext())
            );
          })
        );
      }), useVirtualization && paddingBottom > 0 && /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", { style: { height: `${paddingBottom}px` } }))),
      hideFooter && aggregateFooter && /* @__PURE__ */ React__default.createElement(Table.Tfoot, { sticky: stickyFooter, className: styles$r.aggregateRow }, table2.getFooterGroups().map((footerGroup) => /* @__PURE__ */ React__default.createElement(
        Table.Tr,
        {
          key: footerGroup.id,
          isSelected: rowSelection && Object.keys(rowSelection).length > 0
        },
        footerGroup.headers.map((header2) => {
          const meta = header2.column.columnDef.meta;
          const isPinned = header2.column.getIsPinned();
          const isAttribute = header2.id !== "selection";
          const isHighlighted = highlightedColumns.includes(header2.id);
          const isProjectColumn = header2.id === "project" || header2.id === "num_of_projects";
          return isAttribute ? /* @__PURE__ */ React__default.createElement(
            Table.Th,
            {
              key: header2.id,
              alignRight: !!(meta == null ? void 0 : meta.alignRight),
              pinnedLeft: isPinned === "left",
              pinnedRight: isPinned === "right",
              numeric: !!(meta == null ? void 0 : meta.numeric),
              highlight: isHighlighted,
              style: {
                width: header2.column.getSize(),
                left: isPinned === "left" ? leftOffsets[header2.column.id] : void 0,
                right: isPinned === "right" ? rightOffsets[header2.column.id] : void 0,
                ...isProjectColumn ? { fontVariantNumeric: "normal" } : {}
              }
            },
            !(meta == null ? void 0 : meta.excludeAggregateView) && ((meta == null ? void 0 : meta.readOnlyAggregateView) ? /* @__PURE__ */ React__default.createElement(
              AggregateValue,
              {
                column: header2.column,
                rows: rowsToRender,
                selectedFunction: (selectedAggregateFunctions == null ? void 0 : selectedAggregateFunctions[header2.id]) || ((meta == null ? void 0 : meta.numeric) ? "sum" : "uniqueCount"),
                rowSelection: rowSelection || {},
                aggregateFunctions: aggregateFunctions || {},
                alignRight: !!(meta == null ? void 0 : meta.alignRight)
              }
            ) : /* @__PURE__ */ React__default.createElement(
              AggregateDropdown,
              {
                selectedFunction: (selectedAggregateFunctions == null ? void 0 : selectedAggregateFunctions[header2.id]) || ((meta == null ? void 0 : meta.numeric) ? "sum" : "uniqueCount"),
                onSelect: (value) => handleAggregateSelection == null ? void 0 : handleAggregateSelection(header2.id, value),
                numeric: !!(meta == null ? void 0 : meta.numeric),
                alignRight: !!(meta == null ? void 0 : meta.alignRight),
                mandatory: !!(meta == null ? void 0 : meta.mandatory),
                rows: rowsToRender,
                rowSelection,
                column: header2.column,
                aggregateFunctions: aggregateFunctions || {}
              }
            ))
          ) : /* @__PURE__ */ React__default.createElement(Table.Th, null);
        })
      ))),
      !hideFooter && /* @__PURE__ */ React__default.createElement(Table.Tfoot, { sticky: stickyFooter }, table2.getFooterGroups().map((footerGroup) => /* @__PURE__ */ React__default.createElement(Table.Tr, { key: footerGroup.id }, footerGroup.headers.map((header2) => {
        const isHighlighted = highlightedColumns.includes(header2.id);
        const isProjectColumn = header2.id === "project" || header2.id === "num_of_projects";
        return /* @__PURE__ */ React__default.createElement(
          Table.Th,
          {
            key: header2.id,
            highlight: isHighlighted,
            style: isProjectColumn ? { fontVariantNumeric: "normal" } : void 0
          },
          header2.isPlaceholder ? null : flexRender(header2.column.columnDef.footer, header2.getContext())
        );
      }))))
    )
  );
};
DataTable.displayName = "DataTable";
const display = "_display_1ad4p_8";
const headline = "_headline_1ad4p_40";
const paragraph = "_paragraph_1ad4p_58";
const label$1 = "_label_1ad4p_87";
const formInteraction = "_formInteraction_1ad4p_121";
const lineClamp = "_lineClamp_1ad4p_128";
const ellipsis = "_ellipsis_1ad4p_135";
const bold = "_bold_1ad4p_168";
const textStyles = {
  display,
  "size-small": "_size-small_1ad4p_23",
  "size-medium": "_size-medium_1ad4p_27",
  "size-large": "_size-large_1ad4p_31",
  "size-xlarge": "_size-xlarge_1ad4p_35",
  headline,
  paragraph,
  "size-xxsmall": "_size-xxsmall_1ad4p_61",
  "size-xsmall": "_size-xsmall_1ad4p_66",
  label: label$1,
  formInteraction,
  lineClamp,
  ellipsis,
  "color-normal": "_color-normal_1ad4p_144",
  "color-subtle": "_color-subtle_1ad4p_148",
  "color-lowContrast": "_color-lowContrast_1ad4p_152",
  "color-minContrast": "_color-minContrast_1ad4p_156",
  "color-success": "_color-success_1ad4p_160",
  "color-danger": "_color-danger_1ad4p_164",
  bold
};
function headlineSizeToTag(size = "medium") {
  const sizeMap = {
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
  };
  return sizeMap[size] || "h3";
}
const BaseText = forwardRef((props, ref) => {
  const {
    className,
    ellipsis: ellipsis2,
    color,
    style,
    size = "medium",
    as: Component2 = "span",
    bold: bold2 = false,
    hideFromFullstory,
    ...finalProps
  } = transformSpecialCSSProperties(props);
  const finalStyle = typeof ellipsis2 !== "number" ? style : { ...style, WebkitLineClamp: ellipsis2 };
  return /* @__PURE__ */ React__default.createElement(
    Component2,
    {
      ...finalProps,
      style: finalStyle,
      className: classNames(className, textStyles[`size-${size}`], {
        [textStyles[`color-${color}`]]: !!color,
        [textStyles.lineClamp]: typeof ellipsis2 === "number",
        [textStyles.ellipsis]: typeof ellipsis2 === "boolean" && ellipsis2,
        [textStyles.bold]: bold2,
        "fs-mask": hideFromFullstory
      }),
      ref
    }
  );
});
const Display = forwardRef((props, ref) => /* @__PURE__ */ React__default.createElement(
  BaseText,
  {
    as: headlineSizeToTag(props.size),
    ...props,
    className: classNames(textStyles.display, props.className),
    ref
  }
));
const Headline = forwardRef((props, ref) => /* @__PURE__ */ React__default.createElement(
  BaseText,
  {
    as: headlineSizeToTag(props.size),
    ...props,
    className: classNames(textStyles.headline, props.className),
    ref
  }
));
const Paragraph = forwardRef((props, ref) => /* @__PURE__ */ React__default.createElement(BaseText, { as: "p", ...props, className: classNames(textStyles.paragraph, props.className), ref }));
const Label$1 = forwardRef((props, ref) => /* @__PURE__ */ React__default.createElement(
  BaseText,
  {
    as: "label",
    ...props,
    className: classNames(
      textStyles.label,
      { [textStyles.formInteraction]: !!props.htmlFor },
      props.className
    ),
    ref
  }
));
const Span = forwardRef((props, ref) => (
  // Re-uses .paragraph styles as they are identical, to avoid duplication in `typography.scss`
  /* @__PURE__ */ React__default.createElement(BaseText, { ...props, className: classNames(textStyles.paragraph, props.className), ref })
));
const Text$1 = Object.assign(Span, {
  Display,
  Headline,
  Paragraph,
  Label: Label$1
});
const elevationBase = "_elevationBase_978pa_9";
const styles$o = {
  elevationBase,
  "size--small": "_size--small_978pa_15",
  "size--large": "_size--large_978pa_18",
  "context--inline": "_context--inline_978pa_23",
  "depth--low": "_depth--low_978pa_23",
  "depth--medium": "_depth--medium_978pa_26",
  "depth--high": "_depth--high_978pa_29",
  "context--floating": "_context--floating_978pa_34"
};
const ElevationBase = (props) => {
  const { plain = false, size = "medium", context = "floating", depth = "medium", ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      as: "div",
      ...rest,
      className: classNames(
        styles$o[`context--${context}`],
        styles$o[`depth--${depth}`],
        styles$o[`size--${size}`],
        { [styles$o.elevationBase]: !plain },
        props.className
      )
    }
  );
};
ElevationBase.displayName = "Elevation";
const Elevation = ElevationBase;
const timelineContainer = "_timelineContainer_14huf_9";
const isPanMode = "_isPanMode_14huf_16";
const isZoomMode = "_isZoomMode_14huf_19";
const isDragAdd = "_isDragAdd_14huf_22";
const isDragSubtract = "_isDragSubtract_14huf_25";
const timelineControls = "_timelineControls_14huf_51";
const isActive = "_isActive_14huf_63";
const timelineScrollarea = "_timelineScrollarea_14huf_68";
const lane = "_lane_14huf_90";
const laneSublanesContainer = "_laneSublanesContainer_14huf_123";
const laneHeader = "_laneHeader_14huf_130";
const laneHeaderContent = "_laneHeaderContent_14huf_143";
const interactive$2 = "_interactive_14huf_157";
const active$4 = "_active_14huf_163";
const laneGutterMark = "_laneGutterMark_14huf_187";
const stickyLanes = "_stickyLanes_14huf_205";
const gutterLane = "_gutterLane_14huf_219";
const interval = "_interval_14huf_276";
const extraEmphasis = "_extraEmphasis_14huf_288";
const lifted = "_lifted_14huf_298";
const indicator$1 = "_indicator_14huf_312";
const backgroundIndicator = "_backgroundIndicator_14huf_333";
const styles$n = {
  timelineContainer,
  isPanMode,
  isZoomMode,
  isDragAdd,
  isDragSubtract,
  timelineControls,
  isActive,
  timelineScrollarea,
  lane,
  "separator-start": "_separator-start_14huf_104",
  "separator-end": "_separator-end_14huf_107",
  laneSublanesContainer,
  laneHeader,
  laneHeaderContent,
  interactive: interactive$2,
  active: active$4,
  laneGutterMark,
  stickyLanes,
  gutterLane,
  "lane-variant-subtle": "_lane-variant-subtle_14huf_245",
  "lane-variant-highlight": "_lane-variant-highlight_14huf_255",
  "lane-variant-success": "_lane-variant-success_14huf_265",
  interval,
  extraEmphasis,
  lifted,
  indicator: indicator$1,
  backgroundIndicator
};
const memoryContainer = "_memoryContainer_7imx7_8";
const ignored = "_ignored_7imx7_17";
const bar = "_bar_7imx7_17";
const memoryInline = "_memoryInline_7imx7_18";
const subtle = "_subtle_7imx7_26";
const memoryPopoverDetails = "_memoryPopoverDetails_7imx7_45";
const memoryPopover = "_memoryPopover_7imx7_45";
const styles$m = {
  memoryContainer,
  ignored,
  bar,
  memoryInline,
  subtle,
  memoryPopoverDetails,
  memoryPopover
};
const MemoryContainer = (props) => {
  const { offsetPx, orientation, ignored: ignored2, subtle: subtle2, style, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      ...rest,
      style: {
        top: orientation === "vertical" ? offsetPx : void 0,
        left: orientation === "horizontal" ? offsetPx : void 0,
        ...style
      },
      className: classNames(
        styles$m.memoryContainer,
        { [styles$m.ignored]: ignored2, [styles$m.subtle]: subtle2 },
        props.className
      )
    }
  );
};
MemoryContainer.displayName = "Timeline.Memory";
const MemoryInline = (props) => {
  return /* @__PURE__ */ React__default.createElement(Box$1.Column, { gap: "small", ...props, className: classNames(props.className, styles$m.memoryInline) }, props.children);
};
MemoryInline.displayName = "Timeline.Memory.Inline";
const MemoryPopover = (props) => {
  const { isOpen, offsetX = 20, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(AnimatePresence, null, isOpen && /* @__PURE__ */ React__default.createElement(
    motion.div,
    {
      key: "memory-popover",
      className: styles$m.memoryPopover,
      animate: { opacity: 1, y: -9, x: offsetX },
      initial: { opacity: 0.1, y: -9, x: offsetX },
      exit: { opacity: 0, y: -9, x: offsetX },
      transition: { type: "spring", duration: 0.2 }
    },
    /* @__PURE__ */ React__default.createElement(
      Elevation,
      {
        as: Box$1.Column,
        gap: "medium",
        size: "medium",
        depth: "medium",
        ...rest,
        className: classNames(props.className, styles$m.memoryPopover)
      }
    )
  ));
};
MemoryPopover.displayName = "Timeline.Memory.Popover";
const MemoryPopoverSheet = (props) => {
  const { isOpen, ...rest } = props;
  if (!isOpen) return null;
  return /* @__PURE__ */ React__default.createElement(
    motion.div,
    {
      key: "memory-popover-details",
      className: styles$m.memoryPopoverDetails,
      animate: { opacity: 1, left: 0, top: 4 },
      initial: { opacity: 0, left: 0, top: 8 },
      exit: { opacity: 0, left: 0, top: 8 },
      transition: { type: "spring", duration: 0.3 },
      onClick: (e) => e.stopPropagation()
    },
    /* @__PURE__ */ React__default.createElement(
      Elevation,
      {
        as: Box$1.Column,
        depth: "high",
        ...rest,
        className: classNames(styles$m.memoryPopoverDetails, props.className)
      }
    )
  );
};
MemoryPopoverSheet.displayName = "Timeline.Memory.Popover.Sheet";
const Bar = (props) => {
  const { sizePx, orientation, color = "rgba(25,210,253,0.30)", style, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      ...rest,
      style: {
        backgroundColor: color,
        height: orientation === "vertical" ? `${sizePx}px` : void 0,
        width: orientation === "horizontal" ? `${sizePx}px` : void 0,
        ...style
      },
      className: classNames(styles$m.bar, props.className, "fs-exclude")
    }
  );
};
Bar.displayName = "Timeline.Memory.Bar";
const TimelineMemory = Object.assign(MemoryContainer, {
  /** Inline display of the Memory */
  Inline: MemoryInline,
  /** Memory/Duration Bar, indicating length of Memory */
  Bar,
  /** Hover-the-Memory style popover */
  Popover: Object.assign(MemoryPopover, {
    /** Display extra details from within Memory popover */
    Sheet: MemoryPopoverSheet
  })
});
TimelineMemory.displayName = "Timeline.Memory";
TimelineMemory.Inline.displayName = "Timeline.Memory.Inline";
TimelineMemory.Bar.displayName = "Timeline.Memory.Bar";
TimelineMemory.Popover.displayName = "Timeline.Memory.Popover";
TimelineMemory.Popover.Sheet.displayName = "Timeline.Memory.Popover.Sheet";
const eventContainer = "_eventContainer_z67yf_8";
const styles$l = {
  eventContainer
};
const timelineItemPositioning = (props) => {
  const { orientation, offsetPx, sizePx } = props;
  const isRelative = offsetPx === void 0;
  return {
    position: !isRelative ? "absolute" : void 0,
    top: orientation === "vertical" ? offsetPx : 0,
    right: orientation === "vertical" ? 0 : void 0,
    bottom: orientation === "horizontal" ? 0 : void 0,
    left: orientation === "horizontal" ? offsetPx : 0,
    height: orientation === "vertical" ? sizePx : void 0,
    width: orientation === "horizontal" ? sizePx : void 0
  };
};
const convertSelectionToDateTime = ({
  position,
  orientation,
  pxPerMinute,
  fromDateTime,
  snapToMinutes
}) => {
  const { startPx, lengthPx } = orientation === "horizontal" ? { startPx: position.left, lengthPx: position.width } : { startPx: position.top, lengthPx: position.height };
  function snap(px) {
    return Math.round(px / pxPerMinute / snapToMinutes) * snapToMinutes * pxPerMinute;
  }
  const startSnapped = snap(startPx);
  const lengthAdjustment = startSnapped - startPx;
  const lengthSnapped = snap(lengthPx - lengthAdjustment);
  const startMinutes = startSnapped / pxPerMinute;
  const durationMinutes = lengthSnapped / pxPerMinute;
  const started_at = fromDateTime.plus({ minutes: startMinutes });
  const ended_at = started_at.plus({ minutes: durationMinutes });
  return { started_at, ended_at };
};
const TimelineLaneEventContainer = (props) => {
  const { offsetPx, sizePx, orientation, style, ...rest } = props;
  const dynamicStyles = timelineItemPositioning(props);
  return /* @__PURE__ */ React__default.createElement(
    Elevation,
    {
      depth: "low",
      context: "inline",
      ...rest,
      style: { ...dynamicStyles, ...style },
      className: classNames(styles$l.eventContainer, props.className)
    }
  );
};
TimelineLaneEventContainer.displayName = "Timeline.Event";
const TimelineEvent = Object.assign(TimelineLaneEventContainer, {});
TimelineEvent.displayName = "Timeline.Event";
const useValueRef = (value) => {
  const ref = useRef(value);
  ref.current = value;
  return ref;
};
const usePan = (onPan, onlyMiddleMouse) => {
  const [elementRef, setRef] = useState(null);
  const onPanRef = useValueRef(onPan);
  useEffect(() => {
    if (!elementRef) {
      return;
    }
    let cleanup = () => {
    };
    let lastOffset = { x: 0, y: 0 };
    const onMouseMove = (e) => {
      const offset2 = { x: e.clientX, y: e.clientY };
      onPanRef.current({ left: lastOffset.x - offset2.x, top: lastOffset.y - offset2.y });
      lastOffset = offset2;
    };
    const onMouseUp = () => {
      cleanup();
    };
    const setup = (e) => {
      const isMiddleMouseButton = e.button === 1;
      if (onlyMiddleMouse && !isMiddleMouseButton) {
        return;
      }
      if (e.button > 1) {
        return;
      }
      e.stopPropagation();
      e.preventDefault();
      lastOffset = { x: e.clientX, y: e.clientY };
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
      cleanup = () => {
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
      };
    };
    elementRef.addEventListener("mousedown", setup);
    return () => {
      elementRef.removeEventListener("mousedown", setup);
      cleanup();
    };
  }, [elementRef, onPanRef, onlyMiddleMouse]);
  return setRef;
};
const SLIDER_WIDTH = 150;
const DEFAULT_MIN_PX_PER_MINUTE = 1;
const DEFAULT_MAX_PX_PER_MINUTE = 6;
const TimelineContext = createContext({
  orientation: "horizontal",
  fromDateTime: DateTime.now().startOf("day"),
  pxPerMinute: 2,
  minPxPerMinute: DEFAULT_MIN_PX_PER_MINUTE,
  ticksPerInterval: 4,
  panRef: null,
  scrollAreaRef: null,
  isZoomMode: false,
  isPanMode: false,
  isDragMode: false,
  isDragAddMode: false,
  isDragSubMode: false,
  isAltKeyHeld: false,
  setIsPanMode: () => {
  },
  setIsDragMode: () => {
  },
  onZoomToPx: () => null
});
TimelineContext.displayName = "Timeline.Context";
const TimelineContextContainer = forwardRef((props, _ref) => {
  const { className, config, ...rest } = props;
  const {
    orientation,
    ticksPerInterval,
    pxPerMinute,
    fromDateTime,
    maxPxPerMinute = DEFAULT_MAX_PX_PER_MINUTE,
    minPxPerMinute = DEFAULT_MIN_PX_PER_MINUTE,
    onZoomToPx
  } = config;
  const [scrollAreaRef, setScrollAreaRef] = useState(null);
  const [statefulPanMode, setIsPanMode] = useState(false);
  const [isDragMode, setIsDragMode] = useState(false);
  const isAltKeyHeld = useHeldKey("Alt");
  const isSpaceHeld = useHeldKey(" ");
  const isZoomMode2 = useHeldKey("Meta");
  const isPanMode2 = (isSpaceHeld || statefulPanMode) && !isDragMode;
  const isDragAddMode = !isAltKeyHeld && !isPanMode2 && !isZoomMode2;
  const isDragSubMode = isAltKeyHeld && !isPanMode2;
  const isInteracting = isAltKeyHeld || isPanMode2 || isZoomMode2 || isDragMode;
  const wasInteracting = usePrevious(isInteracting);
  useLayoutEffect(() => {
    if (scrollAreaRef && isInteracting && !wasInteracting) {
      scrollAreaRef.focus();
    }
  }, [isInteracting, wasInteracting, scrollAreaRef]);
  const handlePan = useCallback(
    (pan) => {
      scrollAreaRef.scrollTop += pan.top;
      scrollAreaRef.scrollLeft += pan.left;
    },
    [scrollAreaRef]
  );
  const panRef = usePan(handlePan, !isPanMode2);
  const onZoom = useCallback(
    (delta) => onZoomToPx == null ? void 0 : onZoomToPx(pxPerMinute + delta),
    [pxPerMinute, onZoomToPx]
  );
  useZoom({ onZoom, enabled: !!onZoomToPx, scrollAreaRef });
  const contextValues = useMemo(() => {
    return {
      orientation,
      pxPerMinute,
      maxPxPerMinute,
      minPxPerMinute,
      ticksPerInterval,
      panRef,
      scrollAreaRef,
      isPanMode: isPanMode2,
      isZoomMode: isZoomMode2,
      isDragMode,
      isDragAddMode,
      isDragSubMode,
      setIsPanMode,
      setIsDragMode,
      onZoomToPx,
      fromDateTime,
      isAltKeyHeld
    };
  }, [
    // Config
    pxPerMinute,
    maxPxPerMinute,
    minPxPerMinute,
    orientation,
    ticksPerInterval,
    // Refs
    panRef,
    scrollAreaRef,
    // State
    isPanMode2,
    isZoomMode2,
    isDragMode,
    isDragAddMode,
    isDragSubMode,
    fromDateTime,
    // Actions
    onZoomToPx,
    setIsPanMode,
    setIsDragMode,
    // Key modifiers
    isAltKeyHeld
  ]);
  return /* @__PURE__ */ React__default.createElement(TimelineContext.Provider, { value: contextValues }, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      ref: setScrollAreaRef,
      ...rest,
      className: classNames(
        styles$n.timelineContainer,
        {
          [styles$n.isPanMode]: isSpaceHeld || isPanMode2,
          [styles$n.isDragAdd]: isDragAddMode,
          [styles$n.isDragSubtract]: isDragSubMode,
          [styles$n.isZoomMode]: isZoomMode2
        },
        className
      )
    }
  ));
});
TimelineContextContainer.displayName = "Timeline.ContextProvider";
const TimelineContextControls = forwardRef((props, _ref) => {
  const { children, ...rest } = props;
  const {
    isZoomMode: isZoomMode2,
    isPanMode: isPanMode2,
    isDragAddMode,
    isDragSubMode,
    setIsPanMode,
    pxPerMinute,
    maxPxPerMinute = DEFAULT_MAX_PX_PER_MINUTE,
    minPxPerMinute = DEFAULT_MIN_PX_PER_MINUTE,
    onZoomToPx
  } = useContext(TimelineContext);
  const sliderStepWidth = SLIDER_WIDTH / (maxPxPerMinute - 1);
  const disabledSliderWidth = (minPxPerMinute - 1) * sliderStepWidth;
  const handleZoomChange = useCallback(
    (value) => {
      onZoomToPx == null ? void 0 : onZoomToPx(Math.max(minPxPerMinute, value));
    },
    [onZoomToPx, minPxPerMinute]
  );
  const handleTogglePan = useCallback(
    (e) => {
      var _a;
      (_a = e.currentTarget) == null ? void 0 : _a.blur();
      setIsPanMode(!isPanMode2);
    },
    [isPanMode2, setIsPanMode]
  );
  return /* @__PURE__ */ React__default.createElement(
    Elevation,
    {
      as: Box$1.Row,
      gap: "medium",
      padding: "medium",
      content: "inline",
      depth: "low",
      ...rest,
      className: classNames(styles$n.timelineControls, props.className, {
        [styles$n.isActive]: isZoomMode2 || isPanMode2 || isDragAddMode || isDragSubMode
      })
    },
    /* @__PURE__ */ React__default.createElement(
      Tooltip$1,
      {
        position: "top",
        fixed: true,
        tooltip: isDragSubMode ? "Remove time from current selections" : "Make a time selection. Hold [ALT] to remove"
      },
      /* @__PURE__ */ React__default.createElement(
        Button$1,
        {
          onClick: () => setIsPanMode(false),
          isActive: isDragSubMode || isDragAddMode,
          priority: isDragSubMode || isDragAddMode ? "medium" : "low",
          selected: true,
          size: "small"
        },
        isDragSubMode ? /* @__PURE__ */ React__default.createElement(SvgMinus, null) : /* @__PURE__ */ React__default.createElement(SvgPlus, null)
      )
    ),
    /* @__PURE__ */ React__default.createElement(Tooltip$1, { position: "top", fixed: true, tooltip: "Toggle click-to-pan mode" }, /* @__PURE__ */ React__default.createElement(
      Button$1,
      {
        onClick: handleTogglePan,
        isActive: isPanMode2,
        priority: isPanMode2 ? "medium" : "low",
        selected: true,
        size: "small"
      },
      /* @__PURE__ */ React__default.createElement(SvgHand, null)
    )),
    /* @__PURE__ */ React__default.createElement(Box$1.Separator, { orientation: "vertical", style: { height: 24 } }),
    /* @__PURE__ */ React__default.createElement(Text$1.Label, { size: "small", color: "subtle" }, "Zoom"),
    /* @__PURE__ */ React__default.createElement(Tooltip$1, { position: "top", tooltip: "Zoom in or out [CMD+MouseWheel]" }, /* @__PURE__ */ React__default.createElement(
      Slider,
      {
        onValueChange: (value) => handleZoomChange(value[0]),
        defaultValue: [pxPerMinute],
        value: [pxPerMinute],
        min: 1,
        max: maxPxPerMinute,
        step: 1,
        isActive: isZoomMode2,
        disabledWidth: disabledSliderWidth,
        style: { width: SLIDER_WIDTH },
        "data-testid": "timeline_zoom_slider"
      }
    )),
    /* @__PURE__ */ React__default.createElement(
      Tooltip$1,
      {
        position: "top",
        tooltip: pxPerMinute > minPxPerMinute ? "Zoom out" : "Minimum zoom level for current summary interval"
      },
      /* @__PURE__ */ React__default.createElement(
        Button$1,
        {
          disabled: pxPerMinute <= minPxPerMinute,
          isActive: isZoomMode2,
          size: "xsmall",
          priority: "low",
          onClick: () => handleZoomChange(pxPerMinute - 1)
        },
        /* @__PURE__ */ React__default.createElement(SvgMinus, null)
      )
    ),
    /* @__PURE__ */ React__default.createElement(Tooltip$1, { position: "top", tooltip: pxPerMinute < maxPxPerMinute ? "Zoom in" : "Max zoom level" }, /* @__PURE__ */ React__default.createElement(
      Button$1,
      {
        disabled: pxPerMinute >= maxPxPerMinute,
        isActive: isZoomMode2,
        size: "xsmall",
        priority: "low",
        onClick: () => handleZoomChange(pxPerMinute + 1)
      },
      /* @__PURE__ */ React__default.createElement(SvgPlus, null)
    )),
    children
  );
});
TimelineContextControls.displayName = "Timeline.Controls";
/*!**********************************************************************************************************************
 * Temporary fix for the issue with the useSelectionContainer hook
 * PR made to original project, but for now I think vendoring like this is fine.
 * Original source:
 * * https://github.com/AirLabsTeam/react-drag-to-select/blob/main/src/hooks/useSelectionLogic.ts
 * * @air/react-drag-to-select v5.0.8
 *
 * PR:
 * * https://github.com/AirLabsTeam/react-drag-to-select/pull/46
 */
const SelectionContainer = forwardRef(({ style = {}, ...props }, ref) => {
  const containerRef = useRef(null);
  const selectionBoxRef = useRef(null);
  const [, setForceUpdate] = useState(0);
  useImperativeHandle(
    ref,
    () => ({
      getBoundingClientRect: () => {
        var _a;
        return (_a = containerRef.current) == null ? void 0 : _a.getBoundingClientRect();
      },
      getParentBoundingClientRect: () => {
        var _a, _b;
        return (_b = (_a = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _a.parentElement) == null ? void 0 : _b.getBoundingClientRect();
      },
      drawSelectionBox: (box) => {
        requestAnimationFrame(() => {
          if (selectionBoxRef.current) {
            const styles2 = {
              border: "1px solid #4C85D8",
              background: "rgba(155, 193, 239, 0.4)",
              position: "absolute",
              pointerEvents: "none",
              ...style,
              top: box.top,
              left: box.left,
              width: box.width,
              height: box.height
            };
            selectionBoxRef.current.style.cssText = styleObjectToCSS(styles2);
          }
        });
      },
      clearSelectionBox: () => {
        requestAnimationFrame(() => {
          if (selectionBoxRef.current) {
            const styles2 = {
              top: 0,
              left: 0,
              width: 0,
              height: 0
            };
            selectionBoxRef.current.style.cssText = styleObjectToCSS(styles2);
          }
        });
      }
    })
  );
  useEffect(() => {
    setForceUpdate((number) => number + 1);
  }, []);
  return /* @__PURE__ */ React__default.createElement("div", { ref: containerRef }, containerRef.current ? createPortal(/* @__PURE__ */ React__default.createElement("div", { ref: selectionBoxRef, ...props }), containerRef.current) : null);
});
function useSelectionContainer(props) {
  const {
    onSelectionChange,
    onSelectionEnd,
    onSelectionStart,
    isEnabled = true,
    selectionProps = {},
    eventsElement,
    shouldStartSelecting
  } = props || {};
  const containerRef = useRef(null);
  const { cancelCurrentSelection } = useSelectionLogic({
    containerRef,
    onSelectionEnd,
    onSelectionStart,
    onSelectionChange,
    isEnabled,
    eventsElement,
    shouldStartSelecting
  });
  const DragSelection = useCallback(
    () => /* @__PURE__ */ React__default.createElement(SelectionContainer, { ref: containerRef, ...selectionProps }),
    [selectionProps]
  );
  return {
    cancelCurrentSelection,
    DragSelection
  };
}
function useSelectionLogic({
  containerRef,
  onSelectionChange,
  onSelectionStart,
  onSelectionEnd,
  isEnabled = true,
  eventsElement,
  shouldStartSelecting
}) {
  const startPoint = useRef(null);
  const endPoint = useRef(null);
  const isSelecting = useRef(false);
  const currentSelectionChange = useRef(onSelectionChange);
  const currentSelectionStart = useRef(onSelectionStart);
  const currentSelectionEnd = useRef(onSelectionEnd);
  const onChangeRefId = useRef();
  const isEnabledRef = useRef(isEnabled);
  currentSelectionChange.current = useCallback(
    (box) => {
      onChangeRefId.current = onSelectionChange ? requestAnimationFrame(() => {
        onSelectionChange(box);
      }) : void 0;
    },
    [onSelectionChange]
  );
  currentSelectionStart.current = onSelectionStart;
  currentSelectionEnd.current = onSelectionEnd;
  isEnabledRef.current = isEnabled;
  const cancelCurrentSelection = useCallback(() => {
    var _a;
    startPoint.current = null;
    endPoint.current = null;
    isSelecting.current = false;
    (_a = containerRef.current) == null ? void 0 : _a.clearSelectionBox();
    if (typeof onChangeRefId.current === "number") {
      cancelAnimationFrame(onChangeRefId.current);
    }
  }, [containerRef]);
  const getPointFromEvent = useCallback(
    (event, rect) => {
      var _a;
      if (!rect) {
        rect = (_a = containerRef.current) == null ? void 0 : _a.getParentBoundingClientRect();
      }
      return {
        x: event.clientX - (typeof (rect == null ? void 0 : rect.left) === "number" ? rect.left : 0),
        y: event.clientY - (typeof (rect == null ? void 0 : rect.top) === "number" ? rect.top : 0)
      };
    },
    [containerRef]
  );
  const handleMouseMove = useCallback(
    (event, rect) => {
      var _a, _b, _c;
      if (startPoint.current && endPoint.current) {
        if (!rect) {
          return;
        }
        const newSelectionBox = calculateSelectionBox({
          startPoint: startPoint.current,
          endPoint: endPoint.current
        });
        const boxInContainer = {
          ...newSelectionBox,
          top: newSelectionBox.top + ((rect == null ? void 0 : rect.top) || 0),
          left: newSelectionBox.left + ((rect == null ? void 0 : rect.left) || 0)
        };
        if (calculateBoxCircumference(newSelectionBox) > 10) {
          if (!isSelecting.current) {
            if (currentSelectionStart == null ? void 0 : currentSelectionStart.current) {
              currentSelectionStart.current(event);
            }
            isSelecting.current = true;
          }
          (_a = containerRef.current) == null ? void 0 : _a.drawSelectionBox(newSelectionBox);
          (_b = currentSelectionChange.current) == null ? void 0 : _b.call(currentSelectionChange, boxInContainer);
        } else if (isSelecting.current) {
          (_c = currentSelectionChange.current) == null ? void 0 : _c.call(currentSelectionChange, boxInContainer);
        }
      } else {
        cancelCurrentSelection();
      }
    },
    [cancelCurrentSelection, containerRef]
  );
  const onMouseMove = useCallback(
    (event) => {
      var _a;
      if (!startPoint.current) {
        return;
      }
      const rect = (_a = containerRef.current) == null ? void 0 : _a.getParentBoundingClientRect();
      endPoint.current = getPointFromEvent(event, rect);
      handleMouseMove(event, rect);
    },
    [handleMouseMove, getPointFromEvent, containerRef]
  );
  const onMouseUp = useCallback(
    (event) => {
      var _a;
      if (event.button === 0) {
        if (endPoint.current) {
          (_a = currentSelectionEnd.current) == null ? void 0 : _a.call(currentSelectionEnd, event);
        }
        cancelCurrentSelection();
        document.body.style.removeProperty("user-select");
        document.body.style.removeProperty("-webkit-user-select");
        (eventsElement || document.body).removeEventListener("mousemove", onMouseMove);
        window == null ? void 0 : window.removeEventListener("mouseup", onMouseUp);
      }
    },
    [eventsElement, cancelCurrentSelection, onMouseMove]
  );
  const shouldStartSelectingRef = useRef(shouldStartSelecting);
  shouldStartSelectingRef.current = shouldStartSelecting;
  const onMouseDown = useCallback(
    (e) => {
      if (e.button === 0 && isEnabledRef.current) {
        if (typeof shouldStartSelectingRef.current === "function" && !shouldStartSelectingRef.current(e.target)) {
          return;
        }
        document.body.style.userSelect = "none";
        document.body.style.webkitUserSelect = "none";
        startPoint.current = getPointFromEvent(e);
        (eventsElement || document.body).addEventListener("mousemove", onMouseMove);
        window == null ? void 0 : window.addEventListener("mouseup", onMouseUp);
      }
    },
    [eventsElement, getPointFromEvent, onMouseMove, onMouseUp]
  );
  useEffect(() => {
    (eventsElement || document.body).addEventListener("mousedown", onMouseDown);
    return () => {
      (eventsElement || document.body).removeEventListener("mousedown", onMouseDown);
      (eventsElement || document.body).removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, [eventsElement, onMouseDown, onMouseMove, onMouseUp]);
  return {
    cancelCurrentSelection
  };
}
const calculateSelectionBox = ({
  startPoint,
  endPoint
}) => ({
  left: Math.min(startPoint.x, endPoint.x),
  top: Math.min(startPoint.y, endPoint.y),
  width: Math.abs(startPoint.x - endPoint.x),
  height: Math.abs(startPoint.y - endPoint.y)
});
const calculateBoxCircumference = (box) => 2 * (box.width + box.height);
const isUnitlessNumber = {
  boxFlex: true,
  boxFlexGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};
function buildRule(key, value) {
  const unquotedContentValueRegex = /^(normal|none|(\b(url\([^)]*\)|chapter_counter|attr\([^)]*\)|(no-)?(open|close)-quote|inherit)((\b\s*)|$|\s+))+)$/;
  if (!isUnitlessNumber[key] && typeof value === "number") {
    value = "" + value + "px";
  } else if (key === "content" && typeof value === "string" && !unquotedContentValueRegex.test(value)) {
    value = "'" + value.replace(/'/g, "\\'") + "'";
  }
  return hyphenateStyleName(key) + ": " + value + ";  ";
}
function styleObjectToCSS(rules) {
  const isArray = Array.isArray;
  const keys = Object.keys;
  let result = "";
  if (!rules || keys(rules).length === 0) {
    return result;
  }
  const styleKeys = keys(rules);
  for (let j = 0, l = styleKeys.length; j < l; j++) {
    const styleKey = styleKeys[j];
    const value = rules[styleKey];
    if (isArray(value)) {
      for (let i = 0, len = value.length; i < len; i++) {
        result += buildRule(styleKey, value[i]);
      }
    } else {
      result += buildRule(styleKey, value);
    }
  }
  return result;
}
function hyphenate(string) {
  const _uppercasePattern = /([A-Z])/g;
  return string.replace(_uppercasePattern, "-$1").toLowerCase();
}
function hyphenateStyleName(string) {
  const msPattern = /^ms-/;
  return hyphenate(string).replace(msPattern, "-ms-");
}
const selectedArea = "_selectedArea_cbqd6_8";
const styles$k = {
  selectedArea
};
const TimelineSelection = (props) => {
  const { snapToMinutes = 1 } = props;
  const [relativeDistance, setRelativeDistance] = useState({ top: 0, left: 0 });
  const [position, setPosition] = useState({ top: 0, height: 0, left: 0, width: 0 });
  const {
    fromDateTime,
    scrollAreaRef,
    orientation,
    pxPerMinute,
    isDragMode,
    isAltKeyHeld,
    setIsDragMode
  } = useContext(TimelineContext);
  const { DragSelection } = useSelectionContainer({
    eventsElement: scrollAreaRef,
    shouldStartSelecting: (eventTarget) => {
      if (eventTarget instanceof HTMLElement && eventTarget.closest("[data-no-drag-select]")) {
        return false;
      }
      const isAdjustHandle = eventTarget == null ? void 0 : eventTarget.closest("[data-timestamp-adjuster]");
      return !isDragMode && !isAdjustHandle;
    },
    onSelectionChange: (selection) => {
      if (!isDragMode) return;
      const { scrollTop, scrollLeft } = scrollAreaRef;
      const top = selection.top + scrollTop - relativeDistance.top;
      const left2 = selection.left + scrollLeft - relativeDistance.left;
      setPosition({ top, height: selection.height, left: left2, width: selection.width });
    },
    onSelectionStart: () => {
      const { top = 0, left: left2 = 0 } = (scrollAreaRef == null ? void 0 : scrollAreaRef.getBoundingClientRect()) || {};
      setRelativeDistance({ top, left: left2 });
      setIsDragMode(true);
    },
    onSelectionEnd: () => {
      var _a;
      setIsDragMode(false);
      if (position.width > pxPerMinute || position.height > pxPerMinute) {
        const { started_at, ended_at } = convertSelectionToDateTime({
          position,
          orientation,
          pxPerMinute,
          fromDateTime,
          snapToMinutes
        });
        if (started_at !== ended_at) {
          (_a = props.onSelectionEnd) == null ? void 0 : _a.call(props, { started_at, ended_at, action: isAltKeyHeld ? "remove" : "add" });
        }
      }
      setPosition({ top: 0, height: 0, left: 0, width: 0 });
    },
    // Don't actually render the selection box, we'll draw our own UI
    selectionProps: { style: { display: "none" } }
  });
  const style = useMemo(() => {
    if (!isDragMode) return {};
    function snap(px) {
      return Math.round(px / pxPerMinute / snapToMinutes) * snapToMinutes * pxPerMinute;
    }
    if (orientation === "vertical") {
      const top = position.top;
      const topSnapped = snap(top);
      const heightAdjustment = topSnapped - top;
      const height = snap(position.height - heightAdjustment);
      return { top: topSnapped, height, left: 0, right: 0 };
    }
    const left2 = position.left;
    const leftSnapped = snap(left2);
    const widthAdjustment = leftSnapped - left2;
    const width = snap(position.width - widthAdjustment);
    return { top: 0, bottom: 0, left: leftSnapped, width };
  }, [isDragMode, orientation, position, pxPerMinute, snapToMinutes]);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(DragSelection, null), isDragMode && /* @__PURE__ */ React__default.createElement("div", { className: styles$k.selectedArea, style }));
};
TimelineSelection.displayName = "Timeline.Selection";
const adjustableContainer = "_adjustableContainer_1joze_8";
const adjustHandle = "_adjustHandle_1joze_15";
const styles$j = {
  adjustableContainer,
  adjustHandle,
  "placement-start": "_placement-start_1joze_44",
  "placement-end": "_placement-end_1joze_47"
};
const TimelineAdjustableSelection = (props) => {
  const { offsetPx, sizePx, orientation, style, onSelectionEnd, onSelectonRemove, ...rest } = props;
  const dynamicStyles = timelineItemPositioning(props);
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      ...rest,
      style: { ...dynamicStyles, ...style },
      className: classNames(styles$j.adjustableContainer, props.className)
    },
    /* @__PURE__ */ React__default.createElement(AdjustHandle, { placement: "start" }),
    /* @__PURE__ */ React__default.createElement(AdjustHandle, { placement: "end" })
  );
};
TimelineAdjustableSelection.displayName = "Timeline.AdjustableSelection";
const AdjustHandle = (props) => {
  const { placement } = props;
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames(styles$j.adjustHandle, styles$j[`placement-${placement}`]),
      draggable: true,
      "data-adjust-handle": true,
      onDragStart: (e) => {
        console.info("@todo onDragStart", e);
      }
    }
  );
};
AdjustHandle.displayName = "Timeline.AdjustableSelection.Handle";
const suggestionContainer = "_suggestionContainer_1yqmn_8";
const rejectButton = "_rejectButton_1yqmn_50";
const styles$i = {
  suggestionContainer,
  rejectButton
};
const TimelineLaneSuggestionContainer = forwardRef((props, ref) => {
  const { offsetPx, sizePx, orientation, onDismiss, style, children, ...rest } = props;
  const isDismissable = !!props.onDismiss;
  const dynamicStyles = timelineItemPositioning(props);
  const handleDismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onDismiss == null ? void 0 : onDismiss();
  };
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      ...rest,
      ref,
      style: { ...dynamicStyles, ...style },
      className: classNames(styles$i.suggestionContainer, props.className)
    },
    isDismissable && /* @__PURE__ */ React__default.createElement(Tooltip, { side: "right", tooltip: "Delete Suggestion" }, /* @__PURE__ */ React__default.createElement("button", { className: styles$i.rejectButton, onClick: handleDismiss }, /* @__PURE__ */ React__default.createElement(SvgX, { width: 15, height: 15 }))),
    children
  );
});
TimelineLaneSuggestionContainer.displayName = "Timeline.Event";
const TimelineSuggestion = Object.assign(TimelineLaneSuggestionContainer, {});
TimelineSuggestion.displayName = "Timeline.TimelineSuggestion";
const container$6 = "_container_h5nen_8";
const content$1 = "_content_h5nen_18";
const active$3 = "_active_h5nen_21";
const styles$h = {
  container: container$6,
  content: content$1,
  active: active$3,
  "size-small": "_size-small_h5nen_35",
  "size-medium": "_size-medium_h5nen_50"
};
const SummaryContainer = React__default.forwardRef(
  (props, ref) => {
    const { offsetPx, orientation = "vertical", active: active2, style, ...rest } = props;
    return /* @__PURE__ */ React__default.createElement(
      Element$1,
      {
        ref,
        ...rest,
        style: {
          top: orientation === "vertical" ? offsetPx : void 0,
          left: orientation === "horizontal" ? offsetPx : void 0,
          ...style
        },
        className: classNames(styles$h.container, { [styles$h.active]: active2 }, props.className)
      },
      props.children
    );
  }
);
SummaryContainer.displayName = "Timeline.Lane.SummaryBlock";
const SummaryContent = React__default.forwardRef((props, ref) => {
  const {
    size = "medium",
    sizePx,
    orientation = "vertical",
    color = "rgba(0, 0, 0, 0.1)",
    style,
    ...rest
  } = props;
  return /* @__PURE__ */ React__default.createElement(
    Box$1.Column,
    {
      gap: "small",
      ref,
      ...rest,
      style: {
        height: orientation === "vertical" ? `${sizePx}px` : void 0,
        width: orientation === "horizontal" ? `${sizePx}px` : void 0,
        backgroundColor: color,
        "--summary-bg-color": color,
        // Add CSS variable for the fade effect
        ...style
      },
      className: classNames(styles$h.content, { [styles$h[`size-${size}`]]: !!size }, props.className)
    },
    props.children
  );
});
SummaryContent.displayName = "Timeline.Lane.SummaryBlock.Content";
const TimelineSummaryBlock = Object.assign(SummaryContainer, {
  /** SummaryContent display of content */
  Content: SummaryContent
});
TimelineSummaryBlock.displayName = "Timeline.SummaryBlock";
TimelineSummaryBlock.Content.displayName = "Timeline.SummaryBlock.Content";
const TimelineContainer = forwardRef((props, ref) => {
  const {
    orientation,
    ticksPerInterval,
    onZoomToPx,
    fromDateTime,
    pxPerMinute,
    maxPxPerMinute,
    minPxPerMinute,
    // local
    showFloatingControls,
    style,
    className,
    ...rest
  } = props;
  return /* @__PURE__ */ React__default.createElement(
    TimelineContextContainer,
    {
      ref,
      style,
      className,
      config: {
        orientation,
        ticksPerInterval,
        pxPerMinute,
        fromDateTime,
        onZoomToPx,
        maxPxPerMinute,
        minPxPerMinute
      }
    },
    /* @__PURE__ */ React__default.createElement(TimelineInnerScrollarea, { ...rest }),
    !!showFloatingControls && /* @__PURE__ */ React__default.createElement(Timeline.FloatingControls, null)
  );
});
TimelineContainer.displayName = "Timeline";
const TimelineInnerScrollarea = (props) => {
  const [scrollInitialized, setScrollInitialized] = React__default.useState(false);
  const {
    orientation,
    isZoomMode: isZoomMode2,
    isDragMode,
    isDragSubMode,
    isPanMode: isPanMode2,
    panRef,
    fromDateTime,
    pxPerMinute,
    scrollAreaRef
  } = useContext(TimelineContext);
  const { scrollStartDateTime = fromDateTime.plus({ hours: 6.5 }), ...rest } = props;
  const handleScrollToPx = useCallback(
    (distancePx, behavior) => {
      scrollAreaRef == null ? void 0 : scrollAreaRef.scroll({
        top: orientation === "vertical" ? distancePx : void 0,
        left: orientation === "horizontal" ? distancePx : void 0,
        behavior
      });
    },
    [scrollAreaRef, orientation]
  );
  const prevScrollTo = usePrevious(scrollStartDateTime);
  useEffect(() => {
    let scrollToDateTime;
    if (typeof scrollStartDateTime === "number") {
      scrollToDateTime = DateTime.now().minus({
        minutes: scrollStartDateTime * ((scrollAreaRef == null ? void 0 : scrollAreaRef.clientHeight) ?? 0) / pxPerMinute
      });
    } else if (scrollStartDateTime) {
      scrollToDateTime = scrollStartDateTime;
    } else {
      return;
    }
    const noChanges = !scrollAreaRef || !scrollToDateTime || (typeof prevScrollTo === "number" ? prevScrollTo === scrollStartDateTime : typeof scrollStartDateTime === "object" && (prevScrollTo == null ? void 0 : prevScrollTo.toUnixInteger()) === (scrollStartDateTime == null ? void 0 : scrollStartDateTime.toUnixInteger()));
    if (noChanges && scrollInitialized) return;
    if (!scrollInitialized) setScrollInitialized(true);
    if (!scrollToDateTime) return;
    const distancePx = scrollToDateTime.diff(fromDateTime, "minutes").minutes * pxPerMinute - // Account for column headers
    40;
    handleScrollToPx(distancePx, scrollInitialized ? "smooth" : void 0);
  }, [
    scrollStartDateTime,
    scrollAreaRef,
    prevScrollTo,
    scrollInitialized,
    fromDateTime,
    pxPerMinute,
    handleScrollToPx
  ]);
  const previousPixelsPerMinute = usePrevious(pxPerMinute);
  useEffectOnValueChange(pxPerMinute, () => {
    if (!scrollAreaRef || !scrollInitialized) return;
    const focalPoint = orientation === "horizontal" ? Math.pow(scrollAreaRef.clientWidth, 2) / scrollAreaRef.scrollWidth / 2 : Math.pow(scrollAreaRef.clientHeight, 2) / scrollAreaRef.scrollHeight / 2;
    const scale = pxPerMinute / previousPixelsPerMinute;
    const zoomDirection = scale > 1 ? 1 : -1;
    const distancePx = (scrollAreaRef.scrollTop + focalPoint * zoomDirection) * scale;
    handleScrollToPx(distancePx);
  });
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      ref: panRef,
      "data-timeline-orientation": orientation,
      "data-timeline-limit-interactions": isPanMode2 || isDragMode || isZoomMode2,
      "data-timeline-subtractive-interactions": isDragSubMode,
      ...rest,
      className: classNames(styles$n.timelineScrollarea, props.className)
    }
  );
};
TimelineInnerScrollarea.displayName = "Timeline.InnerScrollarea";
const TimelineLane = forwardRef((props, ref) => {
  const { minSizePx, maxSizePx, variant, style, separator: separator2, ...rest } = props;
  const { orientation, ticksPerInterval, pxPerMinute } = useContext(TimelineContext);
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      ref,
      style: {
        minWidth: orientation === "vertical" ? minSizePx : void 0,
        minHeight: orientation === "horizontal" ? minSizePx : void 0,
        maxWidth: orientation === "vertical" ? maxSizePx : void 0,
        maxHeight: orientation === "horizontal" ? maxSizePx : void 0,
        backgroundSize: orientation === "vertical" ? `100% ${pxPerMinute * 60 / ticksPerInterval}px` : ` ${pxPerMinute * 60 / ticksPerInterval}px 100%`,
        ...style
      },
      ...rest,
      "data-separator": separator2,
      className: classNames(
        styles$n.lane,
        styles$n[`lane-variant-${variant}`],
        styles$n[`separator-${separator2}`],
        props.className
      )
    }
  );
});
TimelineLane.displayName = "Timeline.Lane";
const TimelineLaneSublanes = forwardRef((props, ref) => {
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      ref,
      ...props,
      className: classNames(styles$n.laneSublanesContainer, props.className)
    }
  );
});
TimelineLaneSublanes.displayName = "Timeline.Lane.Sublanes";
const TimelineLaneHeader = forwardRef((props, ref) => {
  const { variant, interactive: interactive2, active: active2, children, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      ref,
      ...rest,
      className: classNames(styles$n.laneHeader, styles$n[`lane-variant-${variant}`]),
      "data-no-drag-select": true
    },
    /* @__PURE__ */ React__default.createElement(
      Box$1.Row,
      {
        gap: props.gap,
        className: classNames(
          styles$n.laneHeaderContent,
          {
            [styles$n.active]: active2 && interactive2,
            [styles$n.interactive]: interactive2
          },
          props.className
        )
      },
      children
    )
  );
});
TimelineLaneHeader.displayName = "Timeline.Lane.Header";
const TimelineLaneHeaderDropdownIndicator = ({ isOpen }) => {
  return /* @__PURE__ */ React__default.createElement(
    SvgDotsVertical,
    {
      style: {
        color: isOpen ? "var(--theme_color_content_normal)" : "var(--theme_color_content_subtle)",
        flexShrink: 0,
        flexBasis: 14
      }
    }
  );
};
TimelineLaneHeaderDropdownIndicator.displayName = "Timeline.Lane.Header.DropdownIndicator";
const TimelineLaneGutterMark = forwardRef(
  (props, ref) => {
    const { style, sizePx, offsetPx, ...rest } = props;
    const dynamicStyles = timelineItemPositioning(props);
    return /* @__PURE__ */ React__default.createElement(
      Element$1,
      {
        ref,
        ...rest,
        style: { ...dynamicStyles, ...style },
        className: classNames(styles$n.laneGutterMark, props.className)
      }
    );
  }
);
TimelineLaneGutterMark.displayName = "Timeline.Lane.GutterMark";
const TimelineGutter = forwardRef(({ variant, ...props }, ref) => {
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      ref,
      ...props,
      className: classNames(props.className, styles$n.gutterLane, styles$n[`lane-variant-${variant}`])
    }
  );
});
TimelineGutter.displayName = "Timeline.Gutter";
const TimelineStickyLanes = forwardRef((props, ref) => {
  return /* @__PURE__ */ React__default.createElement(Element$1, { ref, ...props, className: classNames(props.className, styles$n.stickyLanes) });
});
TimelineStickyLanes.displayName = "Timeline.StickyLanes";
const TimelineGutterInterval = forwardRef((props, ref) => {
  const { extraEmphasis: extraEmphasis2, sizePx, ...rest } = props;
  const { orientation } = useContext(TimelineContext);
  const style = orientation === "vertical" ? { height: sizePx } : { width: sizePx };
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      ref,
      ...rest,
      style: { ...rest.style, ...style },
      className: classNames(
        styles$n.interval,
        { [styles$n.extraEmphasis]: extraEmphasis2 },
        props.className
      )
    },
    /* @__PURE__ */ React__default.createElement(
      Text$1.Label,
      {
        size: "xxsmall",
        color: extraEmphasis2 ? "lowContrast" : "minContrast",
        className: styles$n.lifted
      },
      props.children
    )
  );
});
TimelineGutterInterval.displayName = "Timeline.Gutter.Interval";
const TimelineIndicator = forwardRef((props, ref) => {
  const { offsetPx, style, ...rest } = props;
  const { orientation } = useContext(TimelineContext);
  useInterval(60 * 1e3);
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      ref,
      ...rest,
      style: {
        top: orientation === "vertical" ? offsetPx : void 0,
        left: orientation === "horizontal" ? offsetPx : void 0,
        ...style
      },
      className: classNames(props.className, styles$n.indicator)
    }
  );
});
TimelineIndicator.displayName = "Timeline.Indicator";
const TimelineBackgroundIndicator = forwardRef(
  (props, ref) => {
    const { offsetPx, style, ...rest } = props;
    const { orientation } = useContext(TimelineContext);
    return /* @__PURE__ */ React__default.createElement(
      Element$1,
      {
        ref,
        ...rest,
        style: {
          top: orientation === "vertical" ? offsetPx : void 0,
          left: orientation === "horizontal" ? offsetPx : void 0,
          ...style
        },
        className: classNames(props.className, styles$n.backgroundIndicator)
      }
    );
  }
);
TimelineBackgroundIndicator.displayName = "Timeline.BackgroundIndicator";
const Timeline = Object.assign(TimelineContainer, {
  /** Timeline Gutter (e.g timestamp container) */
  Gutter: Object.assign(TimelineGutter, {
    /** Timeline Gutter Interval (e.g, time ticks)
     * @example <Timeline.Gutter.Interval sizePx={100} />
     * @note Reads from `Timeline.Context`
     */
    Interval: TimelineGutterInterval,
    /**
     * Gutter Header (e.g, gutter title)
     * @example <Timeline.Gutter.Header>GMT+1</Timeline.Gutter.Header>
     * @note Reads from `Timeline.Context`
     */
    Header: TimelineLaneHeader
  }),
  /**
   * Typically current time indicator
   * @example <Timeline.Indicator offsetPx={100} />
   * @note Reads from `Timeline.Context`
   */
  Indicator: TimelineIndicator,
  BackgroundIndicator: TimelineBackgroundIndicator,
  /** Stick one or more lanes to the left side of scrollable area */
  StickyLanes: TimelineStickyLanes,
  /**
   * Timeline Lane (e.g, memory lane)
   * @example <Timeline.Lane>
   *    <Timeline.Lane.Header>My Lane</Timeline.Lane.Header>
   *    <Timeline.Lane.Event sizePx={100} offsetPx={100}>
   *        Behold, an event!
   *    </Timeline.Lane.Event>
   * </Timeline.Lane>
   * @note Reads from `Timeline.Context`
   */
  Lane: Object.assign(TimelineLane, {
    /**
     * Lane Header (e.g, lane title)
     * @example <Timeline.Lane.Header>My Lane</Timeline.Lane.Header>
     */
    Header: Object.assign(TimelineLaneHeader, {
      DropdownIndicator: TimelineLaneHeaderDropdownIndicator
    }),
    /**
     * For `Timeline.Lane`'s that contain multiple sublanes, wrap them in this container
     */
    Sublanes: TimelineLaneSublanes,
    /** Place a `Memory` in a `Timeline.Lane`
     * @example <Timeline.Lane.Memory sizePx={100} offsetPx={100} />
     */
    Memory: TimelineMemory,
    /** Place an `Event` in a `Timeline.Lane`
     * @example <Timeline.Lane.Event sizePx={100} offsetPx={100} />
     */
    Event: TimelineEvent,
    /** Place a `Suggestion` (aka Interval Prediction) in a `Timeline.Lane`
     * @example <Timeline.Lane.Suggestion sizePx={100} offsetPx={100} />
     */
    Suggestion: TimelineSuggestion,
    /**
     * Place a `SummaryBlock` in a `Timeline.Lane`
     * @example <Timeline.Lane.SummaryBlock title="Summary Block" offsetPx={100} sizePx={100} />
     */
    SummaryBlock: TimelineSummaryBlock,
    /**
     * @todo Implement based on generic `Timeline` needs, see `ClickDragAdjust` for inspiration
     * @planned Not yet implemented past basic UI
     */
    AdjustableSelection: TimelineAdjustableSelection,
    /** Place a small mark/indicator in the left gutter of a lane, e.g to indicate logged time to a project */
    GutterMark: TimelineLaneGutterMark
  }),
  /**
   * Pan/Zoom controls floating on `Elevation` bottom/right of `Timeline`
   * @example <Timeline.FloatingControls />
   */
  FloatingControls: TimelineContextControls,
  /** Mark selection of time by click-dragging */
  Selection: TimelineSelection
});
Timeline.displayName = "Timeline";
Timeline.Lane.displayName = "Timeline.Lane";
Timeline.Lane.Header.displayName = "Timeline.Lane.Header";
Timeline.Lane.Sublanes.displayName = "Timeline.Lane.Sublanes";
Timeline.Lane.Memory.displayName = "Timeline.Lane.Memory";
Timeline.Lane.Event.displayName = "Timeline.Lane.Event";
Timeline.Lane.Suggestion.displayName = "Timeline.Lane.Suggestion";
Timeline.Lane.AdjustableSelection.displayName = "Timeline.Lane.AdjustableSelection";
Timeline.Selection.displayName = "Timeline.Selection";
Timeline.Lane.GutterMark.displayName = "Timeline.Lane.GutterMark";
Timeline.Gutter.Header.displayName = "Timeline.Gutter.Header";
Timeline.Gutter.Interval.displayName = "Timeline.Gutter.Interval";
Timeline.Lane.SummaryBlock.displayName = "Timeline.Lane.SummaryBlock";
Timeline.Gutter.displayName = "Timeline.Gutter";
Timeline.Indicator.displayName = "Timeline.Indicator";
Timeline.BackgroundIndicator.displayName = "Timeline.BackgroundIndicator";
Timeline.StickyLanes.displayName = "Timeline.StickyLanes";
Timeline.FloatingControls.displayName = "Timeline.FloatingControls";
const container$5 = "_container_fjhlx_5";
const item = "_item_fjhlx_11";
const disabled$2 = "_disabled_fjhlx_32";
const active$2 = "_active_fjhlx_36";
const styles$g = {
  container: container$5,
  item,
  disabled: disabled$2,
  active: active$2
};
function Container$4(props) {
  return /* @__PURE__ */ React__default.createElement(Element$1, { as: "ul", ...props, className: classNames(styles$g.container, props.className) });
}
function Item$1(props) {
  const { className, active: active2, disabled: disabled2, ...finalProps } = props;
  return /* @__PURE__ */ React__default.createElement(
    Element$1,
    {
      as: "li",
      ...finalProps,
      className: classNames(
        styles$g.item,
        { [styles$g.active]: active2, [styles$g.disabled]: disabled2 },
        className
      )
    }
  );
}
const Tabs = Object.assign(Container$4, {
  Item: Item$1
});
const container$4 = "_container_65ahp_5";
const fixed = "_fixed_65ahp_17";
const styles$f = {
  container: container$4,
  fixed,
  "variant-success": "_variant-success_65ahp_22",
  "variant-error": "_variant-error_65ahp_30",
  "variant-warning": "_variant-warning_65ahp_38",
  "variant-info": "_variant-info_65ahp_46"
};
const FloatingMessage = ({
  children,
  onDismiss,
  variant = "default",
  fixed: fixed2 = true,
  ...rest
}) => {
  return /* @__PURE__ */ React__default.createElement(
    Box$1.Row,
    {
      gap: "medium",
      padding: "medium",
      className: classNames(styles$f.container, styles$f[`variant-${variant}`], {
        [styles$f.fixed]: fixed2
      }),
      justifyContent: "center",
      as: Text$1,
      size: "small",
      ...rest
    },
    children,
    !!onDismiss && /* @__PURE__ */ React__default.createElement(Button$1, { onClick: onDismiss, size: "xsmall", priority: "low" }, /* @__PURE__ */ React__default.createElement(SvgXClose$1, null))
  );
};
FloatingMessage.displayName = "FloatingMessage";
const Spinner = (props) => /* @__PURE__ */ React__default.createElement(DotSpinner, { size: 16, color: "var(--theme_color_content_subtle)", ...props });
const skeleton = "_skeleton_ynwig_5";
const text = "_text_ynwig_8";
const truncated = "_truncated_ynwig_12";
const animate = "_animate_ynwig_16";
const skeletonLoad = "_skeletonLoad_ynwig_1";
const line = "_line_ynwig_33";
const styles$e = {
  skeleton,
  text,
  truncated,
  animate,
  skeletonLoad,
  "border-radius-small": "_border-radius-small_ynwig_23",
  "border-radius-medium": "_border-radius-medium_ynwig_26",
  "border-radius-large": "_border-radius-large_ynwig_29",
  line
};
const Box = memo((props) => {
  const {
    animate: animate2 = true,
    tooltip,
    borderRadius,
    className,
    ...finalProps
  } = transformSpecialCSSProperties(props);
  return /* @__PURE__ */ React__default.createElement(TooltipWrapper, { tooltip }, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames(styles$e.skeleton, className, {
        [styles$e.animate]: animate2,
        [styles$e[`border-radius-${borderRadius}`]]: !!borderRadius
      }),
      ...finalProps
    }
  ));
});
Box.displayName = "Skeleton.Box";
const Text = memo((props) => {
  const {
    type = "paragraph",
    size = "medium",
    animate: animate2 = true,
    lines = 1,
    truncateLastLine = false,
    borderRadius = "medium",
    tooltip,
    className,
    ...finalProps
  } = transformSpecialCSSProperties(props);
  return /* @__PURE__ */ React__default.createElement(TooltipWrapper, { tooltip }, /* @__PURE__ */ React__default.createElement("div", null, new Array(lines).fill(0).map((_, index) => /* @__PURE__ */ React__default.createElement(
    "div",
    {
      key: index,
      className: classNames(
        styles$e.line,
        className,
        textStyles[type],
        textStyles[`size-${size}`]
      ),
      ...finalProps
    },
    /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: classNames(
          styles$e.skeleton,
          styles$e.text,
          textStyles[type],
          textStyles[`size-${size}`],
          {
            [styles$e.animate]: animate2,
            [styles$e.truncated]: truncateLastLine && index === lines - 1,
            [styles$e[`border-radius-${borderRadius}`]]: !!borderRadius
          }
        )
      }
    )
  ))));
});
Text.displayName = "Skeleton.Text";
const Frame = memo((props) => {
  const {
    animate: animate2 = true,
    size,
    shape,
    tooltip,
    className,
    ...finalProps
  } = transformSpecialCSSProperties(props);
  return /* @__PURE__ */ React__default.createElement(TooltipWrapper, { tooltip }, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames(
        styles$e.skeleton,
        styles$e.frame,
        className,
        frameStyles.container,
        frameStyles[`size-${size}`],
        frameStyles[`shape-${shape}`],
        { [styles$e.animate]: animate2 }
      ),
      ...finalProps
    }
  ));
});
Frame.displayName = "Skeleton.Frame";
const TooltipWrapper = ({ children, tooltip }) => {
  if (tooltip) {
    return /* @__PURE__ */ React__default.createElement(Tooltip$1, { position: "top", tooltip }, children);
  }
  return children;
};
const Skeleton = {
  Box,
  Text,
  Frame
};
const containerFrame = "_containerFrame_2h8md_5";
const containerSidebar = "_containerSidebar_2h8md_13";
const containerMain = "_containerMain_2h8md_19";
const mainHeader = "_mainHeader_2h8md_26";
const mainContent = "_mainContent_2h8md_33";
const mainFooter = "_mainFooter_2h8md_66";
const styles$d = {
  containerFrame,
  containerSidebar,
  containerMain,
  mainHeader,
  mainContent,
  mainFooter,
  "variant-in-modal": "_variant-in-modal_2h8md_72"
};
const cvaMultipleChoice = cva(styles$d.containerMultipleChoice, {
  variants: {
    variant: {
      default: styles$d["variant-default"]
    }
  },
  defaultVariants: { variant: "default" }
});
function MultipleChoice(props) {
  var _a, _b;
  const {
    variant,
    asChild,
    size = "small",
    defaultOption,
    children,
    name,
    control,
    options,
    defaultValueHidesOptions = false,
    title,
    description,
    forwardedRef,
    ...rest
  } = props;
  const Component2 = asChild ? Slot : Box$1.Column;
  const {
    field,
    formState: { errors }
  } = useController({
    name,
    control,
    rules: { required: true }
  });
  const hideOptions = (defaultOption == null ? void 0 : defaultOption.value) === field.value && !!defaultValueHidesOptions;
  const defaultFallbackOption = options.find((o) => o.value === (defaultOption == null ? void 0 : defaultOption.fallbackToValue));
  return /* @__PURE__ */ React__default.createElement(
    Component2,
    {
      gap: "large",
      ...rest,
      ref: forwardedRef,
      className: cvaMultipleChoice({
        variant,
        className: rest.className
      })
    },
    /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, (!!title || !!description) && /* @__PURE__ */ React__default.createElement(Box$1.Column, { gap: "small" }, !!title && /* @__PURE__ */ React__default.createElement(Text$1.Label, { size: "large" }, title), !!description && /* @__PURE__ */ React__default.createElement(Text$1.Paragraph, { color: "subtle", size: "medium" }, description)), !!defaultOption && /* @__PURE__ */ React__default.createElement(Box$1.Row, { gap: "medium", style: { paddingBottom: 4 * 2 } }, /* @__PURE__ */ React__default.createElement(
      Form.Input,
      {
        id: `use-default-${field.name}-${field.value}`,
        "data-testid": `use-default-${field.name}-${field.value}`,
        ...field,
        value: `${defaultOption.value}`,
        type: defaultOption.type || "checkbox",
        checked: isChecked(defaultOption.value, field.value),
        onChange: () => {
          const value = defaultOption.value === field.value ? defaultOption.fallbackToValue || options[0].value : defaultOption.value;
          field.onChange(value);
        }
      }
    ), /* @__PURE__ */ React__default.createElement(Form.Label, { htmlFor: `use-default-${field.name}-${field.value}`, size }, defaultOption.label || "Don't customize", !!defaultFallbackOption && isChecked(defaultOption.value, field.value) && /* @__PURE__ */ React__default.createElement(Text$1.Label, { size: "xsmall", color: "subtle" }, '  (use "', defaultFallbackOption.label, '")'))), !hideOptions && options.map((option2) => {
      const id = `mc-${field.name}-${option2.value}-${option2.label}`;
      const checked2 = isChecked(option2.value, field.value);
      const color = (defaultOption == null ? void 0 : defaultOption.value) === field.value ? "subtle" : void 0;
      return /* @__PURE__ */ React__default.createElement(Box$1.Row, { gap: "medium", key: id }, /* @__PURE__ */ React__default.createElement(
        Form.Input,
        {
          id,
          "data-testid": id,
          type: option2.type || "radio",
          ...field,
          value: `${option2.value}`,
          checked: checked2
        }
      ), /* @__PURE__ */ React__default.createElement(Form.Label, { htmlFor: id, size, color }, option2.label, (defaultOption == null ? void 0 : defaultOption.fallbackToValue) === option2.value && /* @__PURE__ */ React__default.createElement(Text$1.Label, { size: "xsmall", color: "subtle" }, " (default)"), !!option2.helpText && /* @__PURE__ */ React__default.createElement(Text$1.Label, { size: "xsmall", color: "subtle" }, " ", option2.helpText)));
    }), typeof ((_a = errors == null ? void 0 : errors[field.name]) == null ? void 0 : _a.message) === "string" && /* @__PURE__ */ React__default.createElement(Form.Error, null, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, (_b = errors == null ? void 0 : errors[field.name]) == null ? void 0 : _b.message)), children)
  );
}
MultipleChoice.displayName = "Settings.FormControls.MultipleChoice";
const isChecked = (optionValue, fieldValue) => {
  return optionValue === fieldValue || +fieldValue === optionValue || Boolean(fieldValue) === optionValue;
};
const SettingsFormControls = {
  MultipleChoice
};
const wizardContainer = "_wizardContainer_143sx_5";
const wizardSidebar = "_wizardSidebar_143sx_13";
const wizardStep = "_wizardStep_143sx_19";
const wizardStepHeader = "_wizardStepHeader_143sx_26";
const wizardStepContent = "_wizardStepContent_143sx_33";
const wizardStepFooter = "_wizardStepFooter_143sx_66";
const wizardMain = "_wizardMain_143sx_96";
const styles$c = {
  wizardContainer,
  wizardSidebar,
  wizardStep,
  wizardStepHeader,
  wizardStepContent,
  wizardStepFooter,
  wizardMain
};
function createSyntheticEvent(type, target) {
  const event = new Event(type);
  Object.defineProperty(event, "target", { writable: false, value: target });
  let prevented = false;
  let stopped = false;
  return {
    ...event,
    nativeEvent: event,
    currentTarget: target,
    target,
    isDefaultPrevented: () => prevented,
    isPropagationStopped: () => stopped,
    persist: () => {
    },
    preventDefault: () => {
      prevented = true;
      event.preventDefault();
    },
    stopPropagation: () => {
      stopped = true;
      event.stopPropagation();
    }
  };
}
const srcHealthCache = /* @__PURE__ */ new Map();
const Image = React__default.forwardRef(
  ({
    decoding = "async",
    fallback,
    loading = "lazy",
    onError,
    onLoad,
    sizes,
    src,
    srcSet,
    ...rest
  }, forwardedRef) => {
    const srcIsBad = !src || typeof src === "string" && srcHealthCache.get(src) === false;
    const fallbackSrcIsBad = typeof fallback !== "string" || srcHealthCache.get(fallback) === false;
    const [showFallbackElement, setShowFallback] = useState(srcIsBad && fallbackSrcIsBad);
    const handleLoad = useCallback(
      (e) => {
        const img = e.target;
        if (e.type === "error") {
          srcHealthCache.set(img.currentSrc, false);
          if (typeof fallback === "string" && srcHealthCache.get(fallback) !== false) {
            img.src = fallback;
          } else {
            setShowFallback(true);
          }
        } else {
          srcHealthCache.set(img.currentSrc, true);
        }
      },
      [fallback]
    );
    const ref = useCallback(
      (img) => {
        if (forwardedRef) {
          if (typeof forwardedRef === "function") {
            forwardedRef(img);
          } else if (typeof forwardedRef === "object") {
            forwardedRef.current = img;
          }
        }
        if (img == null ? void 0 : img.complete) {
          handleLoad(createSyntheticEvent("load", img));
        }
      },
      [forwardedRef, handleLoad]
    );
    if (showFallbackElement) {
      return React__default.isValidElement(fallback) ? fallback : null;
    }
    const srcOrFallback = srcIsBad && typeof fallback === "string" && !fallbackSrcIsBad ? fallback : src;
    return /* @__PURE__ */ React__default.createElement(
      "img",
      {
        ...rest,
        decoding,
        loading,
        onLoad: (e) => {
          handleLoad(e);
          onLoad == null ? void 0 : onLoad(e);
        },
        onError: (e) => {
          handleLoad(e);
          onError == null ? void 0 : onError(e);
        },
        sizes,
        srcSet,
        src: srcOrFallback,
        ref
      }
    );
  }
);
Image.displayName = "Image";
const cvaWizard = cva(styles$c.wizardContainer);
const SettingsWizard = React__default.forwardRef(
  ({ asChild, children, ...props }, forwardedRef) => {
    const Component2 = asChild ? Slot : "div";
    return /* @__PURE__ */ React__default.createElement(
      Component2,
      {
        ...props,
        ref: forwardedRef,
        className: cvaWizard({ className: props.className })
      },
      children
    );
  }
);
SettingsWizard.displayName = "Settings.Wizard";
const SettingsWizardSidebar = React__default.forwardRef(
  ({ wizard, icon: icon2, title, description, asChild, children, ...props }, forwardedRef) => {
    const Component2 = asChild ? Slot : "aside";
    return /* @__PURE__ */ React__default.createElement(Component2, { ...props, ref: forwardedRef, className: styles$c.wizardSidebar }, /* @__PURE__ */ React__default.createElement(Box$1.Column, { height: "100%", padding: "xlarge", gap: "xlarge" }, (icon2 || title || description) && /* @__PURE__ */ React__default.createElement(Box$1.Column, { gap: "small", marginBottom: 4 * 10 }, icon2 && /* @__PURE__ */ React__default.createElement(Box$1, { marginBottom: 4 * 2 }, typeof icon2 === "string" ? /* @__PURE__ */ React__default.createElement(Image, { src: icon2, width: 48, height: 48, style: { borderRadius: 8 } }) : icon2), title && /* @__PURE__ */ React__default.createElement(Text$1.Headline, { size: "xsmall" }, title), description && /* @__PURE__ */ React__default.createElement(Text$1, { color: "subtle" }, description)), /* @__PURE__ */ React__default.createElement(Wizard.ProgressList, { wizard }), /* @__PURE__ */ React__default.createElement(Box$1.Spacer, null), children));
  }
);
SettingsWizardSidebar.displayName = "Settings.Wizard.Sidebar";
const SettingsWizardStep = React__default.forwardRef(
  ({ asChild, children, ...props }, forwardedRef) => {
    const Component2 = asChild ? Slot : "div";
    return /* @__PURE__ */ React__default.createElement(Component2, { ...props, ref: forwardedRef, className: styles$c.wizardStep }, children);
  }
);
SettingsWizardStep.displayName = "Settings.Wizard.Step";
const SettingsWizardStepHeader = React__default.forwardRef(
  ({ title, description, asChild, children, ...props }, forwardedRef) => {
    const Component2 = asChild ? Slot : "div";
    return /* @__PURE__ */ React__default.createElement(Component2, { ...props, ref: forwardedRef, className: styles$c.wizardStepHeader }, /* @__PURE__ */ React__default.createElement(Box$1.Row, { gap: "medium", alignItems: "center" }, /* @__PURE__ */ React__default.createElement(Box$1.Column, { gap: "small" }, title && /* @__PURE__ */ React__default.createElement(Text$1.Headline, { size: "small" }, title), description && /* @__PURE__ */ React__default.createElement(Text$1, { color: "subtle" }, description))), children);
  }
);
SettingsWizardStepHeader.displayName = "Settings.Wizard.Step.Header";
const SettingsWizardStepContent = React__default.forwardRef(
  ({ asChild, children, ...props }, forwardedRef) => {
    const Component2 = asChild ? Slot : "div";
    return /* @__PURE__ */ React__default.createElement(Component2, { ...props, ref: forwardedRef, className: styles$c.wizardStepContent }, children);
  }
);
SettingsWizardStepContent.displayName = "Settings.Wizard.Step.Content";
const SettingsWizardStepFooter = React__default.forwardRef(
  ({ asChild, ...props }, forwardedRef) => {
    const Component2 = asChild ? Slot : Box$1.Row;
    return /* @__PURE__ */ React__default.createElement(
      Component2,
      {
        gap: "large",
        justifyContent: "flex-end",
        ...props,
        ref: forwardedRef,
        className: styles$c.wizardStepFooter
      }
    );
  }
);
SettingsWizardStepFooter.displayName = "Settings.Wizard.Step.Footer";
const SettingsWizardMain = React__default.forwardRef(
  ({ children, ...props }, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement("div", { ...props, ref: forwardedRef, className: styles$c.wizardMain }, children);
  }
);
SettingsWizardMain.displayName = "Settings.Wizard.Main";
const SettingsWizardComponents = {
  Root: SettingsWizard,
  Sidebar: SettingsWizardSidebar,
  Main: SettingsWizardMain,
  Step: Object.assign(SettingsWizardStep, {
    Header: SettingsWizardStepHeader,
    Content: SettingsWizardStepContent,
    Footer: SettingsWizardStepFooter
  })
};
const cvaFrame = cva(styles$d.containerFrame, {
  variants: {
    variant: {
      modal: styles$d["variant-in-modal"],
      fullscreen: styles$d["variant-fullscreen"]
      /**
       * TODO 'wizardModal' variant
       * * ref apps/timely-frontend/src/domains/integrations/components/setup_wizard/Integrations.SetupWizard.module.scss
       * * Create thin wrapper ala `Settings.Wizard`, with it's own special components?, e.g:
       *  `Wizard.Step`, `Wizard.Step.Header`, `Wizard.Step.Content`, `Wizard.Step.Footer`,
       * * Use framer-motion for transitions.
       */
    }
  },
  defaultVariants: { variant: "fullscreen" }
});
const SettingsRoot = React__default.forwardRef(
  ({ variant, asChild, ...props }, forwardedRef) => {
    const Component2 = asChild ? Slot : "div";
    return /* @__PURE__ */ React__default.createElement(
      Component2,
      {
        ...props,
        ref: forwardedRef,
        className: cvaFrame({
          variant,
          className: props.className
        })
      }
    );
  }
);
SettingsRoot.displayName = "Settings";
const cvaSidebar = cva(styles$d.containerSidebar);
const SettingsSidebar = React__default.forwardRef(
  ({ asChild, ...props }, forwardedRef) => {
    const Component2 = asChild ? Slot : "aside";
    return /* @__PURE__ */ React__default.createElement(
      Component2,
      {
        ...props,
        ref: forwardedRef,
        className: cvaSidebar({ className: props.className })
      }
    );
  }
);
SettingsSidebar.displayName = "Settings.Sidebar";
const cvaMain = cva(styles$d.containerMain);
const SettingsMain = React__default.forwardRef(
  ({ asChild, ...props }, forwardedRef) => {
    const Component2 = asChild ? Slot : "main";
    return /* @__PURE__ */ React__default.createElement(
      Component2,
      {
        ...props,
        ref: forwardedRef,
        className: cvaMain({ className: props.className })
      }
    );
  }
);
SettingsMain.displayName = "Settings.Main";
const cvaMainHeader = cva(styles$d.mainHeader);
const SettingsMainHeader = React__default.forwardRef(
  ({ children, asChild, title, ...props }, forwardedRef) => {
    const Component2 = asChild ? Slot : "div";
    return /* @__PURE__ */ React__default.createElement(
      Component2,
      {
        ...props,
        ref: forwardedRef,
        className: cvaMainHeader({ className: props.className })
      },
      /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, !!title && /* @__PURE__ */ React__default.createElement(Text$1.Headline, { size: "small" }, title), children)
    );
  }
);
SettingsMainHeader.displayName = "Settings.Main.Header";
const cvaMainContent = cva(styles$d.mainContent);
const SettingsMainContent = React__default.forwardRef(
  ({ asChild, ...props }, forwardedRef) => {
    const Component2 = asChild ? Slot : "main";
    return /* @__PURE__ */ React__default.createElement(
      Component2,
      {
        ...props,
        ref: forwardedRef,
        className: cvaMainContent({ className: props.className })
      }
    );
  }
);
SettingsMainContent.displayName = "Settings.Main.Content";
const EmptyMainContent = React__default.forwardRef(
  ({ children, ...props }, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(SettingsMainContent, { ...props, ref: forwardedRef }, /* @__PURE__ */ React__default.createElement(Box$1.Column, { gap: "large", alignItems: "center", justifyContent: "center", height: "100%" }, children));
  }
);
EmptyMainContent.displayName = "Settings.Empty.MainContent";
const EmptyMainContentLoader = React__default.forwardRef(({ children, loadingText, ...props }, forwardedRef) => {
  return /* @__PURE__ */ React__default.createElement(EmptyMainContent, { ...props, ref: forwardedRef }, /* @__PURE__ */ React__default.createElement(Spinner, null), /* @__PURE__ */ React__default.createElement(Text$1.Label, { color: "subtle", size: "xsmall" }, loadingText || "Loading..."), children);
});
EmptyMainContent.displayName = "Settings.Empty.MainContent";
const cvaMainFooter = cva(styles$d.mainFooter);
const SettingsMainFooter = React__default.forwardRef(
  ({ asChild, ...props }, forwardedRef) => {
    const Component2 = asChild ? Slot : Box$1.Row;
    return /* @__PURE__ */ React__default.createElement(
      Component2,
      {
        gap: "large",
        ...props,
        ref: forwardedRef,
        className: cvaMainFooter({ className: props.className })
      }
    );
  }
);
SettingsMainFooter.displayName = "Settings.Main.Footer";
const Settings = Object.assign(SettingsRoot, {
  Sidebar: SettingsSidebar,
  Main: Object.assign(SettingsMain, {
    Header: SettingsMainHeader,
    Content: SettingsMainContent,
    Empty: {
      Content: EmptyMainContent,
      ContentLoader: EmptyMainContentLoader
    },
    Footer: SettingsMainFooter
  }),
  Wizard: SettingsWizardComponents,
  FormControls: SettingsFormControls
});
Settings.displayName = "Settings";
const listContainer = "_listContainer_1jm2s_9";
const listItem = "_listItem_1jm2s_50";
const interactive$1 = "_interactive_1jm2s_68";
const active$1 = "_active_1jm2s_74";
const disabled$1 = "_disabled_1jm2s_78";
const listItemIcon = "_listItemIcon_1jm2s_82";
const listHeader = "_listHeader_1jm2s_95";
const listSeparator = "_listSeparator_1jm2s_195";
const styles$b = {
  listContainer,
  "orientation-horizontal": "_orientation-horizontal_1jm2s_39",
  "orientation-vertical": "_orientation-vertical_1jm2s_42",
  listItem,
  interactive: interactive$1,
  active: active$1,
  disabled: disabled$1,
  listItemIcon,
  listHeader,
  "size-xsmall": "_size-xsmall_1jm2s_110",
  "size-small": "_size-small_1jm2s_131",
  "size-medium": "_size-medium_1jm2s_152",
  "size-large": "_size-large_1jm2s_173",
  listSeparator
};
const Container$3 = React__default.forwardRef((props, ref) => {
  const {
    asChild,
    className,
    orientation = "vertical",
    ...finalProps
  } = transformSpecialCSSProperties(props);
  const Component2 = asChild ? Slot : "ul";
  return /* @__PURE__ */ React__default.createElement(
    Component2,
    {
      ...finalProps,
      className: classNames(styles$b.listContainer, styles$b[`orientation-${orientation}`], className),
      ref
    }
  );
});
Container$3.displayName = "List.Container";
const Item = React__default.forwardRef((props, ref) => {
  const {
    asChild,
    className,
    interactive: interactive2 = true,
    size = "small",
    active: active2,
    onClick,
    preventDefault,
    stopPropagation,
    style,
    htmlFor,
    as,
    indentation = 0,
    ...finalProps
  } = transformSpecialCSSProperties(props);
  const handleClick = useCallback(
    (e) => {
      if (preventDefault) e.preventDefault();
      if (stopPropagation) e.stopPropagation();
      onClick == null ? void 0 : onClick(e);
    },
    [onClick, preventDefault, stopPropagation]
  );
  const finalStyle = {
    ...style,
    marginLeft: props.indentation ? indentation * 16 : style == null ? void 0 : style.marginLeft
  };
  const fallbackElement = as || "li";
  const Component2 = asChild ? Slot : htmlFor ? "label" : fallbackElement;
  return /* @__PURE__ */ React__default.createElement(
    Component2,
    {
      ...finalProps,
      style: finalStyle,
      ref,
      onClick: handleClick,
      className: classNames(
        styles$b.listItem,
        styles$b[`size-${size}`],
        {
          // States
          [styles$b.interactive]: interactive2 && !props.disabled,
          [styles$b.active]: active2 && !props.disabled,
          [styles$b.disabled]: props.disabled
        },
        className
      )
    }
  );
});
Item.displayName = "List.Item";
const ListItemIcon = React__default.forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ React__default.createElement("div", { ...props, className: classNames(styles$b.listItemIcon, props.className), ref: forwardedRef }, "src" in props ? /* @__PURE__ */ React__default.createElement(Image, { src: props.src }) : "children" in props && props.children);
});
ListItemIcon.displayName = "List.Item.Icon";
const ListItemInteractive = React__default.forwardRef((props, ref) => {
  return /* @__PURE__ */ React__default.createElement(
    Item,
    {
      ...props,
      className: classNames(styles$b.listItemInteractive, props.className),
      ref,
      size: "small",
      as: "div"
    }
  );
});
ListItemInteractive.displayName = "List.Item.Interactive";
const Header$1 = React__default.forwardRef((props, ref) => {
  const {
    asChild,
    interactive: interactive2 = false,
    active: active2,
    stopPropagation,
    preventDefault,
    className,
    onClick,
    size = "small",
    ...finalProps
  } = transformSpecialCSSProperties(props);
  const Component2 = asChild ? Slot : "li";
  return /* @__PURE__ */ React__default.createElement(
    Component2,
    {
      ...finalProps,
      onClick: !props.disabled ? onClick : void 0,
      className: classNames(
        styles$b.listHeader,
        styles$b[`size-${size}`],
        {
          [styles$b.interactive]: interactive2 && !props.disabled,
          [styles$b.active]: active2 && !props.disabled
        },
        className
      ),
      ref
    }
  );
});
Header$1.displayName = "List.Header";
function Separator({ className, ...rest }) {
  return /* @__PURE__ */ React__default.createElement("div", { ...rest, className: classNames(styles$b.listSeparator, className) }, /* @__PURE__ */ React__default.createElement("div", null));
}
Separator.displayName = "List.Separator";
const List = Object.assign(Container$3, {
  Container: Container$3,
  Item: Object.assign(Item, {
    Icon: ListItemIcon,
    Interactive: ListItemInteractive
  }),
  Header: Header$1,
  Separator
});
const pillContainer = "_pillContainer_nb1c9_5";
const prefix = "_prefix_nb1c9_16";
const postfix = "_postfix_nb1c9_20";
const styles$a = {
  pillContainer,
  prefix,
  postfix,
  "size-xsmall": "_size-xsmall_nb1c9_28",
  "size-small": "_size-small_nb1c9_39",
  "size-medium": "_size-medium_nb1c9_49",
  "variant-normal": "_variant-normal_nb1c9_63",
  "variant-subtle": "_variant-subtle_nb1c9_68",
  "variant-success": "_variant-success_nb1c9_74",
  "variant-alert": "_variant-alert_nb1c9_79",
  "variant-danger": "_variant-danger_nb1c9_84"
};
const cvaPill = cva(styles$a.pillContainer, {
  variants: {
    variant: {
      subtle: styles$a["variant-subtle"],
      normal: styles$a["variant-normal"],
      success: styles$a["variant-success"],
      alert: styles$a["variant-alert"],
      danger: styles$a["variant-danger"]
    },
    size: {
      xsmall: styles$a["size-xsmall"],
      small: styles$a["size-small"],
      medium: styles$a["size-medium"]
    }
  },
  defaultVariants: { variant: "subtle", size: "medium" }
});
const Pill = React__default.forwardRef((props, ref) => {
  const { asChild, className, pre, post, variant, size, ...rest } = props;
  const Component2 = asChild ? Slot : "span";
  return /* @__PURE__ */ React__default.createElement(Component2, { ref, ...rest, className: cvaPill({ variant, size, className }) }, !!pre && /* @__PURE__ */ React__default.createElement("span", { className: styles$a.prefix }, pre), /* @__PURE__ */ React__default.createElement(Slottable, null, props.children), !!post && /* @__PURE__ */ React__default.createElement("span", { className: styles$a.postfix }, post));
});
const container$3 = "_container_16w5e_8";
const input = "_input_16w5e_17";
const invalid = "_invalid_16w5e_85";
const label = "_label_16w5e_170";
const error = "_error_16w5e_190";
const styles$9 = {
  container: container$3,
  input,
  "size-xsmall": "_size-xsmall_16w5e_68",
  "size-small": "_size-small_16w5e_73",
  "size-medium": "_size-medium_16w5e_77",
  "size-large": "_size-large_16w5e_81",
  invalid,
  label,
  error
};
const Container$2 = React__default.forwardRef((props, ref) => {
  const { className, ...finalProps } = transformSpecialCSSProperties(props);
  return /* @__PURE__ */ React__default.createElement("form", { ...finalProps, className: classNames(styles$9.container, className), ref });
});
const Input$1 = React__default.forwardRef((props, ref) => {
  const {
    className,
    size = "medium",
    type = "text",
    invalid: invalid2,
    ...finalProps
  } = transformSpecialCSSProperties(props);
  return /* @__PURE__ */ React__default.createElement(
    "input",
    {
      autoCorrect: "off",
      autoCapitalize: "none",
      ...finalProps,
      type,
      className: classNames(
        styles$9.input,
        styles$9[`size-${size}`],
        { [styles$9.invalid]: invalid2 },
        className
      ),
      ref
    }
  );
});
const Radio = React__default.forwardRef((props, ref) => {
  return /* @__PURE__ */ React__default.createElement(Input$1, { ...props, type: "radio", ref });
});
const Checkbox = React__default.forwardRef((props, ref) => {
  return /* @__PURE__ */ React__default.createElement(Input$1, { ...props, type: "checkbox", ref });
});
const Select = React__default.forwardRef((props, ref) => {
  const { className, size = "medium", ...finalProps } = transformSpecialCSSProperties(props);
  return /* @__PURE__ */ React__default.createElement(
    "select",
    {
      ...finalProps,
      className: classNames(styles$9.input, styles$9[`size-${size}`], className),
      ref
    }
  );
});
const Label = React__default.forwardRef((props, ref) => {
  return /* @__PURE__ */ React__default.createElement(
    Text$1.Label,
    {
      color: props.disabled ? "lowContrast" : void 0,
      ...props,
      className: classNames(styles$9.label, props.className),
      ref
    },
    props.children
  );
});
const Textarea = React__default.forwardRef((props, ref) => {
  const { className, size = "medium", ...finalProps } = transformSpecialCSSProperties(props);
  return /* @__PURE__ */ React__default.createElement(
    "textarea",
    {
      ...finalProps,
      className: classNames(styles$9.input, styles$9[`size-${size}`], className),
      ref
    }
  );
});
const Error$1 = React__default.forwardRef((props, ref) => {
  if (!props.children && !props.errorMessage) return null;
  return /* @__PURE__ */ React__default.createElement(
    Text$1.Label,
    {
      as: "div",
      size: "xsmall",
      ...props,
      className: classNames(styles$9.error, props.className),
      ref
    },
    props.errorMessage || props.children
  );
});
const Form = Object.assign(Container$2, {
  /** Text input field; See more specific implementations for other elements */
  Input: Input$1,
  /** A form label, pairs nicely with `Input` */
  Label,
  /** Simple radio */
  Radio,
  /** Simple checkbox */
  Checkbox,
  /** Simple select */
  Select,
  /** Simple textarea */
  Textarea,
  /** Feed it error messages from Zod/react-form-hook as string. Doesn't render unless it's got errors */
  Error: Error$1
});
const container$2 = "_container_ibaux_11";
const header = "_header_ibaux_20";
const selectedIndicator = "_selectedIndicator_ibaux_27";
const interactive = "_interactive_ibaux_38";
const selected = "_selected_ibaux_27";
const disabled = "_disabled_ibaux_65";
const coverImage = "_coverImage_ibaux_79";
const propertyList = "_propertyList_ibaux_113";
const visibleOnInteraction = "_visibleOnInteraction_ibaux_129";
const styles$8 = {
  container: container$2,
  header,
  selectedIndicator,
  interactive,
  selected,
  disabled,
  "size-medium": "_size-medium_ibaux_75",
  coverImage,
  "size-small": "_size-small_ibaux_94",
  propertyList,
  visibleOnInteraction
};
const cvaCard = cva(styles$8.container, {
  variants: {
    // variant: {
    //   default: styles['variant-default'],
    // },
    interactive: {
      true: styles$8.interactive
    },
    selected: {
      true: [styles$8.interactive, styles$8.selected]
    },
    disabled: {
      true: styles$8.disabled
    },
    size: {
      medium: styles$8["size-medium"],
      small: styles$8["size-small"]
    }
  },
  defaultVariants: { size: "medium", interactive: false, selected: false }
});
const Container$1 = React__default.forwardRef((props, ref) => {
  const {
    asChild,
    children,
    className,
    // Make interactive default to true if variant is 'asRadioOption'
    interactive: _interactive,
    selected: selected2,
    disabled: disabled2,
    size = "medium",
    fancyCheck = false,
    ...rest
  } = props;
  const Component2 = asChild ? Slot : Box$1.Column;
  const interactive2 = _interactive && !disabled2 ? true : false;
  return /* @__PURE__ */ React__default.createElement(
    Component2,
    {
      ref,
      ...rest,
      className: cvaCard({ selected: selected2, interactive: interactive2, size, disabled: disabled2, className })
    },
    !!fancyCheck && /* @__PURE__ */ React__default.createElement(SvgCheckCircle, { className: styles$8.selectedIndicator }),
    /* @__PURE__ */ React__default.createElement(Slottable, null, children)
  );
});
const FormRadioContainer = React__default.forwardRef(
  (props, ref) => {
    const {
      children,
      selected: selected2,
      disabled: disabled2 = false,
      interactive: interactiveProp,
      size,
      fancyCheck = false,
      className,
      ...rest
    } = props;
    const id = props.id || `card-radio-${props.name}-${props.value}`;
    const checked2 = rest.checked || selected2;
    return /* @__PURE__ */ React__default.createElement(
      Container$1,
      {
        size,
        interactive: true,
        selected: checked2,
        fancyCheck,
        disabled: disabled2,
        asChild: true
      },
      /* @__PURE__ */ React__default.createElement("label", { "data-unset-style": true, htmlFor: id }, children, /* @__PURE__ */ React__default.createElement(
        "input",
        {
          ref,
          id,
          type: rest.type || "radio",
          checked: checked2,
          style: { position: "absolute", width: 0, height: 0, opacity: 0 },
          disabled: disabled2,
          ...rest
        }
      ))
    );
  }
);
const Header = React__default.forwardRef((props, ref) => {
  const { asChild, className, ...rest } = props;
  const Component2 = asChild ? Slot : Box$1.Row;
  return /* @__PURE__ */ React__default.createElement(Component2, { ref, gap: "large", ...rest, className: classNames(styles$8.header, className) });
});
const CoverImage = React__default.forwardRef((props, ref) => {
  const { asChild, className, ...rest } = props;
  const Component2 = asChild ? Slot : "div";
  return /* @__PURE__ */ React__default.createElement(
    Component2,
    {
      ref,
      gap: "large",
      ...rest,
      className: classNames(styles$8.coverImage, className)
    }
  );
});
const Body = React__default.forwardRef((props, ref) => {
  const { asChild, className, ...rest } = props;
  const Component2 = asChild ? Slot : Box$1.Row;
  return /* @__PURE__ */ React__default.createElement(Component2, { ref, ...rest, className: classNames(styles$8.body, className) });
});
const PropertyList = React__default.forwardRef((props, ref) => {
  const { asChild, children, className, ...rest } = props;
  const Component2 = asChild ? Slot : "div";
  return /* @__PURE__ */ React__default.createElement(Component2, { ref, ...rest, className: classNames(className) }, /* @__PURE__ */ React__default.createElement(Box$1.Row, { gap: "medium", justifyContent: "middle", className: styles$8.propertyList }, children));
});
const VisibleOnInteraction = React__default.forwardRef(
  (props, ref) => {
    const { asChild, className, ...rest } = props;
    const Component2 = asChild ? Slot : "span";
    return /* @__PURE__ */ React__default.createElement(
      Component2,
      {
        ref,
        ...rest,
        className: classNames(styles$8.visibleOnInteraction, className)
      }
    );
  }
);
const Card = Object.assign(Container$1, {
  Container: Container$1,
  // exported for legacy reasons, remove in future
  CoverImage,
  Header,
  Body,
  PropertyList,
  VisibleOnInteraction,
  Form: {
    Radio: FormRadioContainer
  }
});
const messageContainer = "_messageContainer_1d6t5_9";
const icon = "_icon_1d6t5_16";
const dismissButton = "_dismissButton_1d6t5_21";
const styles$7 = {
  messageContainer,
  icon,
  dismissButton,
  "size-small": "_size-small_1d6t5_47",
  "auto-icon": "_auto-icon_1d6t5_52",
  "size-medium": "_size-medium_1d6t5_61",
  "variant-neutral": "_variant-neutral_1d6t5_78",
  "variant-info": "_variant-info_1d6t5_86",
  "variant-alert": "_variant-alert_1d6t5_94",
  "variant-danger": "_variant-danger_1d6t5_102",
  "variant-success": "_variant-success_1d6t5_110",
  "variant-warning": "_variant-warning_1d6t5_118"
};
const cvaMessage = cva(styles$7.messageContainer, {
  variants: {
    variant: {
      neutral: styles$7["variant-neutral"],
      info: styles$7["variant-info"],
      alert: styles$7["variant-alert"],
      danger: styles$7["variant-danger"],
      success: styles$7["variant-success"],
      warning: styles$7["variant-warning"]
    },
    size: {
      small: styles$7["size-small"],
      medium: styles$7["size-medium"]
    },
    autoIcon: {
      true: styles$7["auto-icon"]
    }
  },
  defaultVariants: { variant: "neutral", size: "medium" }
});
const autoIconMap = {
  neutral: /* @__PURE__ */ React__default.createElement(CustomIcon.Info, null),
  info: /* @__PURE__ */ React__default.createElement(CustomIcon.Info, null),
  alert: /* @__PURE__ */ React__default.createElement(SvgAlertTriangle, null),
  danger: /* @__PURE__ */ React__default.createElement(SvgAlertTriangle, null),
  success: /* @__PURE__ */ React__default.createElement(SvgCheckCircle, null),
  warning: /* @__PURE__ */ React__default.createElement(SvgAlertTriangle, null)
};
const Message$1 = React__default.forwardRef((props, ref) => {
  const {
    asChild,
    onDismiss,
    className,
    title,
    icon: icon2,
    autoIcon,
    variant = "neutral",
    size,
    ...rest
  } = props;
  const Component2 = asChild ? Slot : "div";
  const finalIcon = React__default.isValidElement(icon2) ? icon2 : autoIcon && variant && autoIconMap[variant] ? autoIconMap[variant] : null;
  return /* @__PURE__ */ React__default.createElement(Component2, { ref, ...rest, className: cvaMessage({ variant, size, autoIcon, className }) }, !!onDismiss && /* @__PURE__ */ React__default.createElement("button", { className: styles$7.dismissButton, onClick: onDismiss, "aria-label": "Dismiss" }, /* @__PURE__ */ React__default.createElement(SvgXClose, null)), finalIcon && React__default.cloneElement(finalIcon, { className: styles$7.icon }), !!title && /* @__PURE__ */ React__default.createElement(Text$1.Label, null, title), /* @__PURE__ */ React__default.createElement(Slottable, null, props.children));
});
const container$1 = "_container_10ejt_5";
const button = "_button_10ejt_8";
const hasSelected = "_hasSelected_10ejt_21";
const searchInput = "_searchInput_10ejt_24";
const optionList = "_optionList_10ejt_37";
const option = "_option_10ejt_37";
const inner = "_inner_10ejt_77";
const checkmark = "_checkmark_10ejt_80";
const styles$6 = {
  container: container$1,
  button,
  hasSelected,
  searchInput,
  optionList,
  option,
  inner,
  checkmark
};
const Container = (props) => {
  const { children, className, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(Combobox$2, { as: "div", className: classNames(styles$6.container, className), ...rest }, children);
};
const Button = (props) => {
  const { className, children, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(ComboboxButton, { as: Fragment, ...rest }, ({ value }) => /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames(styles$6.button, className, {
        [styles$6.hasSelected]: value !== null && (!Array.isArray(value) || value.length > 0)
      })
    },
    children,
    "🔽"
  ));
};
const Input = React__default.memo((props) => {
  const { children, className, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(ComboboxInput, { as: "input", className: classNames(styles$6.searchInput, className), ...rest }, children);
});
const Options = (props) => {
  const { children, className, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(ComboboxOptions, { as: "ul", className: classNames(styles$6.optionList, className), ...rest }, children);
};
const Option = (props) => {
  const { className, innerClassName, showCheckmark = true, children, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(ComboboxOption, { as: "li", className: classNames(styles$6.option, className), ...rest }, ({ selected: selected2 }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, showCheckmark && /* @__PURE__ */ React__default.createElement("div", { className: styles$6.checkmark }, selected2 && "✅"), /* @__PURE__ */ React__default.createElement("div", { className: classNames(styles$6.inner, innerClassName) }, children)));
};
const Combobox = Object.assign(Container, { Button, Input, Options, Option });
const DialogRoot = (props) => /* @__PURE__ */ React__default.createElement(DialogPrimitive.Root, { modal: true, ...props });
const DialogTrigger = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement(DialogPrimitive.Trigger, { ...props, ref: forwardedRef }));
const DialogPortal = DialogPrimitive.Portal;
const DialogOverlay = React__default.forwardRef((props, forwardedRef) => {
  const { variant = "invisible", ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(
    DialogPrimitive.Overlay,
    {
      ...rest,
      ref: forwardedRef,
      className: classNames(
        commonStyles.overlay,
        { [commonStyles.visible]: variant === "backdrop" },
        props.className
      )
    }
  );
});
DialogOverlay.displayName = "DialogOverlay";
const cvaContent$1 = cva(commonStyles.dialogContentBase, {
  variants: {
    /** Various modal layouts */
    variant: {
      /** Dialog is default on `Dialog` */
      dialog: commonStyles["contentVariantDialog"],
      /** Default modal */
      modal: [commonStyles.modalContentBase, commonStyles.contentVariantModal],
      /** Minimal, unstyled modal */
      minimal: [commonStyles.modalContentBase, commonStyles.contentVariantMinimal],
      /** Overlay 100%/100% of screen */
      fullscreen: [commonStyles.modalContentBase, commonStyles.contentVariantModalFullscreen],
      /** ~99% overlay the content area of Timely, leaving nav visible */
      overlayView: [commonStyles.modalContentBase, commonStyles.contentVariantModalOverlayView],
      /** For "settings in modal" */
      settings: [commonStyles.modalContentBase, commonStyles.contentVariantModalSettings],
      /** For wizard modals */
      wizard: [commonStyles.modalContentBase, commonStyles.contentVariantModalWizard]
    }
  },
  defaultVariants: {
    variant: "dialog"
  }
});
const DialogContent = React__default.forwardRef(
  ({ children, variant, closable = true, ...props }, forwardedRef) => /* @__PURE__ */ React__default.createElement(
    DialogPrimitive.Content,
    {
      asChild: true,
      ...props,
      ref: forwardedRef,
      className: cvaContent$1({
        variant,
        className: props.className
      })
    },
    /* @__PURE__ */ React__default.createElement(Box$1.Column, { gap: "medium" }, children, !!closable && /* @__PURE__ */ React__default.createElement(Dialog.Close, { asChild: true }, /* @__PURE__ */ React__default.createElement(
      "button",
      {
        className: classNames(commonStyles.closeButton, props.className),
        "aria-label": "Close"
      },
      /* @__PURE__ */ React__default.createElement(SvgXClose, { width: 16, height: 16 })
    )))
  )
);
const DialogClose = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement(
  DialogPrimitive.Close,
  {
    ...props,
    ref: forwardedRef,
    className: classNames(commonStyles.closeButton, props.className)
  }
));
DialogClose.displayName = "DialogClose";
const DialogTitle = React__default.forwardRef(({ children, ...rest }, forwardedRef) => /* @__PURE__ */ React__default.createElement(
  DialogPrimitive.Title,
  {
    ...rest,
    ref: forwardedRef,
    asChild: true,
    className: classNames(commonStyles.dialogTitle, rest.className)
  },
  /* @__PURE__ */ React__default.createElement(Text$1.Headline, { size: "small" }, children)
));
DialogTitle.displayName = "DialogTitle";
const DialogDescription = React__default.forwardRef(({ children, ...rest }, forwardedRef) => /* @__PURE__ */ React__default.createElement(
  DialogPrimitive.Description,
  {
    ...rest,
    ref: forwardedRef,
    asChild: true,
    className: classNames(commonStyles.dialogDescription, rest.className)
  },
  /* @__PURE__ */ React__default.createElement(Text$1, null, children)
));
DialogDescription.displayName = "DialogDescription";
const DialogFooter = (props) => /* @__PURE__ */ React__default.createElement(Box$1.Row, { ...props, className: classNames(commonStyles.dialogFooter, props.className) });
DialogFooter.displayName = "DialogFooter";
const DialogComposition = ({
  trigger,
  title,
  buttons: buttons2,
  description,
  children,
  onEscapeKeyDown,
  onOpenChange,
  variant = "dialog",
  backdrop = false,
  closable = true,
  style,
  ...rest
}) => {
  const handleEscapeKeyDown = React__default.useCallback(
    (event) => {
      onOpenChange == null ? void 0 : onOpenChange(false);
      onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(event);
    },
    [onEscapeKeyDown, onOpenChange]
  );
  const wrapAndStyleChildren = !!variant && ["settings", "minimal", "wizard"].includes(variant);
  return /* @__PURE__ */ React__default.createElement(DialogRoot, { modal: true, ...rest, onOpenChange }, /* @__PURE__ */ React__default.createElement(DialogTrigger, { asChild: true }, trigger), /* @__PURE__ */ React__default.createElement(DialogPortal, null, /* @__PURE__ */ React__default.createElement(DialogOverlay, { variant: backdrop ? "backdrop" : "transparent" }, /* @__PURE__ */ React__default.createElement(
    DialogContent,
    {
      onEscapeKeyDown: handleEscapeKeyDown,
      closable,
      style,
      variant
    },
    !!title && /* @__PURE__ */ React__default.createElement(DialogTitle, null, title),
    !!description && /* @__PURE__ */ React__default.createElement(DialogDescription, null, description),
    wrapAndStyleChildren ? children : /* @__PURE__ */ React__default.createElement(DialogDescription, null, children),
    !!buttons2 && /* @__PURE__ */ React__default.createElement(DialogFooter, null, buttons2.map((button2, index) => {
      if (button2 === "spacer") {
        return /* @__PURE__ */ React__default.createElement(Box$1.Spacer, { key: index });
      }
      return button2;
    }))
  ))));
};
DialogComposition.displayName = "DialogComposition";
const Dialog = Object.assign(DialogComposition, {
  Root: DialogRoot,
  Trigger: DialogTrigger,
  Portal: DialogPortal,
  Overlay: DialogOverlay,
  Content: DialogContent,
  Close: DialogClose,
  Title: DialogTitle,
  Description: DialogDescription,
  // Custom
  Footer: DialogFooter
});
Dialog.displayName = "Dialog";
Dialog.Trigger.displayName = "Dialog.Trigger";
Dialog.Portal.displayName = "Dialog.Portal";
Dialog.Overlay.displayName = "Dialog.Overlay";
Dialog.Content.displayName = "Dialog.Content";
Dialog.Close.displayName = "Dialog.Close";
Dialog.Title.displayName = "Dialog.Title";
Dialog.Description.displayName = "Dialog.Description";
Dialog.Footer.displayName = "Dialog.Footer";
const Modal = ({ variant = "modal", trigger, ...props }) => {
  return /* @__PURE__ */ React__default.createElement(
    Dialog,
    {
      modal: true,
      ...props,
      trigger: trigger || /* @__PURE__ */ React__default.createElement("div", { style: { display: "none" } }),
      variant
    }
  );
};
Modal.displayName = "Modal";
const inlineContainer = "_inlineContainer_lwfqi_5";
const floatingActions = "_floatingActions_lwfqi_33";
const styles$5 = {
  inlineContainer,
  floatingActions
};
const JsonViewComponent = React__default.lazy(() => import("@uiw/react-json-view"));
const JsonContent = ({ data }) => {
  const jsonValue = typeof data === "object" && data !== null ? data : { value: data };
  return /* @__PURE__ */ React__default.createElement(Suspense, { fallback: /* @__PURE__ */ React__default.createElement("code", null, JSON.stringify(data, null, 2)) }, /* @__PURE__ */ React__default.createElement(JsonViewComponent, { value: jsonValue }));
};
const JsonView = React__default.memo(
  ({ data, maxHeight = "300px", collapsed = true, title = "Debug JSON View" }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const containClicks = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
    const renderModal = showModal ? /* @__PURE__ */ React__default.createElement(Modal, { open: showModal, onOpenChange: setShowModal, title, variant: "overlayView" }, /* @__PURE__ */ React__default.createElement("div", { onClick: containClicks }, /* @__PURE__ */ React__default.createElement(JsonContent, { data }))) : null;
    const renderExpandBtn = /* @__PURE__ */ React__default.createElement(
      Button$1,
      {
        size: "xsmall",
        tooltip: isExpanded ? "Collapse" : "Expand",
        onClick: (e) => {
          containClicks(e);
          setIsExpanded(!isExpanded);
        },
        selected: isExpanded
      },
      /* @__PURE__ */ React__default.createElement(SvgExpand01, null)
    );
    const renderFullscreenBtn = /* @__PURE__ */ React__default.createElement(
      Button$1,
      {
        size: "xsmall",
        onClick: (e) => {
          containClicks(e);
          setShowModal(true);
        },
        tooltip: "Open JsonView Modal"
      },
      /* @__PURE__ */ React__default.createElement(SvgExpand06, null)
    );
    if (collapsed) {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("span", null, renderFullscreenBtn), renderModal);
    }
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: styles$5.inlineContainer,
        style: { maxHeight: isExpanded ? "100%" : maxHeight }
      },
      /* @__PURE__ */ React__default.createElement("div", { className: styles$5.floatingActions }, renderExpandBtn, renderFullscreenBtn),
      /* @__PURE__ */ React__default.createElement(JsonContent, { data })
    ), renderModal);
  }
);
JsonView.displayName = "JsonView";
const confirmModalContainer = "_confirmModalContainer_1rtf6_5";
const content = "_content_1rtf6_16";
const buttons = "_buttons_1rtf6_22";
const styles$4 = {
  confirmModalContainer,
  content,
  buttons
};
const PopoverConfirm = (props) => {
  const {
    cancelButtonPriority,
    cancelLabel,
    prompt,
    confirmButtonPriority,
    confirmButtonDestructive,
    confirmLabel,
    onCancel,
    onConfirm,
    target,
    targetCaret,
    ...rest
  } = props;
  return /* @__PURE__ */ React__default.createElement(
    Popover,
    {
      closeOnClick: true,
      stopPropagation: true,
      ...rest,
      targetCaret,
      target,
      className: styles$4.confirmModalContainer
    },
    /* @__PURE__ */ React__default.createElement("div", { className: styles$4.content }, /* @__PURE__ */ React__default.createElement("p", null, prompt), /* @__PURE__ */ React__default.createElement(ButtonRow, { className: styles$4.buttons }, /* @__PURE__ */ React__default.createElement(
      Button$1,
      {
        "data-testid": "accept_popover_confirm",
        size: "small",
        priority: confirmButtonPriority,
        onClick: onConfirm,
        destructive: confirmButtonDestructive
      },
      confirmLabel
    ), /* @__PURE__ */ React__default.createElement(
      Button$1,
      {
        "data-testid": "cancel_popover_confirm",
        size: "small",
        priority: cancelButtonPriority,
        onClick: onCancel
      },
      cancelLabel
    )))
  );
};
PopoverConfirm.defaultProps = {
  cancelButtonPriority: "medium",
  cancelLabel: "Cancel",
  prompt: "Are you sure you want to do this?",
  confirmButtonPriority: "high",
  confirmLabel: "Confirm",
  targetCaret: true,
  onCancel: () => {
  }
};
const circle$1 = "_circle_9w1om_5";
const indicator = "_indicator_9w1om_50";
const styles$3 = {
  circle: circle$1,
  "layout-list": "_layout-list_9w1om_16",
  "layout-step": "_layout-step_9w1om_22",
  "layout-wizard": "_layout-wizard_9w1om_28",
  "variant-outline": "_variant-outline_9w1om_33",
  "variant-solid": "_variant-solid_9w1om_39",
  indicator,
  "indicator-list": "_indicator-list_9w1om_62",
  "indicator-step": "_indicator-step_9w1om_67",
  "indicator-wizard": "_indicator-wizard_9w1om_72",
  "status-ok": "_status-ok_9w1om_77",
  "status-error": "_status-error_9w1om_81",
  "status-loading": "_status-loading_9w1om_85"
};
const circleStyles = cva(styles$3.circle, {
  variants: {
    layout: {
      list: styles$3["layout-list"],
      step: styles$3["layout-step"],
      wizard: styles$3["layout-wizard"]
    },
    variant: {
      solid: styles$3["variant-solid"],
      outline: styles$3["variant-outline"]
    }
  },
  defaultVariants: {
    layout: "list",
    variant: "solid"
  }
});
const indicatorStyles = cva(styles$3.indicator, {
  variants: {
    layout: {
      list: styles$3["indicator-list"],
      step: styles$3["indicator-step"],
      wizard: styles$3["indicator-wizard"]
    },
    status: {
      ok: styles$3["status-ok"],
      error: styles$3["status-error"],
      loading: styles$3["status-loading"]
    }
  },
  defaultVariants: {
    layout: "list"
  }
});
const ICON_SIZE = {
  list: 10,
  step: 18,
  wizard: 14
};
const CircleIndicator = ({
  layout = "list",
  status
}) => {
  const iconSize = ICON_SIZE[layout];
  let icon2 = null;
  if (status === "ok") {
    icon2 = /* @__PURE__ */ React__default.createElement(SvgCheckCircle, { width: iconSize, height: iconSize });
  } else if (status === "error") {
    icon2 = /* @__PURE__ */ React__default.createElement(SvgXCircle, { width: iconSize, height: iconSize });
  } else if (status === "loading") {
    icon2 = /* @__PURE__ */ React__default.createElement(Spinner, { size: iconSize - 1 });
  }
  if (!icon2) return null;
  return /* @__PURE__ */ React__default.createElement("div", { className: indicatorStyles({ layout, status }) }, icon2);
};
const Circle = React__default.forwardRef((props, ref) => {
  const {
    children,
    layout = "list",
    variant = "solid",
    status,
    className,
    "data-testid": dataTestId = "circle",
    ...rest
  } = props;
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      ref,
      className: circleStyles({ layout, className, variant }),
      "data-testid": dataTestId,
      ...rest
    },
    children,
    status && /* @__PURE__ */ React__default.createElement(CircleIndicator, { layout, status })
  );
});
Circle.displayName = "Circle";
const container = "_container_1uc1h_5";
const circle = "_circle_1uc1h_12";
const body = "_body_1uc1h_16";
const styles$2 = {
  container,
  circle,
  body
};
const ChecklistItem = React__default.forwardRef(
  ({
    circleProps,
    indicator: indicator2,
    indent: indent2 = 0,
    asChild = false,
    children,
    "data-testid": dataTestId = "checklist",
    ...rest
  }, ref) => {
    const indentSpacing = indent2 * (4 * 6);
    const ContentWrapper = asChild ? Slot : Box$1.Column;
    return /* @__PURE__ */ React__default.createElement(
      Box$1.Row,
      {
        className: styles$2.container,
        ref,
        alignItems: "flex-start",
        gap: "medium",
        marginLeft: indentSpacing > 0 ? indentSpacing : void 0,
        "data-testid": dataTestId,
        ...rest,
        flexDirection: "row"
      },
      /* @__PURE__ */ React__default.createElement(Circle, { className: styles$2.circle, layout: "list", ...circleProps }, (circleProps == null ? void 0 : circleProps.children) || indicator2),
      /* @__PURE__ */ React__default.createElement(ContentWrapper, { className: styles$2.body, ...rest }, children)
    );
  }
);
const cvaChecklist = cva(void 0, {
  variants: {
    variant: {
      default: void 0
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
const ChecklistRoot = React__default.forwardRef(
  ({ children, items = [], variant, ...rest }, ref) => {
    const renderedChecklistItems = items.map((item2, index) => {
      const circleProps = {
        ...item2.circleProps,
        layout: "list",
        variant: "outline",
        children: item2.indicator || index + 1
      };
      return /* @__PURE__ */ React__default.createElement(ChecklistItem, { key: index, circleProps, ...item2 });
    });
    return /* @__PURE__ */ React__default.createElement(
      Box$1.Column,
      {
        ref,
        gap: "medium",
        "data-testid": "checklist-root",
        ...rest,
        className: cvaChecklist({ variant, className: rest.className })
      },
      !!renderedChecklistItems && renderedChecklistItems,
      children
    );
  }
);
const Checklist = Object.assign(ChecklistRoot, {
  Item: ChecklistItem
});
Checklist.displayName = "Checklist";
Checklist.Item.displayName = "Checklist.Item";
function getStepState(step, index, stepStates, currentIndex) {
  var _a;
  const stepStatus = ((_a = stepStates[step.id]) == null ? void 0 : _a.status) || "pending";
  const circleStatus = stepStatus === "error" ? "error" : stepStatus === "loading" ? "loading" : void 0;
  const disabled2 = index > currentIndex;
  return {
    stepStatus,
    circleStatus,
    disabled: disabled2,
    circleVariant: stepStatus === "pending" ? "outline" : "solid",
    circleContent: stepStatus === "completed" ? /* @__PURE__ */ React__default.createElement(SvgCheck, { width: 16 }) : index + 1,
    textColor: ["completed", "current"].includes(stepStatus) ? "normal" : "minContrast"
  };
}
const Nav = {
  Back: ({
    isFirstStep,
    isLastStep,
    isLoading: isLoading2,
    hasError,
    onClick,
    children = "Back",
    setLoading,
    next,
    prev,
    complete,
    skip,
    goTo,
    ...props
  }) => /* @__PURE__ */ React__default.createElement(
    Button$1,
    {
      disabled: isFirstStep || isLoading2 || hasError,
      onClick,
      priority: "xlow",
      ...props
    },
    /* @__PURE__ */ React__default.createElement(SvgArrowLeft, null),
    children
  ),
  Skip: ({
    isFirstStep,
    isLastStep,
    isLoading: isLoading2,
    hasError,
    onClick,
    children = "Skip",
    setLoading,
    next,
    prev,
    complete,
    skip,
    goTo,
    ...props
  }) => /* @__PURE__ */ React__default.createElement(
    Button$1,
    {
      disabled: isLastStep || isLoading2 || hasError,
      onClick,
      priority: "xlow",
      ...props
    },
    children
  ),
  Next: ({
    isLastStep,
    isFirstStep,
    isLoading: isLoading2,
    hasError,
    onClick,
    children,
    setLoading,
    next,
    prev,
    complete,
    skip,
    goTo,
    ...props
  }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, isLoading2 && /* @__PURE__ */ React__default.createElement(Spinner, null), /* @__PURE__ */ React__default.createElement(Button$1, { onClick, disabled: hasError || isLoading2, priority: "xhigh", ...props }, children || (isLastStep ? "Complete" : "Next step"), !isLoading2 && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, isLastStep ? /* @__PURE__ */ React__default.createElement(SvgCheck, null) : /* @__PURE__ */ React__default.createElement(SvgArrowRight, null))))
};
const Root = ({ children, ...props }) => /* @__PURE__ */ React__default.createElement(Box$1.Column, { width: "100%", ...props }, children);
const Wizard = Object.assign(Root, {
  Root,
  /**
   * Progress bar with step indicators
   *
   * Renders step indicators in a horizontal layout by wrapping them in a {@link Box.Row} component.
   * Each step shows its current status (pending, completed, error, loading) with visual indicators.
   *
   * @extends BoxProps
   */
  Progress: ({ wizard, ...rest }) => {
    const { steps, currentId, stepStates } = wizard;
    if (steps.length === 0) {
      return null;
    }
    const currentIndex = steps.findIndex((s) => s.id === currentId);
    return /* @__PURE__ */ React__default.createElement(Box$1.Row, { gap: "large", justifyContent: "space-between", width: "100%", ...rest }, steps.map((step, index) => {
      const state = getStepState(step, index, stepStates, currentIndex);
      const lastStep = index === steps.length - 1;
      const hasStepTitle = !!step.title;
      const separatorStyle = hasStepTitle ? { marginTop: -26 } : { width: 0 };
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, { key: step.id }, /* @__PURE__ */ React__default.createElement(Box$1.Column, { alignContent: "center", alignItems: "center", gap: "large" }, /* @__PURE__ */ React__default.createElement(
        Circle,
        {
          layout: "step",
          key: step.id,
          status: state.circleStatus,
          variant: state.circleVariant
        },
        state.circleContent
      ), !!step.title && /* @__PURE__ */ React__default.createElement(Text$1, { size: "xsmall", color: state.textColor }, step.title)), !lastStep && /* @__PURE__ */ React__default.createElement(Box$1.Separator, { style: separatorStyle }));
    }));
  },
  /**
   * Vertical progress list with step indicators
   *
   * Renders step indicators in a vertical list layout optimized for sidebars.
   * Each step shows its current status (pending, completed, error, loading) with visual indicators.
   * Uses the same step logic as Progress but with vertical list layout.
   *
   * @extends BoxProps
   */
  ProgressList: ({
    wizard,
    ...rest
  }) => {
    const { steps, currentId, stepStates } = wizard;
    if (steps.length === 0) {
      return null;
    }
    const currentIndex = steps.findIndex((s) => s.id === currentId);
    return /* @__PURE__ */ React__default.createElement(Box$1.Column, { ...rest }, steps.map((step, index) => {
      const state = getStepState(step, index, stepStates, currentIndex);
      const lastStep = index === steps.length - 1;
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, { key: step.id }, /* @__PURE__ */ React__default.createElement(Box$1.Row, { gap: "large", alignItems: "center" }, /* @__PURE__ */ React__default.createElement(
        Circle,
        {
          layout: "wizard",
          status: state.circleStatus,
          variant: state.circleVariant
        },
        state.circleContent
      ), step.title && /* @__PURE__ */ React__default.createElement(Text$1, { color: state.textColor }, step.title)), !lastStep && /* @__PURE__ */ React__default.createElement(
        Box$1.Separator,
        {
          orientation: "vertical",
          style: { alignSelf: "flex-start", marginLeft: 4 * 4, minHeight: 4 * 4 }
        }
      ));
    }));
  },
  // Container for step content
  Content: ({ children, ...rest }) => /* @__PURE__ */ React__default.createElement(Box$1.Column, { gap: "medium", ...rest }, children),
  // Navigation controls
  Nav: {
    Root: ({ children, ...rest }) => /* @__PURE__ */ React__default.createElement(Box$1.Row, { justifyContent: "space-between", width: "100%", gap: "large", ...rest }, children),
    Back: Nav.Back,
    Skip: Nav.Skip,
    Next: Nav.Next
  }
});
const DropdownMenuRoot = (props) => /* @__PURE__ */ React__default.createElement(DropdownMenuPrimitive.Root, { modal: true, ...props });
const DropdownMenuTrigger = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement(DropdownMenuPrimitive.Trigger, { ...props, ref: forwardedRef }));
DropdownMenuTrigger.displayName = "DropdownMenuTrigger";
const DropdownMenuContent = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement(
  DropdownMenuPrimitive.Content,
  {
    sideOffset: 5,
    collisionPadding: 4 * 4,
    ...props,
    ref: forwardedRef,
    className: classNames(commonStyles.dropdownContentBase, props.className)
  }
));
DropdownMenuContent.displayName = "DropdownMenuContent";
const DropdownMenuLabel = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement(
  DropdownMenuPrimitive.Label,
  {
    ...props,
    ref: forwardedRef,
    className: classNames(commonStyles.dropdownMenuLabel, props.className)
  }
));
DropdownMenuLabel.displayName = "DropdownMenuLabel";
const DropdownMenuItem = React__default.forwardRef(
  ({ children, orientation = "horizontal", variant, ...props }, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      DropdownMenuPrimitive.Item,
      {
        ...props,
        ref: forwardedRef,
        className: classNames(
          commonStyles.dropdownMenuItemBase,
          commonStyles[`orientation-${orientation}`],
          variant && styles$q[`variant-${variant}`]
        )
      },
      children
    );
  }
);
DropdownMenuItem.displayName = "DropdownMenuItem";
const DropdownMenuCustomItem = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement(
  "div",
  {
    ...props,
    ref: forwardedRef,
    className: classNames(commonStyles.dropdownMenuItemBase, commonStyles.dropdownMenuItemCustom)
  }
));
DropdownMenuCustomItem.displayName = "DropdownMenuCustomItem";
const DropdownMenuGroup = DropdownMenuPrimitive.Group;
const DropdownMenuCheckboxItem = React__default.forwardRef(
  ({ variant, ...props }, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      DropdownMenuPrimitive.CheckboxItem,
      {
        ...props,
        ref: forwardedRef,
        className: classNames(
          commonStyles.dropdownMenuItemBase,
          variant && styles$q[`variant-${variant}`]
        )
      }
    );
  }
);
DropdownMenuCheckboxItem.displayName = "DropdownMenuCheckboxItem";
const DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup;
const DropdownMenuRadioItem = React__default.forwardRef(
  ({ variant, ...props }, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      DropdownMenuPrimitive.RadioItem,
      {
        ...props,
        ref: forwardedRef,
        className: classNames(
          commonStyles.dropdownMenuItemBase,
          variant && styles$q[`variant-${variant}`]
        )
      }
    );
  }
);
DropdownMenuRadioItem.displayName = "DropdownMenuRadioItem";
const DropdownMenuSeparator = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement(
  DropdownMenuPrimitive.Separator,
  {
    "data-separator": "true",
    ...props,
    ref: forwardedRef,
    className: commonStyles.dropdownMenuSeparator
  }
));
DropdownMenuSeparator.displayName = "DropdownMenuSeparator";
const DropdownMenuArrow = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement(DropdownMenuPrimitive.Arrow, { ...props, ref: forwardedRef, className: styles$q.dropdownMenuArrow }));
DropdownMenuArrow.displayName = "DropdownMenuArrow";
const DropdownMenuPortal = DropdownMenuPrimitive.Portal;
const DropdownMenuSub = DropdownMenuPrimitive.Sub;
const DropdownMenuSubTrigger = React__default.forwardRef(
  ({ variant, ...props }, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(
      DropdownMenuPrimitive.SubTrigger,
      {
        ...props,
        ref: forwardedRef,
        className: classNames(
          commonStyles.dropdownMenuItemBase,
          variant && styles$q[`variant-${variant}`]
        )
      }
    );
  }
);
DropdownMenuSubTrigger.displayName = "DropdownMenuSubTrigger";
const DropdownMenuSubContent = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement(
  DropdownMenuPrimitive.SubContent,
  {
    sideOffset: 2,
    alignOffset: -5,
    ...props,
    ref: forwardedRef,
    className: commonStyles.dropdownContentBase
  }
));
DropdownMenuSubContent.displayName = "DropdownMenuSubContent";
const DropdownMenuItemIndicator = React__default.forwardRef((props, forwardedRef) => /* @__PURE__ */ React__default.createElement(
  DropdownMenuPrimitive.ItemIndicator,
  {
    ...props,
    ref: forwardedRef,
    className: commonStyles.dropdownMenuItemIndicator
  }
));
DropdownMenuItemIndicator.displayName = "DropdownMenuItemIndicator";
const RightSlot = ({ children, ...props }) => /* @__PURE__ */ React__default.createElement("div", { ...props, className: styles$q.rightSlot }, children || /* @__PURE__ */ React__default.createElement(SvgChevronRight$1, null));
const ShortcutCombo = ({ combo }) => {
  if (!combo) return null;
  return /* @__PURE__ */ React__default.createElement(RightSlot, null, combo[0] === "meta" && "⌘", combo[0] === "alt" && "⌥", combo[0] === "ctrl" && "⌃", "+", combo[1], combo[2] && `+${combo[2]}`);
};
const Message = ({ item: item2, ...rest }) => {
  const variant = item2.variant || "info";
  let finalIcon = null;
  if (item2.icon === "auto") {
    finalIcon = autoIconMap[variant];
  } else if (item2.icon !== false && React__default.isValidElement(item2.icon)) {
    finalIcon = item2.icon;
  }
  return /* @__PURE__ */ React__default.createElement(
    Box$1.Row,
    {
      gap: "medium",
      ...rest,
      "data-readonly": true,
      className: classNames(styles$q.messageBody, styles$q[`variant-${variant}`])
    },
    !!finalIcon && /* @__PURE__ */ React__default.createElement(Box$1, { className: styles$q.messageIcon, alignSelf: "flex-start" }, finalIcon),
    /* @__PURE__ */ React__default.createElement(Box$1.Column, null, item2.label && /* @__PURE__ */ React__default.createElement(Text$1.Label, { size: "small" }, item2.label), item2.description && /* @__PURE__ */ React__default.createElement(Text$1, { size: "small", color: "subtle" }, item2.description), item2.content)
  );
};
const Icon = ({ children, icon: icon2, ...props }) => {
  if (!children && !icon2) return null;
  return /* @__PURE__ */ React__default.createElement("div", { ...props, className: commonStyles.dropdownMenuItemIndicator }, children || icon2);
};
const DropdownMenu = Object.assign(
  {},
  {
    Root: DropdownMenuRoot,
    Trigger: DropdownMenuTrigger,
    Content: DropdownMenuContent,
    Label: DropdownMenuLabel,
    Item: DropdownMenuItem,
    Group: DropdownMenuGroup,
    CheckboxItem: DropdownMenuCheckboxItem,
    RadioGroup: DropdownMenuRadioGroup,
    RadioItem: DropdownMenuRadioItem,
    Separator: DropdownMenuSeparator,
    Arrow: DropdownMenuArrow,
    Portal: DropdownMenuPortal,
    Sub: DropdownMenuSub,
    SubTrigger: DropdownMenuSubTrigger,
    SubContent: DropdownMenuSubContent,
    ItemIndicator: DropdownMenuItemIndicator,
    // Custom
    RightSlot,
    ShortcutCombo,
    Icon,
    Message,
    CustomItem: DropdownMenuCustomItem
  }
);
DropdownMenu.Trigger.displayName = "DropdownMenu.Trigger";
DropdownMenu.Content.displayName = "DropdownMenu.Content";
DropdownMenu.Label.displayName = "DropdownMenu.Label";
DropdownMenu.Item.displayName = "DropdownMenu.Item";
DropdownMenu.Group.displayName = "DropdownMenu.Group";
DropdownMenu.CheckboxItem.displayName = "DropdownMenu.CheckboxItem";
DropdownMenu.RadioGroup.displayName = "DropdownMenu.RadioGroup";
DropdownMenu.RadioItem.displayName = "DropdownMenu.RadioItem";
DropdownMenu.Separator.displayName = "DropdownMenu.Separator";
DropdownMenu.Arrow.displayName = "DropdownMenu.Arrow";
DropdownMenu.Portal.displayName = "DropdownMenu.Portal";
DropdownMenu.Sub.displayName = "DropdownMenu.Sub";
DropdownMenu.SubTrigger.displayName = "DropdownMenu.SubTrigger";
DropdownMenu.SubContent.displayName = "DropdownMenu.SubContent";
DropdownMenu.ItemIndicator.displayName = "DropdownMenu.ItemIndicator";
DropdownMenu.CustomItem.displayName = "DropdownMenu.CustomItem";
const cvaContent = cva(void 0, {
  variants: {
    variant: {
      /** Same as `DropdownMenu` */
      dropdown: commonStyles.dropdownContentBase,
      /** More spacing, floats higher than default dropdown */
      popover: commonStyles.popoverContentBase
    }
  },
  defaultVariants: {
    variant: "dropdown"
  }
});
const Dropdown = (props) => {
  const { trigger, children, variant, align, ...rest } = props;
  const handleEscapeKeyDown = (event) => {
    var _a, _b;
    (_a = props.onOpenChange) == null ? void 0 : _a.call(props, false);
    (_b = props == null ? void 0 : props.onEscapeKeyDown) == null ? void 0 : _b.call(props, event);
  };
  return /* @__PURE__ */ React__default.createElement(PopoverPrimitive.Root, { modal: true, ...rest }, /* @__PURE__ */ React__default.createElement(PopoverPrimitive.Trigger, { asChild: true }, trigger), /* @__PURE__ */ React__default.createElement(PopoverPrimitive.Portal, null, /* @__PURE__ */ React__default.createElement(
    PopoverPrimitive.Content,
    {
      arrowPadding: 4 * 4,
      collisionPadding: 4 * 4,
      onEscapeKeyDown: handleEscapeKeyDown,
      className: cvaContent({ variant, className: props.className }),
      align
    },
    children,
    /* @__PURE__ */ React__default.createElement(PopoverPrimitive.Arrow, { className: commonStyles.pointerArrow })
  )));
};
Dropdown.displayName = "Dropdown";
const useCallbackProxy = (callback) => {
  const callbackRef = useValueRef(callback);
  return useCallback((...args) => callbackRef.current(...args), [callbackRef]);
};
const useChangedRecently = (value, recentlyAsInThisManyMillisecondsAgo) => {
  const isInitial = useRef(true);
  const [changing, setIsChanging] = useState(false);
  useLayoutEffect(() => {
    if (isInitial.current) {
      isInitial.current = false;
      return;
    }
    setIsChanging(true);
    const timeout = setTimeout(() => {
      setIsChanging(false);
    }, recentlyAsInThisManyMillisecondsAgo);
    return () => clearTimeout(timeout);
  }, [value, setIsChanging, recentlyAsInThisManyMillisecondsAgo]);
  return changing;
};
const useDebouncedCallback = (callback, wait) => {
  const callbackProxy = useCallbackProxy(callback);
  const memoizedDebounced = useMemo(
    () => debounce((...args) => callbackProxy(...args), wait, {
      leading: false,
      trailing: true
    }),
    [callbackProxy, wait]
  );
  return memoizedDebounced;
};
const useDebouncedEffect = (effect, deps, delayOrConfig) => {
  const searchTimeoutId = useRef(void 0);
  const didMount = useRef(false);
  const isNumber = typeof delayOrConfig === "number";
  const delay = isNumber ? delayOrConfig : delayOrConfig.delay;
  const runOnMount = isNumber ? true : !!delayOrConfig.runOnMount;
  useEffect(
    () => {
      if (!runOnMount && !didMount.current) {
        didMount.current = true;
      } else {
        clearTimeout(searchTimeoutId.current);
        searchTimeoutId.current = window.setTimeout(effect, delay);
      }
      return () => {
        clearTimeout(searchTimeoutId.current);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...deps, delay, runOnMount]
  );
};
const useThrottledEffect = (effect, deps, delayMs) => {
  const freeToFireRef = useRef(true);
  const waitingEffect = useRef();
  const wrapper2 = (cb) => {
    if (!freeToFireRef.current) {
      waitingEffect.current = effect;
      return;
    }
    freeToFireRef.current = false;
    window.setTimeout(() => {
      freeToFireRef.current = true;
      if (waitingEffect.current != null) {
        const next = waitingEffect.current;
        waitingEffect.current = null;
        wrapper2(next);
      }
    }, delayMs);
    cb();
  };
  useEffect(
    () => {
      wrapper2(effect);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...deps ?? [], delayMs]
  );
};
const useMountEffect = (callback) => {
  useEffect(() => {
    const result = callback();
    if (typeof result === "function") {
      return result;
    }
  }, []);
};
const useUnmountEffect = (callback) => {
  useEffect(() => callback, []);
};
const useDeferredMount = () => {
  const [deferring, setDeferring] = useState(true);
  useMountEffect(() => {
    const id = requestIdleCallback(() => setDeferring(false));
    return () => cancelIdleCallback(id);
  });
  return deferring;
};
const requestIdleCallback = (callback) => {
  if (global.requestIdleCallback) return global.requestIdleCallback(callback);
  return setTimeout(function() {
    callback();
  }, 1);
};
const cancelIdleCallback = (id) => {
  if (global.cancelIdleCallback) return global.cancelIdleCallback(id);
  return clearTimeout(id);
};
const usePrevious = (value, initiallyNull = false) => {
  const ref = useRef(
    initiallyNull ? null : value
  );
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
const useEffectOnValueChange = (value, callback, runOnMount = false) => {
  const prevValue = usePrevious(value);
  useEffect(() => {
    if (!isEqual(value, prevValue)) {
      callback();
    }
  });
  useMountEffect(() => {
    if (runOnMount) {
      callback();
    }
  });
};
const useDeferredChangeEffect = ({
  comparisonValue,
  effect,
  waitFor
}) => {
  const shouldFetch = useRef();
  const prevValue = usePrevious(comparisonValue, true);
  useEffect(() => {
    if (!isEqual(comparisonValue, prevValue)) {
      shouldFetch.current = true;
    }
    if (waitFor && shouldFetch.current) {
      shouldFetch.current = false;
      effect();
    }
  });
};
const useInterval = (intervalMs, callback) => {
  const [count, setCount] = useState(0);
  function stateCallback() {
    if (callback != null) {
      callback(count);
    } else {
      setCount(count + 1);
    }
  }
  const savedCallback = useRef(stateCallback);
  useEffect(() => {
    savedCallback.current = stateCallback;
  });
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    const id = setInterval(tick, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return count;
};
const useRealtime = () => {
  const [count, setCount] = useState(0);
  function callback() {
    setCount(count + 1);
  }
  const secondsRef = useRef(0);
  const savedCallback = useRef(callback);
  useEffect(() => {
    savedCallback.current = callback;
  });
  const tick = useCallback(() => {
    const isInForeground = !document.hidden;
    const hasFocus = document.hasFocus != null ? document.hasFocus() : true;
    const every10Seconds = secondsRef.current % 10 === 0;
    const fireCallback = isInForeground && (hasFocus || every10Seconds);
    if (fireCallback) {
      savedCallback.current();
    }
    secondsRef.current = secondsRef.current + 1;
  }, []);
  useInterval(1e3, tick);
  return count;
};
const useRefFacade = (...refs) => {
  const refFacade = useRef(null);
  useEffectOnValueChange(
    refs,
    () => {
      if (!refs) return;
      for (const ref of refs) {
        if (!ref) continue;
        if (typeof ref === "function") {
          ref(refFacade.current ?? null);
        } else {
          ref.current = refFacade.current ?? null;
        }
      }
    },
    true
  );
  return refFacade;
};
const useStateWithLocalStorage = (defaultValue, localStorageKey) => {
  const initialValue = useMemo(() => {
    return getLocalStorageObject(localStorageKey) ?? defaultValue;
  }, [defaultValue, localStorageKey]);
  const [value, setValueInState] = useState(initialValue);
  const setValue = (newValueOrFn) => {
    setValueInState((oldValue) => {
      const newValue = typeof newValueOrFn === "function" ? newValueOrFn(oldValue) : newValueOrFn;
      setLocalStorageObject(localStorageKey, newValue);
      return newValue;
    });
  };
  return [value, setValue];
};
const getLocalStorageObject = (key) => {
  try {
    const itemInStorage = localStorage.getItem(key);
    return itemInStorage ? JSON.parse(itemInStorage) : void 0;
  } catch {
    return void 0;
  }
};
const setLocalStorageObject = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
  }
};
const useThrottledCallback = (callback, wait) => {
  const callbackProxy = useCallbackProxy(callback);
  const memoizedThrottled = useMemo(
    () => throttle((...args) => callbackProxy(...args), wait, {
      leading: true,
      trailing: true
    }),
    [callbackProxy, wait]
  );
  return memoizedThrottled;
};
const useZoom = (options) => {
  const { onZoom, enabled = true, scrollAreaRef, comboKey = "metaKey" } = options;
  const onZoomRef = useValueRef(onZoom);
  const handleWheel = useCallback(
    (e) => {
      if (!enabled || !scrollAreaRef) return;
      if (e[comboKey]) {
        e.preventDefault();
        const delta = e.deltaY < 0 ? 1 : -1;
        onZoomRef.current(delta);
      }
    },
    [scrollAreaRef, enabled, onZoomRef, comboKey]
  );
  useEffect(() => {
    if (scrollAreaRef) {
      scrollAreaRef.addEventListener("wheel", handleWheel, { passive: false });
      return () => {
        scrollAreaRef.removeEventListener("wheel", handleWheel);
      };
    }
  }, [scrollAreaRef, handleWheel]);
};
const useHeldKey = (key, allowInput) => {
  const [isHeld, setIsHeld] = useState(false);
  useEffect(() => {
    const MODIFIER_KEYS = ["Shift", "Control", "Alt", "Meta"];
    const isModifierKey = MODIFIER_KEYS.includes(key);
    const onMouseMove = (e) => {
      if (!isModifierKey) {
        return;
      }
      if (key === "Shift" && !e.shiftKey) {
        onNoLongerHeld();
      }
      if (key === "Control" && !e.ctrlKey) {
        onNoLongerHeld();
      }
      if (key === "Alt" && !e.altKey) {
        onNoLongerHeld();
      }
      if (key === "Meta" && !e.metaKey) {
        onNoLongerHeld();
      }
    };
    const onNoLongerHeld = () => {
      setIsHeld(false);
      window.removeEventListener("mousemove", onMouseMove);
    };
    const onKeyDown = (e) => {
      const targetElementName = e.target instanceof HTMLElement && e.target.nodeName.toLowerCase() || "";
      const allowed = allowInput || !["input", "textarea"].includes(targetElementName);
      const matches = e.key === key && allowed;
      if (!matches) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      setIsHeld(true);
      window.addEventListener("mousemove", onMouseMove);
    };
    const onKeyUp = (e) => {
      if (e.key === key) {
        onNoLongerHeld();
      }
    };
    const onBlur = () => onNoLongerHeld();
    document.body.addEventListener("keyup", onKeyUp);
    document.body.addEventListener("keydown", onKeyDown);
    window.addEventListener("blur", onBlur);
    return () => {
      window.removeEventListener("blur", onBlur);
      document.body.removeEventListener("keydown", onKeyDown);
      document.body.removeEventListener("keyup", onKeyUp);
      window.removeEventListener("mousemove", onMouseMove);
    };
  }, [key, allowInput]);
  return isHeld;
};
function useControllableState(value, changeHandler, initialValue) {
  const [stateValue, setState] = useState(initialValue);
  const effectiveValue = value !== void 0 ? value : stateValue;
  return [
    effectiveValue,
    (newValue) => {
      setState(newValue);
      if (changeHandler) {
        changeHandler(newValue);
      }
    }
  ];
}
function useWizard(config) {
  const { steps = [], defaultStep, onComplete, stepProps = {} } = config;
  const [currentId, setCurrentId] = useState(() => {
    var _a;
    return defaultStep || ((_a = steps[0]) == null ? void 0 : _a.id) || "";
  });
  const [statusMap, setStatusMap] = useState(() => {
    const initial = {};
    steps.forEach((step) => {
      initial[step.id] = step.id === currentId ? "current" : step.initialStatus || "pending";
    });
    return initial;
  });
  const [error2, setError] = useState(null);
  const [isLoading2, setIsLoading] = useState(false);
  useEffect(() => {
    setStatusMap((prevStatusMap) => {
      const curIndex = steps.findIndex((s) => s.id === currentId);
      const newStatusMap = { ...prevStatusMap };
      let hasChanges = false;
      steps.forEach((step) => {
        if (prevStatusMap[step.id] === void 0) {
          newStatusMap[step.id] = step.initialStatus || "pending";
          hasChanges = true;
        }
      });
      const existingStepIds = new Set(steps.map((step) => step.id));
      Object.keys(prevStatusMap).forEach((id) => {
        if (!existingStepIds.has(id)) {
          delete newStatusMap[id];
          hasChanges = true;
        }
      });
      if (currentId && existingStepIds.has(currentId) && newStatusMap[currentId] !== "current") {
        newStatusMap[currentId] = "current";
        hasChanges = true;
      }
      steps.forEach((step, index) => {
        if (index < curIndex) {
          const currentStatus = newStatusMap[step.id] || "pending";
          if (!["completed", "visited"].includes(currentStatus)) {
            newStatusMap[step.id] = "completed";
            hasChanges = true;
          }
        }
      });
      return hasChanges ? newStatusMap : prevStatusMap;
    });
    if (currentId && !steps.some((s) => s.id === currentId) && steps.length > 0) {
      setCurrentId(steps[0].id);
    }
  }, [steps, currentId]);
  const currentIndex = useMemo(() => steps.findIndex((s) => s.id === currentId), [steps, currentId]);
  const currentStep = useMemo(() => steps.find((s) => s.id === currentId), [steps, currentId]);
  const isFirstStep = currentIndex === 0;
  const isLastStep = currentIndex === steps.length - 1;
  const hasError = statusMap[currentId] === "error";
  const stepStates = useMemo(() => {
    const states = {};
    steps.forEach((step) => {
      states[step.id] = {
        status: statusMap[step.id] || "pending"
      };
    });
    return states;
  }, [steps, statusMap]);
  const reset = useCallback(() => {
    var _a;
    const startId = defaultStep || ((_a = steps[0]) == null ? void 0 : _a.id) || "";
    const newStatusMap = {};
    steps.forEach((step) => {
      newStatusMap[step.id] = step.id === startId ? "current" : step.initialStatus || "pending";
    });
    setStatusMap(newStatusMap);
    setCurrentId(startId);
    setError(null);
    setIsLoading(false);
  }, [steps, defaultStep]);
  const setStatus = useCallback((id, status) => {
    setStatusMap((prev) => ({ ...prev, [id]: status }));
  }, []);
  const setErrorState = useCallback(
    (newError) => {
      setError(newError);
      if (newError) {
        setStatus(currentId, "error");
      }
    },
    [currentId, setStatus]
  );
  const clearError = useCallback(() => {
    setError(null);
    if (statusMap[currentId] === "error") {
      setStatus(currentId, "current");
    }
  }, [currentId, statusMap, setStatus]);
  const goTo = useCallback(
    async (targetId) => {
      if (steps.length === 0 || !steps.some((s) => s.id === targetId)) {
        return false;
      }
      if (currentStep == null ? void 0 : currentStep.onBeforeExit) {
        try {
          const canExit = await Promise.resolve(currentStep.onBeforeExit());
          if (!canExit) return false;
        } catch (error22) {
          setErrorState(
            typeof error22 === "string" ? error22 : {
              title: "Error",
              message: error22 instanceof Error ? error22.message : String(error22)
            }
          );
          return false;
        }
      }
      const targetStep = steps.find((s) => s.id === targetId);
      if (targetStep == null ? void 0 : targetStep.onBeforeEnter) {
        try {
          setIsLoading(true);
          const canEnter = await Promise.resolve(targetStep.onBeforeEnter());
          if (!canEnter) {
            setIsLoading(false);
            return false;
          }
        } catch (error22) {
          setErrorState(
            typeof error22 === "string" ? error22 : {
              title: "Error",
              message: error22 instanceof Error ? error22.message : String(error22)
            }
          );
          setIsLoading(false);
          return false;
        }
      }
      setCurrentId(targetId);
      setStatus(targetId, "current");
      setIsLoading(false);
      return true;
    },
    [currentStep, setErrorState, steps, setStatus]
  );
  const navigation = useMemo(
    () => ({
      // Navigation methods
      next: async () => {
        if (isLastStep || steps.length === 0) return false;
        clearError();
        setStatus(currentId, "loading");
        const result = await goTo(steps[currentIndex + 1].id);
        if (result) {
          setStatus(currentId, "completed");
        }
        return result;
      },
      skip: async () => {
        if (isLastStep || steps.length === 0) return false;
        clearError();
        setStatus(currentId, "visited");
        return goTo(steps[currentIndex + 1].id);
      },
      prev: async () => {
        if (isFirstStep || steps.length === 0) return false;
        clearError();
        return goTo(steps[currentIndex - 1].id);
      },
      complete: async () => {
        clearError();
        setStatus(currentId, "completed");
        if (onComplete) {
          try {
            setIsLoading(true);
            await Promise.resolve(onComplete());
            reset();
          } catch (error22) {
            setErrorState(
              typeof error22 === "string" ? error22 : {
                title: "Error",
                message: error22 instanceof Error ? error22.message : String(error22)
              }
            );
            setIsLoading(false);
            return false;
          }
        } else {
          reset();
        }
        setIsLoading(false);
        return true;
      },
      goTo,
      // UI state for navigation components
      isFirstStep,
      isLastStep,
      isLoading: isLoading2,
      hasError,
      setLoading: setIsLoading
    }),
    [
      isLastStep,
      isFirstStep,
      clearError,
      setStatus,
      currentId,
      currentIndex,
      goTo,
      steps,
      onComplete,
      setErrorState,
      isLoading2,
      hasError,
      setIsLoading,
      reset
    ]
  );
  return {
    // Core state
    steps,
    currentStep,
    currentId,
    currentIndex,
    stepStates,
    // Error handling
    error: error2,
    setError: setErrorState,
    clearError,
    // Status handling
    setStatus,
    setLoading: setIsLoading,
    // Navigation with UI state
    navigation,
    // Custom props
    stepProps,
    // Reset functionality
    reset
  };
}
const DropdownCombobox = (props) => {
  const {
    trigger,
    onEscapeKeyDown,
    closeOnSelect,
    onOpenChange,
    defaultOpen,
    open,
    onSelect,
    ...cmdProps
  } = props;
  const [openState, setOpenState] = useControllableState(open, onOpenChange, defaultOpen ?? false);
  const handleEscapeKeyDown = (event) => {
    onOpenChange == null ? void 0 : onOpenChange(false);
    onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(event);
  };
  const handleSelect = (params) => {
    if (closeOnSelect) {
      console.warn('TODO: Implement this, like identical/shared across all "dropdown" components');
      setOpenState(false);
    }
    onSelect == null ? void 0 : onSelect(params);
  };
  return /* @__PURE__ */ React__default.createElement(
    Dropdown,
    {
      variant: "dropdown",
      trigger,
      onEscapeKeyDown: handleEscapeKeyDown,
      onOpenChange: setOpenState,
      open: openState
    },
    /* @__PURE__ */ React__default.createElement(Combobox$1, { onSelect: handleSelect, ...cmdProps })
  );
};
DropdownCombobox.displayName = "DropdownCombobox";
const SliderRoot = "_SliderRoot_11da2_5";
const SliderTrack = "_SliderTrack_11da2_15";
const SliderRange = "_SliderRange_11da2_24";
const SliderRangeDisabled = "_SliderRangeDisabled_11da2_31";
const SliderThumb = "_SliderThumb_11da2_38";
const active = "_active_11da2_47";
const styles$1 = {
  SliderRoot,
  SliderTrack,
  SliderRange,
  SliderRangeDisabled,
  SliderThumb,
  active
};
const Slider = React__default.forwardRef((props, forwardedRef) => {
  const { disabledWidth = 0, isActive: isActive2 = false, className, ...rest } = props;
  return /* @__PURE__ */ React__default.createElement(
    SliderPrimitive.Root,
    {
      className: classNames(styles$1.SliderRoot, className),
      defaultValue: [50],
      max: 100,
      min: 0,
      step: 1,
      ...rest,
      ref: forwardedRef
    },
    /* @__PURE__ */ React__default.createElement(SliderPrimitive.Track, { className: styles$1.SliderTrack }, /* @__PURE__ */ React__default.createElement(SliderPrimitive.Range, { className: styles$1.SliderRange }), /* @__PURE__ */ React__default.createElement(
      SliderPrimitive.Range,
      {
        className: styles$1.SliderRangeDisabled,
        style: { width: disabledWidth }
      }
    )),
    /* @__PURE__ */ React__default.createElement(
      SliderPrimitive.Thumb,
      {
        className: classNames(styles$1.SliderThumb, {
          [styles$1.active]: isActive2
        }),
        "aria-label": "Slider"
      }
    )
  );
});
const HoverOverContent = "_HoverOverContent_1btnd_90";
const PopoverArrow = "_PopoverArrow_1btnd_114";
const styles = {
  HoverOverContent,
  PopoverArrow
};
const HoverOver = (props) => {
  const { trigger, children, ...rest } = props;
  const handleEscapeKeyDown = (event) => {
    var _a, _b;
    (_a = props.onOpenChange) == null ? void 0 : _a.call(props, false);
    (_b = props == null ? void 0 : props.onEscapeKeyDown) == null ? void 0 : _b.call(props, event);
  };
  return /* @__PURE__ */ React__default.createElement(HoverOverPrimitive.Root, { ...rest }, /* @__PURE__ */ React__default.createElement(HoverOverPrimitive.Trigger, { asChild: true }, trigger), /* @__PURE__ */ React__default.createElement(HoverOverPrimitive.Portal, null, /* @__PURE__ */ React__default.createElement(
    HoverOverPrimitive.Content,
    {
      arrowPadding: 4 * 4,
      collisionPadding: 4 * 4,
      onEscapeKeyDown: handleEscapeKeyDown,
      className: styles.HoverOverContent
    },
    children,
    /* @__PURE__ */ React__default.createElement(HoverOverPrimitive.Arrow, { className: styles.PopoverArrow })
  )));
};
const Tooltip = React__default.forwardRef((props, forwardedRef) => {
  const {
    /** Content props */
    side,
    align,
    // Root props
    tooltip,
    children,
    delayDuration = 250,
    disableHoverableContent = true,
    ...rest
  } = props;
  return /* @__PURE__ */ React__default.createElement(TooltipPrimitive.Provider, { disableHoverableContent }, /* @__PURE__ */ React__default.createElement(TooltipPrimitive.Root, { ...rest, delayDuration }, /* @__PURE__ */ React__default.createElement(TooltipPrimitive.Trigger, { ref: forwardedRef, asChild: true }, React__default.isValidElement(children) ? children : /* @__PURE__ */ React__default.createElement("span", null, children)), /* @__PURE__ */ React__default.createElement(TooltipPrimitive.Portal, null, /* @__PURE__ */ React__default.createElement(
    TooltipPrimitive.Content,
    {
      side,
      align,
      sideOffset: 4,
      collisionPadding: 4 * 4,
      className: commonStyles.tooltipContentBase
    },
    tooltip,
    /* @__PURE__ */ React__default.createElement(TooltipPrimitive.Arrow, { "data-arrow": true })
  ))));
});
Tooltip.displayName = "Tooltip";
const mediaQuerySupportsEventTargetMethods = Object.getPrototypeOf(typeof window !== "undefined" && window.matchMedia("")) instanceof EventTarget;
const addMediaQueryListener = mediaQuerySupportsEventTargetMethods ? (mediaQuery, listener, options) => mediaQuery.addEventListener("change", listener, options) : (mediaQuery, listener) => mediaQuery.addListener(listener);
const removeMediaQueryListener = mediaQuerySupportsEventTargetMethods ? (mediaQuery, listener, options) => mediaQuery.removeEventListener("change", listener, options) : (mediaQuery, listener) => mediaQuery.removeListener(listener);
const ThemeContext = React__default.createContext({
  theme: "timely-light"
});
ThemeContext.displayName = "ThemeContext";
const ThemeProvider = ({ theme, children }) => {
  useThemeBodyClass(theme);
  return /* @__PURE__ */ React__default.createElement(ThemeContext.Provider, { value: { theme } }, children);
};
ThemeProvider.displayName = "ThemeProvider";
const useThemeBodyClass = (theme) => {
  useEffect(() => {
    Array.from(document.documentElement.classList).forEach((cls) => {
      if (cls.startsWith("theme-")) {
        document.documentElement.classList.remove(cls);
      }
    });
    document.documentElement.classList.add(`theme-${theme}`);
  }, [theme]);
};
const useCurrentTheme = () => {
  const { theme } = React__default.useContext(ThemeContext);
  return theme;
};
useCurrentTheme.displayName = "useCurrentTheme";
const AutoThemeProvider = ({ children }) => {
  const darkModeQuery = useMemo(
    () => typeof window !== "undefined" ? window.matchMedia("(prefers-color-scheme: dark)") : null,
    []
  );
  const [, setDarkMode] = useState(() => !!(darkModeQuery == null ? void 0 : darkModeQuery.matches));
  useMountEffect(() => {
    darkModeQuery == null ? void 0 : darkModeQuery.addEventListener("change", () => {
      setDarkMode(darkModeQuery.matches);
    });
  });
  const theme = "timely-light";
  return /* @__PURE__ */ React__default.createElement(ThemeProvider, { theme }, children);
};
AutoThemeProvider.displayName = "AutoThemeProvider";
export {
  AutoThemeProvider,
  Box$1 as Box,
  Button$1 as Button,
  ButtonGroup,
  ButtonRow,
  Card,
  Checkbox$1 as Checkbox,
  Checklist,
  Circle,
  CombinedButton,
  Combobox$1 as Combobox,
  CustomIcon,
  DataTable,
  Dialog,
  Dropdown,
  DropdownCombobox,
  DropdownMenu$1 as DropdownMenu,
  DropdownMenu as DropdownMenuPrimitive,
  Element$1 as Element,
  Elevation,
  FloatingMessage,
  Form,
  Frame$1 as Frame,
  Combobox as HeadlessCombobox,
  HoverOver,
  Icon$3 as Icon,
  Image,
  Info,
  JsonView,
  LinkButton,
  List,
  LoadingIcon,
  Message$1 as Message,
  Modal,
  Pill,
  Popover,
  PopoverConfirm,
  Tooltip as RadixTooltip,
  Settings,
  Skeleton,
  Slider,
  Spinner,
  Switch,
  Table,
  Tabs,
  Text$1 as Text,
  ThemeProvider,
  Timeline,
  Tooltip$1 as Tooltip,
  Wizard,
  addMediaQueryListener,
  createSyntheticEvent,
  removeMediaQueryListener,
  useButtonClassNames,
  useCallbackProxy,
  useChangedRecently,
  useControllableState,
  useCurrentTheme,
  useDebouncedCallback,
  useDebouncedEffect,
  useDeferredChangeEffect,
  useDeferredMount,
  useEffectOnValueChange,
  useHeldKey,
  useInterval,
  useMountEffect,
  usePan,
  usePrevious,
  useRealtime,
  useRefFacade,
  useStateWithLocalStorage,
  useThrottledCallback,
  useThrottledEffect,
  useUnmountEffect,
  useValueRef,
  useWizard,
  useZoom
};
//# sourceMappingURL=index.es.js.map
